import React from "react";

export const GreenLogoSmall = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="90"
      height="20"
      viewBox="0 0 157.51 24.575"
    >
      <g
        id="Nextq_Logo"
        data-name="Nextq Logo"
        transform="translate(-35.53 -55.908)"
      >
        <path
          id="Path_32107"
          data-name="Path 32107"
          d="M35.593,74.028l-.033.01-.03-.016V56.51c.03,0,.059.007.089.007,0,.158-.01.313-.01.471V73.557c0,.158-.01.313-.013.471Z"
          transform="translate(0 -0.404)"
          fill="#a7a4a4"
        />
        <path
          id="Path_32108"
          data-name="Path 32108"
          d="M35.72,74c0-.158.013-.313.013-.471V56.964c0-.158.007-.313.01-.471,1,0,2-.007,3,0a2.035,2.035,0,0,1,1.8.946c1.012,1.549,2.033,3.091,3.048,4.636q2.971,4.523,5.941,9.042c.04.063.086.122.194.28V58.233c0-1.41.316-1.727,1.74-1.743.422-.007.844.013,1.265-.013.274-.016.316.089.316.33-.013,1.117-.007,2.234-.007,3.351q0,7.513.01,15.023c0,.356-.092.432-.432.419-.827-.033-1.658-.04-2.488-.026a1.992,1.992,0,0,1-1.8-.939q-1.364-2.046-2.722-4.1-3.178-4.809-6.35-9.622c-.053-.082-.115-.158-.231-.32v.514q0,7.019.01,14.038c0,.359-.082.481-.451.451-.577-.046-1.163-.007-1.733-.082-.844-.115-1.094-.438-1.124-1.282,0-.079-.01-.158-.013-.234Z"
          transform="translate(-0.127 -0.38)"
          fill="#060505"
        />
        <path
          id="Path_32109"
          data-name="Path 32109"
          d="M237.016,80.478a12.789,12.789,0,0,1-3.272-.293,3.539,3.539,0,0,1-2.966-3.335,6.473,6.473,0,0,1-.079-1.1c.016-.346-.129-.442-.442-.484A8.1,8.1,0,0,1,226.6,73.9a6.893,6.893,0,0,1-2.7-4,16.052,16.052,0,0,1-.056-8.182,7.05,7.05,0,0,1,5.941-5.539,13.744,13.744,0,0,1,6.106.158,6.8,6.8,0,0,1,5.121,4.966,15.723,15.723,0,0,1,.007,8.789,6.935,6.935,0,0,1-5.79,5.1c-.336.066-.676.115-1.015.155-.145.016-.214.059-.211.211a5.625,5.625,0,0,0,.132,1.328c.194.7.768.834,1.374.91.735.092,1.473.053,2.208.079.817.033,1.022.234,1.124,1.054.053.405.033.814.053,1.219.013.25-.056.346-.326.336-.488-.023-.975-.007-1.562-.007Zm1.216-13.662a18.11,18.11,0,0,0-.273-4.155,4.519,4.519,0,0,0-3.832-3.832,17.16,17.16,0,0,0-5.385.036,1.933,1.933,0,0,0-1.7,1.588,7.575,7.575,0,0,0-.148.771,40.153,40.153,0,0,0-.135,5.114,10.884,10.884,0,0,0,.3,2.458,4.51,4.51,0,0,0,3.776,3.753,16.952,16.952,0,0,0,5.305-.01,2.04,2.04,0,0,0,1.908-1.99,22.825,22.825,0,0,0,.181-3.734Z"
          transform="translate(-125.924 0)"
          fill="#67be63"
        />
        <path
          id="Path_32110"
          data-name="Path 32110"
          d="M346.079,81.336a4.9,4.9,0,0,1-1.944,1.532,9.21,9.21,0,0,1-7.325.168,4.16,4.16,0,0,1-2.593-4.389c.2-2.59,1.934-4.106,4.567-4.518A30.042,30.042,0,0,1,343,74q1.008-.015,2.013,0c.247,0,.336-.053.326-.326a2.609,2.609,0,0,0-2.488-2.626A17.017,17.017,0,0,0,340.3,70.9c-1.028-.007-2.053,0-3.081,0a3.6,3.6,0,0,1-.705-.056.808.808,0,0,1-.741-.794,10.71,10.71,0,0,1-.079-1.453c0-.2.063-.283.27-.277a65.726,65.726,0,0,1,7.727.208,7.463,7.463,0,0,1,1.783.494,4.725,4.725,0,0,1,2.936,4.063A11.436,11.436,0,0,1,348.5,74.7c0,2.811-.007,5.625.007,8.436,0,.293-.053.428-.382.4a9.464,9.464,0,0,1-1.3-.086.8.8,0,0,1-.649-.652,14.274,14.274,0,0,1-.1-1.453Zm-3.819-4.847V76.5c-.936,0-1.868,0-2.8,0a6.425,6.425,0,0,0-.708.063c-.807.082-1.12.392-1.183,1.2-.033.419-.056.837-.049,1.259a1.827,1.827,0,0,0,.817,1.575,2.948,2.948,0,0,0,1.16.471,14.04,14.04,0,0,0,4.284.026c1.031-.132,1.338-.527,1.489-1.575.132-.929.023-1.862.092-2.791.016-.241-.122-.241-.3-.241-.936,0-1.868,0-2.8,0Z"
          transform="translate(-200.249 -8.315)"
          fill="#67be63"
        />
        <path
          id="Path_32111"
          data-name="Path 32111"
          d="M101.954,76.668c-1.835,0-3.348.007-4.864-.007-.28,0-.356.066-.323.349a3.538,3.538,0,0,0,3.542,3.381c1.552.1,3.1.016,4.66.049a5.858,5.858,0,0,1,1.1.079.873.873,0,0,1,.728.814,11.3,11.3,0,0,1,.072,1.493c.007.194-.076.217-.231.217-2.317-.036-4.636.119-6.946-.082a6.317,6.317,0,0,1-4.847-2.495,6.86,6.86,0,0,1-1.213-3.239,12.405,12.405,0,0,1,.264-5A6.053,6.053,0,0,1,99.2,67.692a9.834,9.834,0,0,1,4.6.227,5.709,5.709,0,0,1,4.1,4.808,12.052,12.052,0,0,1,.076,2.669,1.1,1.1,0,0,1-1.173,1.2c-1.72.158-3.447.023-4.851.072Zm-1.2-2.593h3.635c.135,0,.283.053.287-.194a3.415,3.415,0,0,0-2.616-3.7,11.11,11.11,0,0,0-3.961,0,1.353,1.353,0,0,0-1.193,1.232,15.2,15.2,0,0,0-.152,2.353c0,.257.066.326.323.323,1.226-.013,2.448-.007,3.674-.007Z"
          transform="translate(-38.866 -7.79)"
          fill="#080707"
        />
        <path
          id="Path_32112"
          data-name="Path 32112"
          d="M447.535,76.654c-1.516,0-3.028.01-4.544-.007-.313,0-.369.092-.333.386a3.5,3.5,0,0,0,3.49,3.351c1.575.132,3.16.026,4.739.056a5.216,5.216,0,0,1,1.061.079.86.86,0,0,1,.712.745,9.645,9.645,0,0,1,.079,1.572c.007.283-.208.185-.336.185-1.885.007-3.767.01-5.651,0a10.208,10.208,0,0,1-2.425-.283,5.8,5.8,0,0,1-4.574-4.449,11.576,11.576,0,0,1,.089-6.225,5.81,5.81,0,0,1,4.557-4.228,9.636,9.636,0,0,1,5.635.2,5.646,5.646,0,0,1,3.737,4.643,10.956,10.956,0,0,1,.079,2.709,1.1,1.1,0,0,1-1.183,1.193c-.5.04-1,.063-1.5.069-1.213.01-2.422,0-3.635,0Zm-.946-2.58h3.631c.161,0,.346.053.346-.231a3.4,3.4,0,0,0-2.88-3.734,12.923,12.923,0,0,0-3.618.026,1.369,1.369,0,0,0-1.288,1.285,14.666,14.666,0,0,0-.145,2.313c-.007.287.092.349.359.346,1.2-.013,2.4-.007,3.592-.007Z"
          transform="translate(-270.762 -7.782)"
          fill="#67be63"
        />
        <path
          id="Path_32113"
          data-name="Path 32113"
          d="M297.549,81.334a4.761,4.761,0,0,1-3,1.994,10.272,10.272,0,0,1-4.422.138,4.518,4.518,0,0,1-3.951-4.073,15.282,15.282,0,0,1-.227-2.626c-.007-2.735,0-5.467-.01-8.2,0-.316.092-.405.4-.389a12.281,12.281,0,0,1,1.809.1.962.962,0,0,1,.88.873,6.777,6.777,0,0,1,.079,1.414c.007,2.181,0,4.363.007,6.544a7.818,7.818,0,0,0,.086,1.176,2.618,2.618,0,0,0,2.6,2.58,13.591,13.591,0,0,0,3.546-.033,1.4,1.4,0,0,0,1.344-1.4,10.241,10.241,0,0,0,.089-1.453c0-3.127.007-6.258-.007-9.385,0-.326.079-.435.412-.415a12.823,12.823,0,0,1,1.812.092,1,1,0,0,1,.929,1c.04.379.066.761.069,1.14.01,4.2.007,8.413.023,12.618,0,.33-.079.435-.412.409a9.126,9.126,0,0,1-1.338-.089.78.78,0,0,1-.633-.669,10.252,10.252,0,0,1-.082-1.344Z"
          transform="translate(-167.892 -8.224)"
          fill="#67be63"
        />
        <path
          id="Path_32114"
          data-name="Path 32114"
          d="M154.445,68.1c-.811,1.048-1.588,2.05-2.366,3.055-1.064,1.371-2.119,2.745-3.2,4.106-.165.208-.112.313.023.488q2.887,3.623,5.757,7.26c.073.089.135.185.254.343a13.522,13.522,0,0,1-3.4-.227,2.067,2.067,0,0,1-1.068-.774q-1.661-2.155-3.308-4.317c-.112-.145-.221-.29-.346-.451-1.008,1.354-1.994,2.682-2.982,4.007-.086.115-.185.224-.267.343a3,3,0,0,1-2.415,1.361c-.8.026-1.6.007-2.435.007q.816-1.023,1.634-2.043c1.466-1.826,2.926-3.651,4.4-5.467a.336.336,0,0,0,.007-.521q-2.719-3.43-5.414-6.874c-.079-.1-.152-.208-.264-.362a13.521,13.521,0,0,1,3.325.241,3.267,3.267,0,0,1,1.773,1.43c.788,1.1,1.565,2.2,2.346,3.308.089.125.181.25.29.4.83-1.14,1.648-2.264,2.471-3.388.171-.234.359-.455.531-.685a3.056,3.056,0,0,1,2.564-1.226c.672,0,1.341,0,2.086,0Z"
          transform="translate(-69.166 -8.128)"
          fill="#080707"
        />
        <path
          id="Path_32115"
          data-name="Path 32115"
          d="M412.758,67.757c0-1.694-.007-3.075.007-4.455,0-.28-.082-.359-.356-.349-.475.02-.949,0-1.42.01-.227.007-.29-.066-.274-.3.033-.432.046-.867.036-1.3,0-.244.073-.316.316-.31A6.347,6.347,0,0,0,412.129,61c.488-.069.626-.244.629-.741.007-1.13.016-2.261-.007-3.391-.007-.339.1-.412.419-.4.791.023,1.582.03,2.369,0,.372-.016.428.115.422.445-.02,1.025,0,2.05-.013,3.075,0,.28.089.353.359.349,1.134-.013,2.264.007,3.4-.013.323-.007.4.1.386.4a11.331,11.331,0,0,1-.076,1.3.867.867,0,0,1-.83.853,17.024,17.024,0,0,1-2.719.066c-.33,0-.445.056-.445.422.02,2.626.01,5.256.01,7.882a2.578,2.578,0,0,0,.112.853,1.182,1.182,0,0,0,1.137.873c.537.03,1.078.03,1.615.069.629.046.877.31.972.933a10.77,10.77,0,0,1,.059,1.493c0,.148-.026.254-.208.257a12.633,12.633,0,0,1-4.416-.412,3.485,3.485,0,0,1-2.478-3.187c-.161-1.559-.016-3.124-.069-4.373Z"
          transform="translate(-251.549 -0.374)"
          fill="#67be63"
        />
        <path
          id="Path_32116"
          data-name="Path 32116"
          d="M188.846,67.652c0-1.447-.007-2.89.007-4.337,0-.25-.053-.349-.326-.336-.475.023-.949-.01-1.42.013-.27.013-.333-.086-.32-.333.023-.445.033-.893.023-1.338-.007-.227.089-.25.277-.25a6.3,6.3,0,0,0,1.14-.056c.362-.066.563-.227.587-.61.066-1.127.016-2.257.03-3.384.007-.524,0-.524.507-.524.765,0,1.529.02,2.29-.01.346-.013.4.1.4.412-.02,1.038,0,2.076-.013,3.114,0,.257.063.333.326.33,1.16-.013,2.317,0,3.477-.013.28,0,.369.072.343.349a12.559,12.559,0,0,1-.1,1.489.856.856,0,0,1-.732.718,14.273,14.273,0,0,1-2.4.076c-.83.016-.83,0-.83.83V71.2a3.277,3.277,0,0,0,.082.781,1.239,1.239,0,0,0,1.2,1.005c.524.036,1.051-.02,1.575.056.662.1.919.3,1,.952.059.507.036,1.022.056,1.532.007.148-.043.208-.2.214a14.273,14.273,0,0,1-3.961-.26,3.7,3.7,0,0,1-3-3.964c-.01-1.288,0-2.577,0-3.862Z"
          transform="translate(-101.412 -0.388)"
          fill="#040404"
        />
        <path
          id="Path_32117"
          data-name="Path 32117"
          d="M386.293,70.036c1.344-1.806,3.193-2.086,5.154-2.1.257,0,.339.086.326.339-.023.458,0,.919-.03,1.377-.049.735-.313.972-1.041,1-.6.016-1.209.023-1.812.063a1.609,1.609,0,0,0-1.737,1.651,10.063,10.063,0,0,0-.073,1.335c0,3.061-.007,6.123.007,9.181,0,.3-.069.415-.389.4a15.082,15.082,0,0,1-1.809-.089,1.012,1.012,0,0,1-.956-1.022,17.036,17.036,0,0,1-.046-1.967V68.691c0-.672,0-.679.692-.669a6.327,6.327,0,0,1,.9.053c.577.092.764.3.811.886.023.32,0,.643,0,1.068Z"
          transform="translate(-233.559 -8.067)"
          fill="#68be64"
        />
        <path
          id="Path_32118"
          data-name="Path 32118"
          d="M491.955,69.993a5.238,5.238,0,0,1,4.188-2.017c.326-.026.659-.007.985-.016.191,0,.29.049.277.27-.033.537-.03,1.078-.082,1.611-.056.577-.316.794-.91.821-.656.03-1.315.03-1.971.073a1.592,1.592,0,0,0-1.684,1.621,14.111,14.111,0,0,0-.082,1.493q-.01,4.454,0,8.91c0,.531,0,.537-.55.527a9.7,9.7,0,0,1-1.575-.072c-.685-.122-.933-.366-1.018-1.048a5.647,5.647,0,0,1-.03-.669q0-6.525-.01-13.049c0-.323.076-.442.409-.412a11.574,11.574,0,0,1,1.219.059.8.8,0,0,1,.765.85c.03.323.043.646.069,1.051Z"
          transform="translate(-304.367 -8.08)"
          fill="#66be62"
        />
        <path
          id="Path_32120"
          data-name="Path 32120"
          d="M349,93.13h2.8c.171,0,.313,0,.3.241-.069.929.04,1.865-.092,2.791-.152,1.048-.458,1.443-1.489,1.575a13.938,13.938,0,0,1-4.284-.026,2.948,2.948,0,0,1-1.16-.471,1.835,1.835,0,0,1-.817-1.575c-.007-.419.016-.84.049-1.259.063-.8.376-1.114,1.183-1.2.234-.023.471-.059.708-.063.936-.007,1.868,0,2.8,0v-.013Z"
          transform="translate(-206.992 -24.956)"
          fill="#fefefe"
        />
        <path
          id="Path_32121"
          data-name="Path 32121"
          d="M107.386,79.1c-1.226,0-2.448-.007-3.674.007-.257,0-.33-.066-.323-.323a14.8,14.8,0,0,1,.152-2.353,1.353,1.353,0,0,1,1.193-1.232,11.264,11.264,0,0,1,3.961,0,3.415,3.415,0,0,1,2.616,3.7c0,.244-.155.191-.287.194H107.39Z"
          transform="translate(-45.497 -12.817)"
          fill="#fefefe"
        />
        <path
          id="Path_32122"
          data-name="Path 32122"
          d="M453.23,79.115c-1.2,0-2.4-.007-3.592.007-.267,0-.366-.059-.359-.346a14.662,14.662,0,0,1,.145-2.313,1.369,1.369,0,0,1,1.288-1.285,12.679,12.679,0,0,1,3.618-.026,3.4,3.4,0,0,1,2.88,3.734c0,.283-.185.231-.346.231h-3.631Z"
          transform="translate(-277.406 -12.823)"
          fill="#fefefe"
        />
      </g>
    </svg>
  );
};

export const GreenLogoLarge = () => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="334"
      height="30"
    >
      <path
        d="M0 0 C110.22 0 220.44 0 334 0 C334 9.9 334 19.8 334 30 C223.78 30 113.56 30 0 30 C0 20.1 0 10.2 0 0 Z "
        fill="#FAFAFC"
        transform="translate(0,0)"
      />
      <path
        d="M0 0 C39.6 0 79.2 0 120 0 C120 9.9 120 19.8 120 30 C84.03 30 48.06 30 11 30 C11 29.67 11 29.34 11 29 C12.65 29 14.3 29 16 29 C16 28.34 16 27.68 16 27 C15.34 26.814375 14.68 26.62875 14 26.4375 C10.39561773 24.71040016 7.88172512 22.42489836 4.9375 19.75390625 C2.70368139 17.73175997 0.37393069 15.85463335 -2 14 C-1.125 10.125 -1.125 10.125 0 9 C0 6.03 0 3.06 0 0 Z "
        fill="#FAFBFC"
        transform="translate(214,0)"
      />
      <path
        d="M0 0 C39.27 0 78.54 0 119 0 C119 0.33 119 0.66 119 1 C116.36 1 113.72 1 111 1 C111.05800781 1.83917969 111.11601563 2.67835938 111.17578125 3.54296875 C110.97173688 7.55584137 109.79638008 10.69537245 108.1875 14.3125 C107.92646484 14.94478516 107.66542969 15.57707031 107.39648438 16.22851562 C106.60546875 18.05078125 106.60546875 18.05078125 105 21 C103.515 21.495 103.515 21.495 102 22 C101.01 22.99 100.02 23.98 99 25 C96.03 25 93.06 25 90 25 C90 17.41 90 9.82 90 2 C88.02 1.67 86.04 1.34 84 1 C84.495 1.99 84.495 1.99 85 3 C85.08449628 4.7404417 85.10723024 6.48409722 85.09765625 8.2265625 C85.09282227 9.7734375 85.09282227 9.7734375 85.08789062 11.3515625 C85.07532227 12.97191406 85.07532227 12.97191406 85.0625 14.625 C85.05798828 15.71296875 85.05347656 16.8009375 85.04882812 17.921875 C85.03701776 20.61463789 85.02054778 23.30729188 85 26 C84.505 25.01 84.505 25.01 84 24 C82.68 24.66 81.36 25.32 80 26 C78.63053378 24.26194659 77.27984046 22.50908767 75.9375 20.75 C74.80634766 19.28820313 74.80634766 19.28820313 73.65234375 17.796875 C72 15 72 15 72.03125 12.96875 C73.31205021 10.36583343 74.86183212 8.1000138 76.5625 5.75 C77.20316406 4.85796875 77.84382813 3.9659375 78.50390625 3.046875 C78.99761719 2.37140625 79.49132812 1.6959375 80 1 C78.02 1 76.04 1 74 1 C73.9071875 2.299375 73.9071875 2.299375 73.8125 3.625 C72.76320022 7.98362987 71.06896592 9.77758579 68 13 C67.67 13 67.34 13 67 13 C67 9.37 67 5.74 67 2 C65.02 1.67 63.04 1.34 61 1 C61.495 1.99 61.495 1.99 62 3 C62.09654283 4.80134348 62.1307544 6.60622869 62.1328125 8.41015625 C62.13474609 10.01793945 62.13474609 10.01793945 62.13671875 11.65820312 C62.13285156 12.78162109 62.12898438 13.90503906 62.125 15.0625 C62.13080078 16.75342773 62.13080078 16.75342773 62.13671875 18.47851562 C62.13542969 19.54908203 62.13414063 20.61964844 62.1328125 21.72265625 C62.13168457 22.71015869 62.13055664 23.69766113 62.12939453 24.71508789 C62 27 62 27 61 28 C62.98 28.33 64.96 28.66 67 29 C67 29.33 67 29.66 67 30 C44.89 30 22.78 30 0 30 C0 20.1 0 10.2 0 0 Z "
        fill="#F9FAFB"
        transform="translate(0,0)"
      />
      <path
        d="M0 0 C0.87011719 0.00451172 1.74023438 0.00902344 2.63671875 0.01367188 C4.75784293 0.0253264 6.8789311 0.04325643 9 0.0625 C8.86658203 1.12791016 8.86658203 1.12791016 8.73046875 2.21484375 C9.09966782 6.11551217 10.76001461 7.69798725 13.3125 10.625 C14.11300781 11.55441406 14.91351563 12.48382813 15.73828125 13.44140625 C16.85783203 14.73884766 16.85783203 14.73884766 18 16.0625 C19.01372798 17.38542606 20.01990244 18.71446938 21 20.0625 C21.02690104 17.27076945 21.04679053 14.47929652 21.0625 11.6875 C21.07506836 10.49640625 21.07506836 10.49640625 21.08789062 9.28125 C21.23040151 5.03857778 21.23040151 5.03857778 20 1.0625 C21.98 1.0625 23.96 1.0625 26 1.0625 C25.67 10.3025 25.34 19.5425 25 29.0625 C19.37336054 26.81184421 19.37336054 26.81184421 16.703125 23.4375 C16.13722656 22.73109375 15.57132812 22.0246875 14.98828125 21.296875 C14.41464844 20.55953125 13.84101563 19.8221875 13.25 19.0625 C12.66089844 18.32515625 12.07179688 17.5878125 11.46484375 16.828125 C7.19041149 11.44332298 7.19041149 11.44332298 6 9.0625 C6 15.6625 6 22.2625 6 29.0625 C1.96823055 29.86885389 -1.19028748 30.18893059 -5.23974609 30.19189453 C-6.47808197 30.19504669 -7.71641785 30.19819885 -8.99227905 30.20144653 C-10.3359989 30.19965612 -11.67971842 30.19760501 -13.0234375 30.1953125 C-14.41199765 30.19598685 -15.80055768 30.19695796 -17.18911743 30.19821167 C-20.09581631 30.19968346 -23.0024844 30.19755141 -25.90917969 30.19287109 C-29.62001192 30.18718477 -33.33077163 30.19044913 -37.04160118 30.19644356 C-39.90876808 30.20007227 -42.77591805 30.19889982 -45.64308548 30.19631577 C-47.01051467 30.19565233 -48.37794543 30.19645437 -49.74537277 30.19879532 C-51.6640698 30.20135868 -53.58277226 30.19675379 -55.50146484 30.19189453 C-56.59002777 30.19109894 -57.6785907 30.19030334 -58.80014038 30.18948364 C-62.25443527 30.05240296 -65.58780666 29.60502996 -69 29.0625 C-68.67 28.4025 -68.34 27.7425 -68 27.0625 C-67.91489795 25.1031396 -67.89282344 23.14087206 -67.90234375 21.1796875 C-67.90556641 20.01308594 -67.90878906 18.84648437 -67.91210938 17.64453125 C-67.92048828 16.42121094 -67.92886719 15.19789062 -67.9375 13.9375 C-67.94201172 12.70644531 -67.94652344 11.47539062 -67.95117188 10.20703125 C-67.9629867 7.15880608 -67.97945972 4.11067686 -68 1.0625 C-65.69 1.0625 -63.38 1.0625 -61 1.0625 C-61 4.6925 -61 8.3225 -61 12.0625 C-60.195625 10.99 -59.39125 9.9175 -58.5625 8.8125 C-58.11003906 8.20921875 -57.65757813 7.6059375 -57.19140625 6.984375 C-55.96099003 4.99957244 -55.43887332 3.34262345 -55 1.0625 C-53.02 1.0625 -51.04 1.0625 -49 1.0625 C-50.53903617 4.56030948 -52.69088479 7.32725861 -55.07421875 10.28125 C-56.17113669 12.01361336 -56.17113669 12.01361336 -55.8671875 13.984375 C-54.76122345 16.63470327 -53.24176046 18.58177797 -51.4375 20.8125 C-50.79683594 21.61171875 -50.15617187 22.4109375 -49.49609375 23.234375 C-49.00238281 23.83765625 -48.50867188 24.4409375 -48 25.0625 C-47.01 24.7325 -46.02 24.4025 -45 24.0625 C-45 16.4725 -45 8.8825 -45 1.0625 C-42.69 1.0625 -40.38 1.0625 -38 1.0625 C-38.33 8.9825 -38.66 16.9025 -39 25.0625 C-35.37 24.7325 -31.74 24.4025 -28 24.0625 C-27.34 22.7425 -26.68 21.4225 -26 20.0625 C-25.50757813 19.58425781 -25.01515625 19.10601563 -24.5078125 18.61328125 C-20.32881831 14.31519655 -18.60991177 6.85666183 -18 1.0625 C-11.95180188 0.17347088 -6.10776514 -0.06098383 0 0 Z "
        fill="#F4F5FB"
        transform="translate(129,-0.0625)"
      />
      <path
        d="M0 0 C17.49 0 34.98 0 53 0 C54.14273574 2.28547148 54.23127257 3.76879905 54.3125 6.3125 C54.36857422 7.45138672 54.36857422 7.45138672 54.42578125 8.61328125 C54 11 54 11 50 16 C52.64 19.63 55.28 23.26 58 27 C56.68 27.33 55.36 27.66 54 28 C49.87154382 24.61254877 46.92279951 20.42595354 44 16 C44 15.34 44 14.68 44 14 C44.825 13.566875 45.65 13.13375 46.5 12.6875 C47.325 12.130625 48.15 11.57375 49 11 C49.41780879 8.37305578 49.41780879 8.37305578 49 6 C46.69 5.34 44.38 4.68 42 4 C42.495 15.88 42.495 15.88 43 28 C41.02 28 39.04 28 37 28 C36.67 21.4 36.34 14.8 36 8 C34.68 7.67 33.36 7.34 32 7 C32 14.26 32 21.52 32 29 C21.27406392 30.00949987 10.77336932 30.07750625 0 30 C0 20.1 0 10.2 0 0 Z "
        fill="#F5F7FB"
        transform="translate(0,0)"
      />
      <path
        d="M0 0 C4.95 0 9.9 0 15 0 C15 1.32 15 2.64 15 4 C12.03 3.67 9.06 3.34 6 3 C6 5.64 6 8.28 6 11 C8.31 11 10.62 11 13 11 C12.67 12.32 12.34 13.64 12 15 C9.03 14.505 9.03 14.505 6 14 C6 17.3 6 20.6 6 24 C8.47395833 23.73958333 10.94791667 23.47916667 13.421875 23.21875 C16 23 16 23 20 23 C20.33 23.99 20.66 24.98 21 26 C21.66 26 22.32 26 23 26 C22.86157705 22.04137069 22.71300994 18.08318673 22.5625 14.125 C22.52318359 12.99707031 22.48386719 11.86914062 22.44335938 10.70703125 C22.40146484 9.63066406 22.35957031 8.55429688 22.31640625 7.4453125 C22.27974854 6.45031738 22.24309082 5.45532227 22.20532227 4.43017578 C22.15040468 1.99220499 22.15040468 1.99220499 21 0 C23.64 0 26.28 0 29 0 C28.67 0.66 28.34 1.32 28 2 C27.84777027 3.66565749 27.75082785 5.33656496 27.68359375 7.0078125 C27.64169922 7.99394531 27.59980469 8.98007813 27.55664062 9.99609375 C27.51732422 11.02863281 27.47800781 12.06117187 27.4375 13.125 C27.39431641 14.16527344 27.35113281 15.20554687 27.30664062 16.27734375 C27.2003712 18.85142528 27.09833417 21.42560508 27 24 C28.6045556 23.85851011 30.20863767 23.71164314 31.8125 23.5625 C33.15248047 23.44068359 33.15248047 23.44068359 34.51953125 23.31640625 C37.12743559 23.06510233 37.12743559 23.06510233 40 22 C40 22.99 40 23.98 40 25 C40.99 25 41.98 25 43 25 C43.0289337 21.20834926 43.04677601 17.41672673 43.0625 13.625 C43.07506836 12.00464844 43.07506836 12.00464844 43.08789062 10.3515625 C43.09111328 9.3203125 43.09433594 8.2890625 43.09765625 7.2265625 C43.10289307 6.27346191 43.10812988 5.32036133 43.11352539 4.33837891 C43.15642599 1.97675594 43.15642599 1.97675594 42 0 C44.31 0 46.62 0 49 0 C48.67 7.92 48.34 15.84 48 24 C51.3 23.67 54.6 23.34 58 23 C59.66666667 23 61.33333333 23 63 23 C63 15.41 63 7.82 63 0 C65.31 0 67.62 0 70 0 C69.67 7.92 69.34 15.84 69 24 C70.98 24.495 70.98 24.495 73 25 C73.33 24.34 73.66 23.68 74 23 C74.680625 23.165 75.36125 23.33 76.0625 23.5 C79.43166519 24.07347493 82.58821459 24.13122252 86 24 C87.29633621 22.93354885 87.29633621 22.93354885 87.0625 20.4375 C87.041875 19.633125 87.02125 18.82875 87 18 C86.21753906 17.57847656 85.43507813 17.15695313 84.62890625 16.72265625 C83.11103516 15.90087891 83.11103516 15.90087891 81.5625 15.0625 C80.55316406 14.51722656 79.54382813 13.97195313 78.50390625 13.41015625 C76 12 76 12 75 11 C74.71689894 8.07462235 74.52582915 5.84502508 75 3 C77.39987507 0.351862 79.27220526 0.0439539 82.78125 -0.16796875 C85.52890302 -0.1856727 88.25570175 -0.12976542 91 0 C91 1.65 91 3.3 91 5 C90.01 4.67 89.02 4.34 88 4 C86.60560336 3.93334624 85.20830125 3.91461801 83.8125 3.9375 C82.554375 3.958125 81.29625 3.97875 80 4 C80.16213924 6.42048293 80.16213924 6.42048293 81 9 C82.94742783 10.56882088 82.94742783 10.56882088 85.375 11.625 C92.14977444 14.91308271 92.14977444 14.91308271 93.6875 18.6875 C94.15243137 22.12799215 94.01758422 25.52887466 94 29 C84.25405304 29.02334847 74.50811596 29.04102827 64.76214695 29.05181217 C60.23489443 29.05699239 55.70766129 29.06399974 51.18041992 29.07543945 C46.79725395 29.0864436 42.4141064 29.09231325 38.03092766 29.09487724 C36.3731145 29.09670037 34.71530215 29.10025886 33.05749702 29.10573006 C21.9993818 29.14071547 11.03162658 28.77415982 0 28 C0 27.34 0 26.68 0 26 C0.66 26 1.32 26 2 26 C1.86157705 22.04137069 1.71300994 18.08318673 1.5625 14.125 C1.52318359 12.99707031 1.48386719 11.86914062 1.44335938 10.70703125 C1.40146484 9.63066406 1.35957031 8.55429688 1.31640625 7.4453125 C1.27974854 6.45031738 1.24309082 5.45532227 1.20532227 4.43017578 C1.15040468 1.99220499 1.15040468 1.99220499 0 0 Z "
        fill="#F3F4FA"
        transform="translate(240,1)"
      />
      <path
        d="M0 0 C2.31 0 4.62 0 7 0 C7 3.63 7 7.26 7 11 C7.804375 9.9275 8.60875 8.855 9.4375 7.75 C9.88996094 7.14671875 10.34242187 6.5434375 10.80859375 5.921875 C12.03900997 3.93707244 12.56112668 2.28012345 13 0 C14.98 0 16.96 0 19 0 C17.46096383 3.49780948 15.30911521 6.26475861 12.92578125 9.21875 C11.82886331 10.95111336 11.82886331 10.95111336 12.1328125 12.921875 C13.23877655 15.57220327 14.75823954 17.51927797 16.5625 19.75 C17.20316406 20.54921875 17.84382813 21.3484375 18.50390625 22.171875 C18.99761719 22.77515625 19.49132812 23.3784375 20 24 C20.99 23.67 21.98 23.34 23 23 C23 15.41 23 7.82 23 0 C25.31 0 27.62 0 30 0 C29.67 7.92 29.34 15.84 29 24 C32.63 23.67 36.26 23.34 40 23 C39.67 24.98 39.34 26.96 39 29 C34.42847075 29.02485982 29.85698153 29.04293526 25.28540039 29.05493164 C23.73265904 29.05993684 22.17992234 29.06674301 20.62719727 29.07543945 C18.38556768 29.08767307 16.14400082 29.09326657 13.90234375 29.09765625 C12.87378517 29.10539818 12.87378517 29.10539818 11.82444763 29.11329651 C7.43608179 29.1137986 3.31598155 28.70910669 -1 28 C-0.67 27.34 -0.34 26.68 0 26 C0.08510205 24.0406396 0.10717656 22.07837206 0.09765625 20.1171875 C0.09443359 18.95058594 0.09121094 17.78398437 0.08789062 16.58203125 C0.07951172 15.35871094 0.07113281 14.13539062 0.0625 12.875 C0.05798828 11.64394531 0.05347656 10.41289062 0.04882812 9.14453125 C0.0370133 6.09630608 0.02054028 3.04817686 0 0 Z "
        fill="#E2E5F7"
        transform="translate(61,1)"
      />
      <path
        d="M0 0 C14.58680819 -0.70128886 14.58680819 -0.70128886 20.546875 3.61328125 C23.72552359 6.64666902 24.35800681 9.01386973 24.5 13.25 C24.43027384 18.50735222 23.16294888 21.0673608 19.5078125 24.7578125 C15.95017299 27.68871758 12.25173266 27.11126462 7.875 27.0625 C5.27625 27.041875 2.6775 27.02125 0 27 C0 18.09 0 9.18 0 0 Z "
        fill="#F5F6FC"
        transform="translate(160,1)"
      />
      <path
        d="M0 0 C1.875 1.1875 1.875 1.1875 3 3 C3.66652315 7.22131327 2.36579951 9.54987572 0 13 C0.59039062 13.26039062 1.18078125 13.52078125 1.7890625 13.7890625 C4.13521085 15.07405541 5.56008697 16.42375548 7.375 18.375 C10.36562897 21.47543608 13.37450424 23.70090513 17 26 C17 26.33 17 26.66 17 27 C13.52497909 27.16547719 11.15761066 27.05989205 7.875 25.8125 C6.92625 25.544375 5.9775 25.27625 5 25 C3.65599167 25.98560611 2.32392972 26.98758315 1 28 C-3.98906907 28.63353258 -5.87076758 28.79987296 -10 25.875 C-12 23 -12 23 -12.5625 20 C-12 17 -12 17 -9.9375 14.75 C-7.27315771 10.96835289 -7.9931451 8.44695608 -8.640625 4.01171875 C-8.75921875 3.34785156 -8.8778125 2.68398437 -9 2 C-5.53076119 -0.31282587 -4.07794425 -0.42478586 0 0 Z "
        fill="#2C59E7"
        transform="translate(212,1)"
      />
      <path
        d="M0 0 C2.6484375 -0.41796875 2.6484375 -0.41796875 6 0 C8.2830328 1.92387834 9.90782579 4.25968731 11.625 6.6875 C12.0890625 7.31333984 12.553125 7.93917969 13.03125 8.58398438 C13.93955858 9.80917463 14.84116616 11.03936679 15.73535156 12.27490234 C17.42048792 14.57358449 19.20025363 16.79045223 21 19 C21.02690104 16.20826945 21.04679053 13.41679652 21.0625 10.625 C21.07087891 9.8309375 21.07925781 9.036875 21.08789062 8.21875 C21.23040151 3.97607778 21.23040151 3.97607778 20 0 C21.98 0 23.96 0 26 0 C25.67 9.24 25.34 18.48 25 28 C19.37336054 25.74934421 19.37336054 25.74934421 16.703125 22.375 C15.85427734 21.31539062 15.85427734 21.31539062 14.98828125 20.234375 C14.12783203 19.12835937 14.12783203 19.12835937 13.25 18 C12.66089844 17.26265625 12.07179687 16.5253125 11.46484375 15.765625 C7.19041149 10.38082298 7.19041149 10.38082298 6 8 C6 14.27 6 20.54 6 27 C4.35 27 2.7 27 1 27 C1.00523682 26.25314941 1.01047363 25.50629883 1.01586914 24.73681641 C1.03660401 21.36621943 1.04964899 17.99563586 1.0625 14.625 C1.07087891 13.449375 1.07925781 12.27375 1.08789062 11.0625 C1.09111328 9.94101563 1.09433594 8.81953125 1.09765625 7.6640625 C1.10289307 6.62717285 1.10812988 5.5902832 1.11352539 4.52197266 C1.17140815 2.0040332 1.17140815 2.0040332 0 0 Z "
        fill="#3B63E8"
        transform="translate(129,1)"
      />
      <path
        d="M0 0 C14.58680819 -0.70128886 14.58680819 -0.70128886 20.546875 3.61328125 C23.72552359 6.64666902 24.35800681 9.01386973 24.5 13.25 C24.43027384 18.50735222 23.16294888 21.0673608 19.5078125 24.7578125 C15.95017299 27.68871758 12.25173266 27.11126462 7.875 27.0625 C5.27625 27.041875 2.6775 27.02125 0 27 C0 18.09 0 9.18 0 0 Z M5 3 C4.97112186 6.47914941 4.95324313 9.95826831 4.9375 13.4375 C4.92912109 14.43072266 4.92074219 15.42394531 4.91210938 16.44726562 C4.90888672 17.39150391 4.90566406 18.33574219 4.90234375 19.30859375 C4.89710693 20.18314209 4.89187012 21.05769043 4.88647461 21.95874023 C4.77215191 23.99440206 4.77215191 23.99440206 6 25 C9.92894886 25.45685452 11.75313122 25.13767682 15.25 23.1875 C18.14542239 21.11320337 18.14542239 21.11320337 20 18 C20.34342312 13.74155328 20.43989287 11.06500379 18.8125 7.125 C16.61553867 4.54925224 15.28000911 3.82000228 12 3 C9.66682641 2.9726969 7.33313889 2.96987731 5 3 Z "
        fill="#2254E6"
        transform="translate(160,1)"
      />
      <path
        d="M0 0 C1.98 0 3.96 0 6 0 C6.2266333 0.56920166 6.4532666 1.13840332 6.68676758 1.72485352 C7.7277439 4.33777574 8.77011202 6.95014063 9.8125 9.5625 C10.34713867 10.90538086 10.34713867 10.90538086 10.89257812 12.27539062 C12.86417111 17.21341709 14.87967839 22.12392917 17 27 C14.69 27 12.38 27 10 27 C9.34 24.03 8.68 21.06 8 18 C4.7 18 1.4 18 -2 18 C-2.99 20.97 -3.98 23.94 -5 27 C-6.32 27 -7.64 27 -9 27 C-7.03239902 20.78652322 -4.71998486 14.85705663 -2.0859375 8.89453125 C-0.9706619 5.92180023 -0.41872495 3.14043715 0 0 Z "
        fill="#2A5AE6"
        transform="translate(111,1)"
      />
      <path
        d="M0 0 C13.46528658 -0.37060422 13.46528658 -0.37060422 15.921875 1.33203125 C17.64932243 4.00456768 17.43460846 5.89565383 17 9 C15.68 10.65 14.36 12.3 13 14 C15.64 17.63 18.28 21.26 21 25 C19.68 25.33 18.36 25.66 17 26 C12.87154382 22.61254877 9.92279951 18.42595354 7 14 C7 13.34 7 12.68 7 12 C7.825 11.566875 8.65 11.13375 9.5 10.6875 C10.7375 9.8521875 10.7375 9.8521875 12 9 C12.41780879 6.37305578 12.41780879 6.37305578 12 4 C9.69 3.34 7.38 2.68 5 2 C5.33 9.92 5.66 17.84 6 26 C4.02 26 2.04 26 0 26 C0 17.42 0 8.84 0 0 Z "
        fill="#2554E6"
        transform="translate(37,2)"
      />
      <path
        d="M0 0 C6.27 0 12.54 0 19 0 C19.33 1.65 19.66 3.3 20 5 C19.01 4.34 18.02 3.68 17 3 C13.79620876 2.75753217 13.79620876 2.75753217 10.3125 2.875 C8.229375 2.91625 6.14625 2.9575 4 3 C4 10.59 4 18.18 4 26 C3.67 26 3.34 26 3 26 C2.67 20.06 2.34 14.12 2 8 C0.68 7.67 -0.64 7.34 -2 7 C-2.33 13.93 -2.66 20.86 -3 28 C-4.98 28 -6.96 28 -9 28 C-8.99476318 27.25314941 -8.98952637 26.50629883 -8.98413086 25.73681641 C-8.96339599 22.36621943 -8.95035101 18.99563586 -8.9375 15.625 C-8.92912109 14.449375 -8.92074219 13.27375 -8.91210938 12.0625 C-8.90888672 10.94101563 -8.90566406 9.81953125 -8.90234375 8.6640625 C-8.89710693 7.62717285 -8.89187012 6.5902832 -8.88647461 5.52197266 C-8.82859185 3.0040332 -8.82859185 3.0040332 -10 1 C-2.25 0.875 -2.25 0.875 0 2 C0 1.34 0 0.68 0 0 Z "
        fill="#EBEDFA"
        transform="translate(34,0)"
      />
      <path
        d="M0 0 C0 1.65 0 3.3 0 5 C-0.99 4.67 -1.98 4.34 -3 4 C-4.39439664 3.93334624 -5.79169875 3.91461801 -7.1875 3.9375 C-8.445625 3.958125 -9.70375 3.97875 -11 4 C-10.83786076 6.42048293 -10.83786076 6.42048293 -10 9 C-8.05257217 10.56882088 -8.05257217 10.56882088 -5.625 11.625 C-2.57866188 13.1035159 -0.15930244 14.34656251 2 17 C2.5625 19.875 2.5625 19.875 2 23 C-0.72255054 26.29571907 -2.29833182 27.720346 -6.51953125 28.4140625 C-13.19444472 28.62906703 -13.19444472 28.62906703 -15.80078125 26.59375 C-17 25 -17 25 -17 23 C-16.319375 23.165 -15.63875 23.33 -14.9375 23.5 C-11.56833481 24.07347493 -8.41178541 24.13122252 -5 24 C-3.70366379 22.93354885 -3.70366379 22.93354885 -3.9375 20.4375 C-3.958125 19.633125 -3.97875 18.82875 -4 18 C-4.78246094 17.57847656 -5.56492187 17.15695313 -6.37109375 16.72265625 C-7.38300781 16.17480469 -8.39492188 15.62695312 -9.4375 15.0625 C-10.44683594 14.51722656 -11.45617187 13.97195313 -12.49609375 13.41015625 C-15 12 -15 12 -16 11 C-16.28310106 8.07462235 -16.47417085 5.84502508 -16 3 C-11.97920209 -1.43674252 -5.52740861 -0.26136608 0 0 Z "
        fill="#2D5AE6"
        transform="translate(331,1)"
      />
      <path
        d="M0 0 C4.95 0 9.9 0 15 0 C15 1.32 15 2.64 15 4 C12.03 3.67 9.06 3.34 6 3 C6 5.64 6 8.28 6 11 C8.31 11 10.62 11 13 11 C12.67 12.32 12.34 13.64 12 15 C9.03 14.505 9.03 14.505 6 14 C6 17.3 6 20.6 6 24 C9.96 23.67 13.92 23.34 18 23 C17.67 24.32 17.34 25.64 17 27 C11.72 27 6.44 27 1 27 C1.01740234 24.32777344 1.01740234 24.32777344 1.03515625 21.6015625 C1.04453335 19.27604271 1.05363363 16.95052179 1.0625 14.625 C1.07087891 13.449375 1.07925781 12.27375 1.08789062 11.0625 C1.09111328 9.94101563 1.09433594 8.81953125 1.09765625 7.6640625 C1.10289307 6.62717285 1.10812988 5.5902832 1.11352539 4.52197266 C1.17140815 2.0040332 1.17140815 2.0040332 0 0 Z "
        fill="#2353E7"
        transform="translate(240,1)"
      />
      <path
        d="M0 0 C11.22 0 22.44 0 34 0 C34 0.66 34 1.32 34 2 C31.03 2 28.06 2 25 2 C24.67 3.32 24.34 4.64 24 6 C23.01 5.67 22.02 5.34 21 5 C21 4.01 21 3.02 21 2 C19.02 2 17.04 2 15 2 C14.7525 2.70125 14.505 3.4025 14.25 4.125 C13 7 13 7 10.875 9.6875 C8.59283194 13.71933024 8.73936503 16.303933 9.0546875 20.828125 C9 23 9 23 7 25 C6.97106068 21.37501666 6.95322208 17.75006287 6.9375 14.125 C6.92912109 13.09246094 6.92074219 12.05992188 6.91210938 10.99609375 C6.90888672 10.00996094 6.90566406 9.02382812 6.90234375 8.0078125 C6.89710693 7.09660645 6.89187012 6.18540039 6.88647461 5.24658203 C7 3 7 3 8 1 C6.02 1.33 4.04 1.66 2 2 C2.00523682 2.74685059 2.01047363 3.49370117 2.01586914 4.26318359 C2.03660401 7.63378057 2.04964899 11.00436414 2.0625 14.375 C2.07087891 15.550625 2.07925781 16.72625 2.08789062 17.9375 C2.09111328 19.05898438 2.09433594 20.18046875 2.09765625 21.3359375 C2.10289307 22.37282715 2.10812988 23.4097168 2.11352539 24.47802734 C2 27 2 27 1 29 C3.31 29 5.62 29 8 29 C8 29.33 8 29.66 8 30 C5.36 30 2.72 30 0 30 C0 20.1 0 10.2 0 0 Z "
        fill="#F9FAFB"
        transform="translate(0,0)"
      />
      <path
        d="M0 0 C2.31 0 4.62 0 7 0 C6.67 7.92 6.34 15.84 6 24 C9.63 23.67 13.26 23.34 17 23 C16.67 24.32 16.34 25.64 16 27 C10.72 27 5.44 27 0 27 C0 18.09 0 9.18 0 0 Z "
        fill="#2254E6"
        transform="translate(84,1)"
      />
      <path
        d="M0 0 C2.64 0 5.28 0 8 0 C7.67 0.66 7.34 1.32 7 2 C6.84777027 3.66565749 6.75082785 5.33656496 6.68359375 7.0078125 C6.64169922 7.99394531 6.59980469 8.98007813 6.55664062 9.99609375 C6.51732422 11.02863281 6.47800781 12.06117187 6.4375 13.125 C6.39431641 14.16527344 6.35113281 15.20554687 6.30664062 16.27734375 C6.20037232 18.8513983 6.09966473 21.42568131 6 24 C9.96 23.67 13.92 23.34 18 23 C17.67 24.32 17.34 25.64 17 27 C11.72 27 6.44 27 1 27 C1.01740234 24.32777344 1.01740234 24.32777344 1.03515625 21.6015625 C1.04453335 19.27604271 1.05363363 16.95052179 1.0625 14.625 C1.07087891 13.449375 1.07925781 12.27375 1.08789062 11.0625 C1.09111328 9.94101563 1.09433594 8.81953125 1.09765625 7.6640625 C1.10289307 6.62717285 1.10812988 5.5902832 1.11352539 4.52197266 C1.17140815 2.0040332 1.17140815 2.0040332 0 0 Z "
        fill="#2254E7"
        transform="translate(261,1)"
      />
      <path
        d="M0 0 C0.33 0 0.66 0 1 0 C1.0289337 3.79165074 1.04677601 7.58327327 1.0625 11.375 C1.07087891 12.45523437 1.07925781 13.53546875 1.08789062 14.6484375 C1.09272461 16.1953125 1.09272461 16.1953125 1.09765625 17.7734375 C1.10551147 19.20308838 1.10551147 19.20308838 1.11352539 20.66162109 C1 23 1 23 0 25 C1.32 25.33 2.64 25.66 4 26 C-2.93 26 -9.86 26 -17 26 C-17 25.67 -17 25.34 -17 25 C-12.71 25 -8.42 25 -4 25 C-4.33 24.34 -4.66 23.68 -5 23 C-5.08400529 21.40552536 -5.10727467 19.80759455 -5.09765625 18.2109375 C-5.09443359 17.26992188 -5.09121094 16.32890625 -5.08789062 15.359375 C-5.07951172 14.37453125 -5.07113281 13.3896875 -5.0625 12.375 C-5.05798828 11.38242188 -5.05347656 10.38984375 -5.04882812 9.3671875 C-5.03702145 6.9113984 -5.020554 4.45572896 -5 2 C-3.68 2.33 -2.36 2.66 -1 3 C-0.67 2.01 -0.34 1.02 0 0 Z "
        fill="#FDFEFC"
        transform="translate(36,4)"
      />
      <path
        d="M0 0 C2.31 0 4.62 0 7 0 C6.67 7.92 6.34 15.84 6 24 C9.96 23.67 13.92 23.34 18 23 C17.67 24.32 17.34 25.64 17 27 C11.72 27 6.44 27 1 27 C1.01740234 24.32777344 1.01740234 24.32777344 1.03515625 21.6015625 C1.04453335 19.27604271 1.05363363 16.95052179 1.0625 14.625 C1.07087891 13.449375 1.07925781 12.27375 1.08789062 11.0625 C1.09111328 9.94101563 1.09433594 8.81953125 1.09765625 7.6640625 C1.10289307 6.62717285 1.10812988 5.5902832 1.11352539 4.52197266 C1.17140815 2.0040332 1.17140815 2.0040332 0 0 Z "
        fill="#2B59E7"
        transform="translate(282,1)"
      />
      <path
        d="M0 0 C2.31 0 4.62 0 7 0 C7 8.91 7 17.82 7 27 C5.02 27 3.04 27 1 27 C0.67 18.09 0.34 9.18 0 0 Z "
        fill="#5574EB"
        transform="translate(303,1)"
      />
      <path
        d="M0 0 C2.31 0 4.62 0 7 0 C7 8.91 7 17.82 7 27 C5.02 27 3.04 27 1 27 C0.67 18.09 0.34 9.18 0 0 Z "
        fill="#3F67E8"
        transform="translate(1,1)"
      />
      <path
        d="M0 0 C2.31 0 4.62 0 7 0 C6.38511719 0.90492187 6.38511719 0.90492187 5.7578125 1.828125 C4.94957031 3.02695313 4.94957031 3.02695313 4.125 4.25 C3.59132813 5.03890625 3.05765625 5.8278125 2.5078125 6.640625 C1.18177985 8.71555692 0.05071825 10.77614972 -1 13 C-0.36191406 13.84304688 0.27617187 14.68609375 0.93359375 15.5546875 C1.76831357 16.66139468 2.60294437 17.76816901 3.4375 18.875 C3.85837891 19.43058594 4.27925781 19.98617188 4.71289062 20.55859375 C7.88671875 24.7734375 7.88671875 24.7734375 9 27 C6.01499799 27.18656263 4.68547617 27.1974418 2 26 C-1.23727904 22.67957167 -3.95094465 19.16641254 -6 15 C-5.8317068 11.34098002 -4.69654623 9.19398077 -2.4375 6.375 C-0.20844763 3.61455306 -0.20844763 3.61455306 0 0 Z "
        fill="#3861E7"
        transform="translate(14,1)"
      />
      <path
        d="M0 0 C1.98 0 3.96 0 6 0 C4.46096383 3.49780948 2.30911521 6.26475861 -0.07421875 9.21875 C-1.16163707 10.94187925 -1.16163707 10.94187925 -0.8984375 12.86328125 C0.34461788 15.81959123 2.12933653 18.13381492 4.0625 20.6875 C8 25.91212654 8 25.91212654 8 27 C5.76171875 27.29296875 5.76171875 27.29296875 3 27 C0.83203125 24.98828125 0.83203125 24.98828125 -1.1875 22.3125 C-1.86167969 21.44238281 -2.53585938 20.57226562 -3.23046875 19.67578125 C-4.94426228 17.08428331 -6.2684932 15.02356142 -7 12 C-5.91796875 9.90234375 -5.91796875 9.90234375 -4.1875 7.9375 C-1.90080513 5.29498076 -0.59607963 3.47584097 0 0 Z "
        fill="#315CE8"
        transform="translate(74,1)"
      />
      <path
        d="M0 0 C1.98 0 3.96 0 6 0 C6 0.33 6 0.66 6 1 C4.35 1 2.7 1 1 1 C1 1.99 1 2.98 1 4 C1.99 4 2.98 4 4 4 C4.99 7.63 5.98 11.26 7 15 C4.36 15 1.72 15 -1 15 C-2.32 18.96 -3.64 22.92 -5 27 C-6.32 27 -7.64 27 -9 27 C-7.03239902 20.78652322 -4.71998486 14.85705663 -2.0859375 8.89453125 C-0.9706619 5.92180023 -0.41872495 3.14043715 0 0 Z "
        fill="#4B6DE9"
        transform="translate(111,1)"
      />
      <path
        d="M0 0 C3.09744495 1.36612201 5.07666871 2.9040241 7.375 5.375 C10.36562897 8.47543608 13.37450424 10.70090513 17 13 C17 13.33 17 13.66 17 14 C13.52497909 14.16547719 11.15761066 14.05989205 7.875 12.8125 C6.92625 12.544375 5.9775 12.27625 5 12 C3.65599167 12.98560611 2.32392972 13.98758315 1 15 C-1.74656059 15.50714501 -4.25699247 15.53398712 -7 15 C-9.5 13 -9.5 13 -11 11 C-9.34385343 10.61781233 -7.67542976 10.28604898 -6 10 C-5.67 10.33 -5.34 10.66 -5 11 C-2.04195427 11.33340471 -2.04195427 11.33340471 1 11 C1.66 10.01 2.32 9.02 3 8 C2.505 7.4225 2.01 6.845 1.5 6.25 C0 4 0 4 0 0 Z "
        fill="#325DE7"
        transform="translate(212,14)"
      />
      <path
        d="M0 0 C1.9375 0.3125 1.9375 0.3125 4 1 C4.33 1.99 4.66 2.98 5 4 C10.28 4.33 15.56 4.66 21 5 C21 3.35 21 1.7 21 0 C21.66 0 22.32 0 23 0 C23 0.99 23 1.98 23 3 C26.71279469 4.23759823 30.31306346 4.35608897 34.1875 4.5625 C34.93708984 4.60568359 35.68667969 4.64886719 36.45898438 4.69335938 C38.30578375 4.79922685 40.15286834 4.9000976 42 5 C42 5.33 42 5.66 42 6 C33.08825032 6.90592986 24.26671896 7.15700793 15.3125 7.125 C14.0013623 7.12306641 12.69022461 7.12113281 11.33935547 7.11914062 C1.86054568 7.07698656 -7.5522407 6.77576909 -17 6 C-16.67 5.34 -16.34 4.68 -16 4 C-10.72 4.33 -5.44 4.66 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#E1E7F7"
        transform="translate(257,23)"
      />
      <path
        d="M0 0 C2.31 0 4.62 0 7 0 C6.67 0.66 6.34 1.32 6 2 C5.915085 3.8863912 5.892807 5.77578515 5.90234375 7.6640625 C5.90556641 8.78554687 5.90878906 9.90703125 5.91210938 11.0625 C5.92048828 12.238125 5.92886719 13.41375 5.9375 14.625 C5.94201172 15.80835938 5.94652344 16.99171875 5.95117188 18.2109375 C5.96298533 21.14067507 5.97945742 24.07031272 6 27 C4.02 27 2.04 27 0 27 C0 18.09 0 9.18 0 0 Z "
        fill="#2054E9"
        transform="translate(61,1)"
      />
      <path
        d="M0 0 C2.64 0 5.28 0 8 0 C7.67 0.66 7.34 1.32 7 2 C6.915085 3.8863912 6.892807 5.77578515 6.90234375 7.6640625 C6.90556641 8.78554687 6.90878906 9.90703125 6.91210938 11.0625 C6.92048828 12.238125 6.92886719 13.41375 6.9375 14.625 C6.94201172 15.80835938 6.94652344 16.99171875 6.95117188 18.2109375 C6.96298533 21.14067507 6.97945742 24.07031272 7 27 C5.02 27 3.04 27 1 27 C1.00523682 26.25314941 1.01047363 25.50629883 1.01586914 24.73681641 C1.03660401 21.36621943 1.04964899 17.99563586 1.0625 14.625 C1.07087891 13.449375 1.07925781 12.27375 1.08789062 11.0625 C1.09111328 9.94101563 1.09433594 8.81953125 1.09765625 7.6640625 C1.10289307 6.62717285 1.10812988 5.5902832 1.11352539 4.52197266 C1.17140815 2.0040332 1.17140815 2.0040332 0 0 Z "
        fill="#2254E7"
        transform="translate(24,1)"
      />
      <path
        d="M0 0 C5.80205656 5.64524422 5.80205656 5.64524422 8 9 C8 9.66 8 10.32 8 11 C13.28 11 18.56 11 24 11 C24 11.66 24 12.32 24 13 C13.61581773 13.92450589 3.32228113 14.8350722 -7 13 C-6.67 12.34 -6.34 11.68 -6 11 C-4.35 11 -2.7 11 -1 11 C-0.83197949 9.54182203 -0.66562857 8.0834516 -0.5 6.625 C-0.4071875 5.81289063 -0.314375 5.00078125 -0.21875 4.1640625 C0.03352351 2.03087175 0.03352351 2.03087175 0 0 Z "
        fill="#E9EBF9"
        transform="translate(8,16)"
      />
      <path
        d="M0 0 C14.28406551 -0.90278504 14.28406551 -0.90278504 20.64453125 3.61328125 C22 5 22 5 23 8 C21.02 8.99 21.02 8.99 19 10 C18.773125 9.38125 18.54625 8.7625 18.3125 8.125 C16.55257273 5.27559395 15.19537152 4.92310733 12 4 C9.67402489 3.6186926 7.34087842 3.27539746 5 3 C5 3.66 5 4.32 5 5 C4.34 5 3.68 5 3 5 C2.67 5.99 2.34 6.98 2 8 C1.67 8 1.34 8 1 8 C0.67 5.36 0.34 2.72 0 0 Z "
        fill="#2B59E8"
        transform="translate(160,1)"
      />
      <path
        d="M0 0 C0.66 0.33 1.32 0.66 2 1 C2 4.3 2 7.6 2 11 C7.94 10.505 7.94 10.505 14 10 C13.67 11.32 13.34 12.64 13 14 C7.72 14 2.44 14 -3 14 C-2.25 3.375 -2.25 3.375 0 0 Z "
        fill="#2253E5"
        transform="translate(244,14)"
      />
      <path
        d="M0 0 C4.2742558 1.5830577 6.26531794 4.50568404 9 8 C7.10442866 10.52742845 6.19410622 10.97169284 3 11.4375 C0 11 0 11 -1.9375 9.3125 C-3.28233625 6.38550346 -3.03115662 5.01415011 -2 2 C-1.34 1.34 -0.68 0.68 0 0 Z "
        fill="#EEF1F9"
        transform="translate(207,15)"
      />
      <path
        d="M0 0 C0.99 0 1.98 0 3 0 C3.90711462 9.28952569 3.90711462 9.28952569 1.8046875 13.25390625 C-0.88703199 16.493438 -2.77431476 18.24672567 -7 19 C-7 17.68 -7 16.36 -7 15 C-6.195625 14.278125 -5.39125 13.55625 -4.5625 12.8125 C-1.43604022 9.38101976 -1.34864751 7.37796761 -1.140625 2.890625 C-1 1 -1 1 0 0 Z "
        fill="#2757E7"
        transform="translate(181,9)"
      />
      <path
        d="M0 0 C0.09152344 0.72574219 0.18304688 1.45148437 0.27734375 2.19921875 C1.12037703 5.46654231 2.43162457 7.2167063 4.5625 9.8125 C5.20316406 10.60269531 5.84382813 11.39289062 6.50390625 12.20703125 C6.99761719 12.79871094 7.49132813 13.39039063 8 14 C6.15234375 14.625 6.15234375 14.625 4 15 C-0.12845618 11.61254877 -3.07720049 7.42595354 -6 3 C-6 2.34 -6 1.68 -6 1 C-4 0 -4 0 0 0 Z "
        fill="#315BE7"
        transform="translate(50,13)"
      />
      <path
        d="M0 0 C2.31 0 4.62 0 7 0 C6.67 7.92 6.34 15.84 6 24 C5.67 24 5.34 24 5 24 C5 18.06 5 12.12 5 6 C4.01 6.495 4.01 6.495 3 7 C2.68758545 9.71446979 2.48663408 12.33909361 2.375 15.0625 C2.33632812 15.82111328 2.29765625 16.57972656 2.2578125 17.36132812 C2.16326438 19.24047195 2.08053244 21.12020336 2 23 C1.67 23 1.34 23 1 23 C0.67 15.41 0.34 7.82 0 0 Z "
        fill="#6C82EB"
        transform="translate(84,1)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C7 2 7 2 7.375 4.4375 C7 7 7 7 5.1875 8.8125 C3 10 3 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#F6F7FA"
        transform="translate(43,4)"
      />
      <path
        d="M0 0 C1.9375 0.3125 1.9375 0.3125 4 1 C4.33 1.99 4.66 2.98 5 4 C10.28 4.33 15.56 4.66 21 5 C21 5.33 21 5.66 21 6 C8.22638801 6.82950418 -4.23939491 7.08707645 -17 6 C-16.67 5.34 -16.34 4.68 -16 4 C-10.72 4.33 -5.44 4.66 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#D0D5F4"
        transform="translate(257,23)"
      />
      <path
        d="M0 0 C4.95 0 9.9 0 15 0 C15 0.33 15 0.66 15 1 C14.21753906 1.13277344 13.43507813 1.26554688 12.62890625 1.40234375 C11.11103516 1.66724609 11.11103516 1.66724609 9.5625 1.9375 C8.55316406 2.11152344 7.54382813 2.28554688 6.50390625 2.46484375 C4.0712562 2.74751097 4.0712562 2.74751097 3 4 C2.71898054 6.31952569 2.55217375 8.63885514 2.37890625 10.96875 C2.25386719 11.6390625 2.12882812 12.309375 2 13 C1.01 13.495 1.01 13.495 0 14 C0.04125 13.236875 0.0825 12.47375 0.125 11.6875 C0.22080824 8.77281584 0.22080824 8.77281584 -2 6 C-1.34 4.02 -0.68 2.04 0 0 Z "
        fill="#ECEFFB"
        transform="translate(313,0)"
      />
      <path
        d="M0 0 C2.31 0 4.62 0 7 0 C4.33333333 4 1.66666667 8 -1 12 C-1.99 11.67 -2.98 11.34 -4 11 C-2.96544058 8.41360145 -1.92974164 5.82825735 -0.875 3.25 C0.06040771 1.24702439 0.06040771 1.24702439 0 0 Z "
        fill="#3E65E9"
        transform="translate(14,1)"
      />
      <path
        d="M0 0 C2.49361571 1.20381448 4.68143083 2.45428722 7 4 C5.84826645 6.46800047 4.95216435 8.04783565 3 10 C0.27573689 7.64722731 -0.8141763 5.37503669 -2 2 C-1.34 1.34 -0.68 0.68 0 0 Z "
        fill="#3E66E8"
        transform="translate(208,3)"
      />
      <path
        d="M0 0 C0.33 0 0.66 0 1 0 C1 5.94 1 11.88 1 18 C-0.65 16.35 -2.3 14.7 -4 13 C-4 10.37886292 -3.68707555 8.49064888 -3 6 C-2.34 6 -1.68 6 -1 6 C-0.67 4.02 -0.34 2.04 0 0 Z "
        fill="#E0E4F8"
        transform="translate(150,3)"
      />
      <path
        d="M0 0 C0.66 0 1.32 0 2 0 C2 7.26 2 14.52 2 22 C1.01 21.67 0.02 21.34 -1 21 C-0.67 14.07 -0.34 7.14 0 0 Z "
        fill="#2154E5"
        transform="translate(151,5)"
      />
      <path
        d="M0 0 C0.33 0.99 0.66 1.98 1 3 C1.66 3 2.32 3 3 3 C2.34 6.63 1.68 10.26 1 14 C1.99 14.33 2.98 14.66 4 15 C4.33 16.65 4.66 18.3 5 20 C3.02 20 1.04 20 -1 20 C-0.67 13.4 -0.34 6.8 0 0 Z "
        fill="#2455E4"
        transform="translate(62,8)"
      />
      <path
        d="M0 0 C1.32 0.66 2.64 1.32 4 2 C4.609375 4.6015625 4.609375 4.6015625 4.75 7.625 C4.80671875 8.62789062 4.8634375 9.63078125 4.921875 10.6640625 C4.94765625 11.43492188 4.9734375 12.20578125 5 13 C3.02 13 1.04 13 -1 13 C-0.67 8.71 -0.34 4.42 0 0 Z "
        fill="#2454E7"
        transform="translate(3,15)"
      />
      <path
        d="M0 0 C1.98 0 3.96 0 6 0 C5.67 9.24 5.34 18.48 5 28 C4.34 27.67 3.68 27.34 3 27 C3.33 19.41 3.66 11.82 4 4 C3.34 4 2.68 4 2 4 C1.34 2.68 0.68 1.36 0 0 Z "
        fill="#7789EC"
        transform="translate(149,1)"
      />
      <path
        d="M0 0 C0.66 0.33 1.32 0.66 2 1 C2.37890625 3.8359375 2.37890625 3.8359375 2.5625 7.375 C2.82302499 12.27255474 2.82302499 12.27255474 4 17 C2.35 17 0.7 17 -1 17 C-0.67 11.39 -0.34 5.78 0 0 Z "
        fill="#2557E7"
        transform="translate(131,11)"
      />
      <path
        d="M0 0 C0.66 0 1.32 0 2 0 C3.49821059 3.37097383 4 5.20442119 4 9 C2.02 9 0.04 9 -2 9 C-1.51421457 5.87709365 -1.0013988 3.00419641 0 0 Z "
        fill="#E8EBF8"
        transform="translate(113,6)"
      />
      <path
        d="M0 0 C0.33 0.66 0.66 1.32 1 2 C-0.61180408 3.95066193 -1.43014778 4.92886446 -3.99291992 5.2487793 C-5.10050659 5.16237183 -5.10050659 5.16237183 -6.23046875 5.07421875 C-7.43413086 4.99204102 -7.43413086 4.99204102 -8.66210938 4.90820312 C-9.49548828 4.83537109 -10.32886719 4.76253906 -11.1875 4.6875 C-12.03248047 4.62626953 -12.87746094 4.56503906 -13.74804688 4.50195312 C-15.83312095 4.34881209 -17.91675276 4.17625843 -20 4 C-19.67 3.34 -19.34 2.68 -19 2 C-17.87980469 2.02320313 -16.75960937 2.04640625 -15.60546875 2.0703125 C-14.13281916 2.08907237 -12.66016237 2.10727234 -11.1875 2.125 C-10.08051758 2.15013672 -10.08051758 2.15013672 -8.95117188 2.17578125 C-5.08753574 2.21074628 -3.29096332 2.19397555 0 0 Z "
        fill="#E1E4F8"
        transform="translate(179,25)"
      />
      <path
        d="M0 0 C-0.33 1.32 -0.66 2.64 -1 4 C-4.3 4 -7.6 4 -11 4 C-11 3.01 -11 2.02 -11 1 C-9.54182203 0.83197949 -8.0834516 0.66562857 -6.625 0.5 C-5.81289062 0.4071875 -5.00078125 0.314375 -4.1640625 0.21875 C-2 0 -2 0 0 0 Z "
        fill="#2F5CE8"
        transform="translate(101,24)"
      />
      <path
        d="M0 0 C4.95 0 9.9 0 15 0 C15 0.33 15 0.66 15 1 C11.04 1 7.08 1 3 1 C3 1.99 3 2.98 3 4 C3.66 4 4.32 4 5 4 C5 5.98 5 7.96 5 10 C4.01 9.67 3.02 9.34 2 9 C1.855625 7.88625 1.71125 6.7725 1.5625 5.625 C1.21627965 2.17857953 1.21627965 2.17857953 0 0 Z "
        fill="#5374E8"
        transform="translate(240,1)"
      />
      <path
        d="M0 0 C0.33 0 0.66 0 1 0 C1.21278058 4.46839215 0.59138085 7.82262526 -1 12 C-2.32 12 -3.64 12 -5 12 C-4.54738642 10.56068883 -4.08767021 9.12361001 -3.625 7.6875 C-3.24214844 6.48673828 -3.24214844 6.48673828 -2.8515625 5.26171875 C-2 3 -2 3 0 0 Z "
        fill="#305AE6"
        transform="translate(107,16)"
      />
      <path
        d="M0 0 C0.99 0 1.98 0 3 0 C3 0.66 3 1.32 3 2 C6.3 1.67 9.6 1.34 13 1 C13 1.66 13 2.32 13 3 C4.75 3 -3.5 3 -12 3 C-12 2.67 -12 2.34 -12 2 C-8.04 2 -4.08 2 0 2 C0 1.34 0 0.68 0 0 Z "
        fill="#FCFDFA"
        transform="translate(299,27)"
      />
      <path
        d="M0 0 C1.2684375 0.495 1.2684375 0.495 2.5625 1 C6.20989216 2.06105954 9.22274664 2.15109013 13 2 C13 2.66 13 3.32 13 4 C9.7 4.33 6.4 4.66 3 5 C3 4.34 3 3.68 3 3 C1.02 3 -0.96 3 -3 3 C-2.01 2.01 -1.02 1.02 0 0 Z "
        fill="#E5E7F9"
        transform="translate(217,25)"
      />
      <path
        d="M0 0 C0.33 0 0.66 0 1 0 C1.04898438 0.67546875 1.09796875 1.3509375 1.1484375 2.046875 C1.22320312 2.93890625 1.29796875 3.8309375 1.375 4.75 C1.44460937 5.63171875 1.51421875 6.5134375 1.5859375 7.421875 C1.99850055 9.99066382 2.71160957 11.75841015 4 14 C3.01 14.33 2.02 14.66 1 15 C1 17.64 1 20.28 1 23 C0.67 23 0.34 23 0 23 C0 15.41 0 7.82 0 0 Z "
        fill="#DDE2F7"
        transform="translate(42,4)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 0.66 10 1.32 10 2 C10.99 2 11.98 2 13 2 C13 3.32 13 4.64 13 6 C12.34 6 11.68 6 11 6 C10.67 5.34 10.34 4.68 10 4 C7.64400765 3.53248212 7.64400765 3.53248212 4.9375 3.375 C4.01839844 3.30023437 3.09929687 3.22546875 2.15234375 3.1484375 C1.44207031 3.09945313 0.73179688 3.05046875 0 3 C0 2.01 0 1.02 0 0 Z "
        fill="#2353E9"
        transform="translate(109,15)"
      />
      <path
        d="M0 0 C0.33 0 0.66 0 1 0 C1.06058594 1.19238281 1.12117188 2.38476562 1.18359375 3.61328125 C1.26801149 5.17969925 1.35265887 6.74610488 1.4375 8.3125 C1.47681641 9.09818359 1.51613281 9.88386719 1.55664062 10.69335938 C1.59853516 11.45068359 1.64042969 12.20800781 1.68359375 12.98828125 C1.72025146 13.68477783 1.75690918 14.38127441 1.79467773 15.09887695 C1.95581153 17.2216572 1.95581153 17.2216572 3 20 C1.02 20 -0.96 20 -3 20 C-2.34 19.67 -1.68 19.34 -1 19 C-0.67 12.73 -0.34 6.46 0 0 Z "
        fill="#2455E2"
        transform="translate(307,8)"
      />
      <path
        d="M0 0 C4.62 0 9.24 0 14 0 C14 0.33 14 0.66 14 1 C10.04 1 6.08 1 2 1 C2 1.66 2 2.32 2 3 C2.99 3 3.98 3 5 3 C5 3.66 5 4.32 5 5 C4.34 5 3.68 5 3 5 C2.67 5.99 2.34 6.98 2 8 C1.67 8 1.34 8 1 8 C0.67 5.36 0.34 2.72 0 0 Z "
        fill="#5876E8"
        transform="translate(160,1)"
      />
      <path
        d="M0 0 C2.31 0 4.62 0 7 0 C6.34 2.31 5.68 4.62 5 7 C3.68 6.67 2.36 6.34 1 6 C0.67 4.02 0.34 2.04 0 0 Z "
        fill="#4064E6"
        transform="translate(61,1)"
      />
      <path
        d="M0 0 C0.66 0 1.32 0 2 0 C2 0.99 2 1.98 2 3 C2.66 3 3.32 3 4 3 C4.33 2.01 4.66 1.02 5 0 C5.99 2.31 6.98 4.62 8 7 C5.69 7 3.38 7 1 7 C0.67 4.69 0.34 2.38 0 0 Z "
        fill="#3B62E9"
        transform="translate(120,21)"
      />
      <path
        d="M0 0 C2.31 0 4.62 0 7 0 C6.67 1.32 6.34 2.64 6 4 C5.38125 4.103125 4.7625 4.20625 4.125 4.3125 C1.63473516 4.87525373 1.63473516 4.87525373 0 8 C0 5.36 0 2.72 0 0 Z "
        fill="#E9EDF8"
        transform="translate(246,4)"
      />
      <path
        d="M0 0 C-0.33 1.32 -0.66 2.64 -1 4 C-5.90567888 4.28301994 -8.24528933 4.16492205 -12 1 C-10.37512529 0.83211627 -8.75009558 0.66573213 -7.125 0.5 C-6.22007812 0.4071875 -5.31515625 0.314375 -4.3828125 0.21875 C-2 0 -2 0 0 0 Z "
        fill="#315DE9"
        transform="translate(258,24)"
      />
      <path
        d="M0 0 C0.66 0.66 1.32 1.32 2 2 C1.01 3.98 0.02 5.96 -1 8 C0.32 8 1.64 8 3 8 C3.33 6.68 3.66 5.36 4 4 C4 5.65 4 7.3 4 9 C2.02 9 0.04 9 -2 9 C-3 7 -3 7 -2.125 3.9375 C-1 1 -1 1 0 0 Z "
        fill="#CAD3F5"
        transform="translate(103,20)"
      />
      <path
        d="M0 0 C1.98 0 3.96 0 6 0 C4.79618552 2.49361571 3.54571278 4.68143083 2 7 C1.34 7 0.68 7 0 7 C0 4.69 0 2.38 0 0 Z "
        fill="#476DE8"
        transform="translate(74,1)"
      />
      <path
        d="M0 0 C0.33 1.65 0.66 3.3 1 5 C0.01 4.34 -0.98 3.68 -2 3 C-4.58885171 2.70008931 -7.09149082 2.49134775 -9.6875 2.375 C-10.7403418 2.31699219 -10.7403418 2.31699219 -11.81445312 2.2578125 C-13.54254655 2.1637666 -15.27123675 2.0808032 -17 2 C-17 1.67 -17 1.34 -17 1 C-15.10440036 0.83069605 -13.20850769 0.66467136 -11.3125 0.5 C-10.25675781 0.4071875 -9.20101562 0.314375 -8.11328125 0.21875 C-5.39363975 0.0276585 -2.72460144 -0.04043935 0 0 Z "
        fill="#BFC8F3"
        transform="translate(53,0)"
      />
      <path
        d="M0 0 C0.66 0 1.32 0 2 0 C3.32 2.31 4.64 4.62 6 7 C5.01 7.33 4.02 7.66 3 8 C2.01 7.34 1.02 6.68 0 6 C-0.1875 2.875 -0.1875 2.875 0 0 Z "
        fill="#F1F4FA"
        transform="translate(67,16)"
      />
      <path
        d="M0 0 C0.66 1.32 1.32 2.64 2 4 C0.35830472 6.02054804 -1.30911778 8.02043058 -3 10 C-3.33 10 -3.66 10 -4 10 C-4 8.02 -4 6.04 -4 4 C-3.01 3.67 -2.02 3.34 -1 3 C-0.67 2.01 -0.34 1.02 0 0 Z "
        fill="#F1F4F9"
        transform="translate(71,3)"
      />
      <path
        d="M0 0 C2.475 0.495 2.475 0.495 5 1 C5 2.32 5 3.64 5 5 C6.98 5 8.96 5 11 5 C11 5.33 11 5.66 11 6 C8.36 6 5.72 6 3 6 C3 5.34 3 4.68 3 4 C2.01 4 1.02 4 0 4 C0 2.68 0 1.36 0 0 Z "
        fill="#D9DDF7"
        transform="translate(299,23)"
      />
      <path
        d="M0 0 C0.99 0.33 1.98 0.66 3 1 C3 1.99 3 2.98 3 4 C6.465 3.505 6.465 3.505 10 3 C10 3.66 10 4.32 10 5 C7.98177083 4.90234375 5.96354167 4.8046875 3.9453125 4.70703125 C3.30335937 4.80371094 2.66140625 4.90039062 2 5 C1.34 5.99 0.68 6.98 0 8 C-0.79953138 4.71303767 -1.09658936 3.28976808 0 0 Z "
        fill="#5D78E8"
        transform="translate(108,11)"
      />
      <path
        d="M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 2.99 0 3.98 0 5 C-1.32 5.33 -2.64 5.66 -4 6 C-4 7.32 -4 8.64 -4 10 C-4.66 9.67 -5.32 9.34 -6 9 C-4.52307692 2.35384615 -4.52307692 2.35384615 -1.875 0.5625 C-0.946875 0.2840625 -0.946875 0.2840625 0 0 Z "
        fill="#E9EAF6"
        transform="translate(59,2)"
      />
      <path
        d="M0 0 C2.64 0 5.28 0 8 0 C7.34 1.65 6.68 3.3 6 5 C4.125 4.75 4.125 4.75 2 4 C0.75 1.9375 0.75 1.9375 0 0 Z "
        fill="#4F6EE9"
        transform="translate(261,1)"
      />
      <path
        d="M0 0 C0.66 1.32 1.32 2.64 2 4 C0.68 4.99 -0.64 5.98 -2 7 C-2.66 6.67 -3.32 6.34 -4 6 C-4 5.01 -4 4.02 -4 3 C-2 1.3125 -2 1.3125 0 0 Z "
        fill="#3A62E6"
        transform="translate(178,21)"
      />
      <path
        d="M0 0 C0.99 0.33 1.98 0.66 3 1 C2.67 2.65 2.34 4.3 2 6 C0.68 5.34 -0.64 4.68 -2 4 C-1.34 2.68 -0.68 1.36 0 0 Z "
        fill="#ECEFF9"
        transform="translate(208,3)"
      />
      <path
        d="M0 0 C0 1.65 0 3.3 0 5 C-4.455 4.01 -4.455 4.01 -9 3 C-5.73209435 0.82139623 -3.91954654 0 0 0 Z "
        fill="#4669E7"
        transform="translate(331,1)"
      />
      <path
        d="M0 0 C4.75 0.75 4.75 0.75 7 3 C7 3.99 7 4.98 7 6 C4.50638429 4.79618552 2.31856917 3.54571278 0 2 C0 1.34 0 0.68 0 0 Z "
        fill="#2957E7"
        transform="translate(208,1)"
      />
      <path
        d="M0 0 C3 2 3 2 3.6875 4.125 C3.790625 4.74375 3.89375 5.3625 4 6 C2.68 6 1.36 6 0 6 C-1.125 2.25 -1.125 2.25 0 0 Z "
        fill="#2C5AE7"
        transform="translate(9,11)"
      />
      <path
        d="M0 0 C2.31 0 4.62 0 7 0 C6.67 0.99 6.34 1.98 6 3 C3.9375 3.6875 3.9375 3.6875 2 4 C1.34 2.68 0.68 1.36 0 0 Z "
        fill="#5674EB"
        transform="translate(303,1)"
      />
      <path
        d="M0 0 C0.33 0 0.66 0 1 0 C1 3.3 1 6.6 1 10 C0.01 10.495 0.01 10.495 -1 11 C-0.95875 10.236875 -0.9175 9.47375 -0.875 8.6875 C-0.77919176 5.77281584 -0.77919176 5.77281584 -3 3 C-2.01 2.67 -1.02 2.34 0 2 C0 1.34 0 0.68 0 0 Z "
        fill="#E4E8F5"
        transform="translate(314,3)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C9 4 9 4 8 6 C7.34 5.67 6.68 5.34 6 5 C6.33 3.68 6.66 2.36 7 1 C4.69 1 2.38 1 0 1 C0 0.67 0 0.34 0 0 Z "
        fill="#F4F4F8"
        transform="translate(248,0)"
      />
      <path
        d="M0 0 C7.42857143 -0.14285714 7.42857143 -0.14285714 11 1 C10.67 1.99 10.34 2.98 10 4 C6.7 3.01 3.4 2.02 0 1 C0 0.67 0 0.34 0 0 Z "
        fill="#F0F2FB"
        transform="translate(170,0)"
      />
      <path
        d="M0 0 C2.97 0.495 2.97 0.495 6 1 C6 1.66 6 2.32 6 3 C6.66 3.33 7.32 3.66 8 4 C5.6875 4.6875 5.6875 4.6875 3 5 C1.1875 3.6875 1.1875 3.6875 0 2 C0 1.34 0 0.68 0 0 Z "
        fill="#E9EEF6"
        transform="translate(309,25)"
      />
      <path
        d="M0 0 C-0.33 1.32 -0.66 2.64 -1 4 C-1.99 4 -2.98 4 -4 4 C-4 3.34 -4 2.68 -4 2 C-5.98 2.33 -7.96 2.66 -10 3 C-10 2.34 -10 1.68 -10 1 C-2.25 0 -2.25 0 0 0 Z "
        fill="#3960E7"
        transform="translate(279,24)"
      />
      <path
        d="M0 0 C1.485 0.99 1.485 0.99 3 2 C2.67 3.32 2.34 4.64 2 6 C1.01 5.67 0.02 5.34 -1 5 C-0.67 3.35 -0.34 1.7 0 0 Z "
        fill="#2654E6"
        transform="translate(15,19)"
      />
      <path
        d="M0 0 C3.36720387 1.39332574 4.9859524 2.9789286 7 6 C4 6 4 6 1.8125 4.125 C0 2 0 2 0 0 Z "
        fill="#3F67EB"
        transform="translate(212,14)"
      />
      <path
        d="M0 0 C2.64 0 5.28 0 8 0 C7.01 1.485 7.01 1.485 6 3 C3.5625 2.625 3.5625 2.625 1 2 C0.67 1.34 0.34 0.68 0 0 Z "
        fill="#5978E9"
        transform="translate(24,1)"
      />
      <path
        d="M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C6.01 2.33 5.02 2.66 4 3 C3.34 3.66 2.68 4.32 2 5 C1.34 3.35 0.68 1.7 0 0 Z "
        fill="#5475E5"
        transform="translate(1,1)"
      />
      <path
        d="M0 0 C2.475 0.495 2.475 0.495 5 1 C4.67 2.32 4.34 3.64 4 5 C3.01 4.67 2.02 4.34 1 4 C0.3125 1.9375 0.3125 1.9375 0 0 Z "
        fill="#2555E5"
        transform="translate(73,21)"
      />
      <path
        d="M0 0 C1.98 0.495 1.98 0.495 4 1 C4 1.99 4 2.98 4 4 C2.35 3.67 0.7 3.34 -1 3 C-0.67 2.01 -0.34 1.02 0 0 Z "
        fill="#EFF1F8"
        transform="translate(45,4)"
      />
    </svg>
  );
};

export const GreenLogoLargeBackup = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="150"
      height="40"
      viewBox="0 0 157.51 24.575"
    >
      <g
        id="Nextq_Logo"
        data-name="Nextq Logo"
        transform="translate(-35.53 -55.908)"
      >
        <path
          id="Path_32107"
          data-name="Path 32107"
          d="M35.593,74.028l-.033.01-.03-.016V56.51c.03,0,.059.007.089.007,0,.158-.01.313-.01.471V73.557c0,.158-.01.313-.013.471Z"
          transform="translate(0 -0.404)"
          fill="#a7a4a4"
        />
        <path
          id="Path_32108"
          data-name="Path 32108"
          d="M35.72,74c0-.158.013-.313.013-.471V56.964c0-.158.007-.313.01-.471,1,0,2-.007,3,0a2.035,2.035,0,0,1,1.8.946c1.012,1.549,2.033,3.091,3.048,4.636q2.971,4.523,5.941,9.042c.04.063.086.122.194.28V58.233c0-1.41.316-1.727,1.74-1.743.422-.007.844.013,1.265-.013.274-.016.316.089.316.33-.013,1.117-.007,2.234-.007,3.351q0,7.513.01,15.023c0,.356-.092.432-.432.419-.827-.033-1.658-.04-2.488-.026a1.992,1.992,0,0,1-1.8-.939q-1.364-2.046-2.722-4.1-3.178-4.809-6.35-9.622c-.053-.082-.115-.158-.231-.32v.514q0,7.019.01,14.038c0,.359-.082.481-.451.451-.577-.046-1.163-.007-1.733-.082-.844-.115-1.094-.438-1.124-1.282,0-.079-.01-.158-.013-.234Z"
          transform="translate(-0.127 -0.38)"
          fill="#060505"
        />
        <path
          id="Path_32109"
          data-name="Path 32109"
          d="M237.016,80.478a12.789,12.789,0,0,1-3.272-.293,3.539,3.539,0,0,1-2.966-3.335,6.473,6.473,0,0,1-.079-1.1c.016-.346-.129-.442-.442-.484A8.1,8.1,0,0,1,226.6,73.9a6.893,6.893,0,0,1-2.7-4,16.052,16.052,0,0,1-.056-8.182,7.05,7.05,0,0,1,5.941-5.539,13.744,13.744,0,0,1,6.106.158,6.8,6.8,0,0,1,5.121,4.966,15.723,15.723,0,0,1,.007,8.789,6.935,6.935,0,0,1-5.79,5.1c-.336.066-.676.115-1.015.155-.145.016-.214.059-.211.211a5.625,5.625,0,0,0,.132,1.328c.194.7.768.834,1.374.91.735.092,1.473.053,2.208.079.817.033,1.022.234,1.124,1.054.053.405.033.814.053,1.219.013.25-.056.346-.326.336-.488-.023-.975-.007-1.562-.007Zm1.216-13.662a18.11,18.11,0,0,0-.273-4.155,4.519,4.519,0,0,0-3.832-3.832,17.16,17.16,0,0,0-5.385.036,1.933,1.933,0,0,0-1.7,1.588,7.575,7.575,0,0,0-.148.771,40.153,40.153,0,0,0-.135,5.114,10.884,10.884,0,0,0,.3,2.458,4.51,4.51,0,0,0,3.776,3.753,16.952,16.952,0,0,0,5.305-.01,2.04,2.04,0,0,0,1.908-1.99,22.825,22.825,0,0,0,.181-3.734Z"
          transform="translate(-125.924 0)"
          fill="#67be63"
        />
        <path
          id="Path_32110"
          data-name="Path 32110"
          d="M346.079,81.336a4.9,4.9,0,0,1-1.944,1.532,9.21,9.21,0,0,1-7.325.168,4.16,4.16,0,0,1-2.593-4.389c.2-2.59,1.934-4.106,4.567-4.518A30.042,30.042,0,0,1,343,74q1.008-.015,2.013,0c.247,0,.336-.053.326-.326a2.609,2.609,0,0,0-2.488-2.626A17.017,17.017,0,0,0,340.3,70.9c-1.028-.007-2.053,0-3.081,0a3.6,3.6,0,0,1-.705-.056.808.808,0,0,1-.741-.794,10.71,10.71,0,0,1-.079-1.453c0-.2.063-.283.27-.277a65.726,65.726,0,0,1,7.727.208,7.463,7.463,0,0,1,1.783.494,4.725,4.725,0,0,1,2.936,4.063A11.436,11.436,0,0,1,348.5,74.7c0,2.811-.007,5.625.007,8.436,0,.293-.053.428-.382.4a9.464,9.464,0,0,1-1.3-.086.8.8,0,0,1-.649-.652,14.274,14.274,0,0,1-.1-1.453Zm-3.819-4.847V76.5c-.936,0-1.868,0-2.8,0a6.425,6.425,0,0,0-.708.063c-.807.082-1.12.392-1.183,1.2-.033.419-.056.837-.049,1.259a1.827,1.827,0,0,0,.817,1.575,2.948,2.948,0,0,0,1.16.471,14.04,14.04,0,0,0,4.284.026c1.031-.132,1.338-.527,1.489-1.575.132-.929.023-1.862.092-2.791.016-.241-.122-.241-.3-.241-.936,0-1.868,0-2.8,0Z"
          transform="translate(-200.249 -8.315)"
          fill="#67be63"
        />
        <path
          id="Path_32111"
          data-name="Path 32111"
          d="M101.954,76.668c-1.835,0-3.348.007-4.864-.007-.28,0-.356.066-.323.349a3.538,3.538,0,0,0,3.542,3.381c1.552.1,3.1.016,4.66.049a5.858,5.858,0,0,1,1.1.079.873.873,0,0,1,.728.814,11.3,11.3,0,0,1,.072,1.493c.007.194-.076.217-.231.217-2.317-.036-4.636.119-6.946-.082a6.317,6.317,0,0,1-4.847-2.495,6.86,6.86,0,0,1-1.213-3.239,12.405,12.405,0,0,1,.264-5A6.053,6.053,0,0,1,99.2,67.692a9.834,9.834,0,0,1,4.6.227,5.709,5.709,0,0,1,4.1,4.808,12.052,12.052,0,0,1,.076,2.669,1.1,1.1,0,0,1-1.173,1.2c-1.72.158-3.447.023-4.851.072Zm-1.2-2.593h3.635c.135,0,.283.053.287-.194a3.415,3.415,0,0,0-2.616-3.7,11.11,11.11,0,0,0-3.961,0,1.353,1.353,0,0,0-1.193,1.232,15.2,15.2,0,0,0-.152,2.353c0,.257.066.326.323.323,1.226-.013,2.448-.007,3.674-.007Z"
          transform="translate(-38.866 -7.79)"
          fill="#080707"
        />
        <path
          id="Path_32112"
          data-name="Path 32112"
          d="M447.535,76.654c-1.516,0-3.028.01-4.544-.007-.313,0-.369.092-.333.386a3.5,3.5,0,0,0,3.49,3.351c1.575.132,3.16.026,4.739.056a5.216,5.216,0,0,1,1.061.079.86.86,0,0,1,.712.745,9.645,9.645,0,0,1,.079,1.572c.007.283-.208.185-.336.185-1.885.007-3.767.01-5.651,0a10.208,10.208,0,0,1-2.425-.283,5.8,5.8,0,0,1-4.574-4.449,11.576,11.576,0,0,1,.089-6.225,5.81,5.81,0,0,1,4.557-4.228,9.636,9.636,0,0,1,5.635.2,5.646,5.646,0,0,1,3.737,4.643,10.956,10.956,0,0,1,.079,2.709,1.1,1.1,0,0,1-1.183,1.193c-.5.04-1,.063-1.5.069-1.213.01-2.422,0-3.635,0Zm-.946-2.58h3.631c.161,0,.346.053.346-.231a3.4,3.4,0,0,0-2.88-3.734,12.923,12.923,0,0,0-3.618.026,1.369,1.369,0,0,0-1.288,1.285,14.666,14.666,0,0,0-.145,2.313c-.007.287.092.349.359.346,1.2-.013,2.4-.007,3.592-.007Z"
          transform="translate(-270.762 -7.782)"
          fill="#67be63"
        />
        <path
          id="Path_32113"
          data-name="Path 32113"
          d="M297.549,81.334a4.761,4.761,0,0,1-3,1.994,10.272,10.272,0,0,1-4.422.138,4.518,4.518,0,0,1-3.951-4.073,15.282,15.282,0,0,1-.227-2.626c-.007-2.735,0-5.467-.01-8.2,0-.316.092-.405.4-.389a12.281,12.281,0,0,1,1.809.1.962.962,0,0,1,.88.873,6.777,6.777,0,0,1,.079,1.414c.007,2.181,0,4.363.007,6.544a7.818,7.818,0,0,0,.086,1.176,2.618,2.618,0,0,0,2.6,2.58,13.591,13.591,0,0,0,3.546-.033,1.4,1.4,0,0,0,1.344-1.4,10.241,10.241,0,0,0,.089-1.453c0-3.127.007-6.258-.007-9.385,0-.326.079-.435.412-.415a12.823,12.823,0,0,1,1.812.092,1,1,0,0,1,.929,1c.04.379.066.761.069,1.14.01,4.2.007,8.413.023,12.618,0,.33-.079.435-.412.409a9.126,9.126,0,0,1-1.338-.089.78.78,0,0,1-.633-.669,10.252,10.252,0,0,1-.082-1.344Z"
          transform="translate(-167.892 -8.224)"
          fill="#67be63"
        />
        <path
          id="Path_32114"
          data-name="Path 32114"
          d="M154.445,68.1c-.811,1.048-1.588,2.05-2.366,3.055-1.064,1.371-2.119,2.745-3.2,4.106-.165.208-.112.313.023.488q2.887,3.623,5.757,7.26c.073.089.135.185.254.343a13.522,13.522,0,0,1-3.4-.227,2.067,2.067,0,0,1-1.068-.774q-1.661-2.155-3.308-4.317c-.112-.145-.221-.29-.346-.451-1.008,1.354-1.994,2.682-2.982,4.007-.086.115-.185.224-.267.343a3,3,0,0,1-2.415,1.361c-.8.026-1.6.007-2.435.007q.816-1.023,1.634-2.043c1.466-1.826,2.926-3.651,4.4-5.467a.336.336,0,0,0,.007-.521q-2.719-3.43-5.414-6.874c-.079-.1-.152-.208-.264-.362a13.521,13.521,0,0,1,3.325.241,3.267,3.267,0,0,1,1.773,1.43c.788,1.1,1.565,2.2,2.346,3.308.089.125.181.25.29.4.83-1.14,1.648-2.264,2.471-3.388.171-.234.359-.455.531-.685a3.056,3.056,0,0,1,2.564-1.226c.672,0,1.341,0,2.086,0Z"
          transform="translate(-69.166 -8.128)"
          fill="#080707"
        />
        <path
          id="Path_32115"
          data-name="Path 32115"
          d="M412.758,67.757c0-1.694-.007-3.075.007-4.455,0-.28-.082-.359-.356-.349-.475.02-.949,0-1.42.01-.227.007-.29-.066-.274-.3.033-.432.046-.867.036-1.3,0-.244.073-.316.316-.31A6.347,6.347,0,0,0,412.129,61c.488-.069.626-.244.629-.741.007-1.13.016-2.261-.007-3.391-.007-.339.1-.412.419-.4.791.023,1.582.03,2.369,0,.372-.016.428.115.422.445-.02,1.025,0,2.05-.013,3.075,0,.28.089.353.359.349,1.134-.013,2.264.007,3.4-.013.323-.007.4.1.386.4a11.331,11.331,0,0,1-.076,1.3.867.867,0,0,1-.83.853,17.024,17.024,0,0,1-2.719.066c-.33,0-.445.056-.445.422.02,2.626.01,5.256.01,7.882a2.578,2.578,0,0,0,.112.853,1.182,1.182,0,0,0,1.137.873c.537.03,1.078.03,1.615.069.629.046.877.31.972.933a10.77,10.77,0,0,1,.059,1.493c0,.148-.026.254-.208.257a12.633,12.633,0,0,1-4.416-.412,3.485,3.485,0,0,1-2.478-3.187c-.161-1.559-.016-3.124-.069-4.373Z"
          transform="translate(-251.549 -0.374)"
          fill="#67be63"
        />
        <path
          id="Path_32116"
          data-name="Path 32116"
          d="M188.846,67.652c0-1.447-.007-2.89.007-4.337,0-.25-.053-.349-.326-.336-.475.023-.949-.01-1.42.013-.27.013-.333-.086-.32-.333.023-.445.033-.893.023-1.338-.007-.227.089-.25.277-.25a6.3,6.3,0,0,0,1.14-.056c.362-.066.563-.227.587-.61.066-1.127.016-2.257.03-3.384.007-.524,0-.524.507-.524.765,0,1.529.02,2.29-.01.346-.013.4.1.4.412-.02,1.038,0,2.076-.013,3.114,0,.257.063.333.326.33,1.16-.013,2.317,0,3.477-.013.28,0,.369.072.343.349a12.559,12.559,0,0,1-.1,1.489.856.856,0,0,1-.732.718,14.273,14.273,0,0,1-2.4.076c-.83.016-.83,0-.83.83V71.2a3.277,3.277,0,0,0,.082.781,1.239,1.239,0,0,0,1.2,1.005c.524.036,1.051-.02,1.575.056.662.1.919.3,1,.952.059.507.036,1.022.056,1.532.007.148-.043.208-.2.214a14.273,14.273,0,0,1-3.961-.26,3.7,3.7,0,0,1-3-3.964c-.01-1.288,0-2.577,0-3.862Z"
          transform="translate(-101.412 -0.388)"
          fill="#040404"
        />
        <path
          id="Path_32117"
          data-name="Path 32117"
          d="M386.293,70.036c1.344-1.806,3.193-2.086,5.154-2.1.257,0,.339.086.326.339-.023.458,0,.919-.03,1.377-.049.735-.313.972-1.041,1-.6.016-1.209.023-1.812.063a1.609,1.609,0,0,0-1.737,1.651,10.063,10.063,0,0,0-.073,1.335c0,3.061-.007,6.123.007,9.181,0,.3-.069.415-.389.4a15.082,15.082,0,0,1-1.809-.089,1.012,1.012,0,0,1-.956-1.022,17.036,17.036,0,0,1-.046-1.967V68.691c0-.672,0-.679.692-.669a6.327,6.327,0,0,1,.9.053c.577.092.764.3.811.886.023.32,0,.643,0,1.068Z"
          transform="translate(-233.559 -8.067)"
          fill="#68be64"
        />
        <path
          id="Path_32118"
          data-name="Path 32118"
          d="M491.955,69.993a5.238,5.238,0,0,1,4.188-2.017c.326-.026.659-.007.985-.016.191,0,.29.049.277.27-.033.537-.03,1.078-.082,1.611-.056.577-.316.794-.91.821-.656.03-1.315.03-1.971.073a1.592,1.592,0,0,0-1.684,1.621,14.111,14.111,0,0,0-.082,1.493q-.01,4.454,0,8.91c0,.531,0,.537-.55.527a9.7,9.7,0,0,1-1.575-.072c-.685-.122-.933-.366-1.018-1.048a5.647,5.647,0,0,1-.03-.669q0-6.525-.01-13.049c0-.323.076-.442.409-.412a11.574,11.574,0,0,1,1.219.059.8.8,0,0,1,.765.85c.03.323.043.646.069,1.051Z"
          transform="translate(-304.367 -8.08)"
          fill="#66be62"
        />
        <path
          id="Path_32120"
          data-name="Path 32120"
          d="M349,93.13h2.8c.171,0,.313,0,.3.241-.069.929.04,1.865-.092,2.791-.152,1.048-.458,1.443-1.489,1.575a13.938,13.938,0,0,1-4.284-.026,2.948,2.948,0,0,1-1.16-.471,1.835,1.835,0,0,1-.817-1.575c-.007-.419.016-.84.049-1.259.063-.8.376-1.114,1.183-1.2.234-.023.471-.059.708-.063.936-.007,1.868,0,2.8,0v-.013Z"
          transform="translate(-206.992 -24.956)"
          fill="#fefefe"
        />
        <path
          id="Path_32121"
          data-name="Path 32121"
          d="M107.386,79.1c-1.226,0-2.448-.007-3.674.007-.257,0-.33-.066-.323-.323a14.8,14.8,0,0,1,.152-2.353,1.353,1.353,0,0,1,1.193-1.232,11.264,11.264,0,0,1,3.961,0,3.415,3.415,0,0,1,2.616,3.7c0,.244-.155.191-.287.194H107.39Z"
          transform="translate(-45.497 -12.817)"
          fill="#fefefe"
        />
        <path
          id="Path_32122"
          data-name="Path 32122"
          d="M453.23,79.115c-1.2,0-2.4-.007-3.592.007-.267,0-.366-.059-.359-.346a14.662,14.662,0,0,1,.145-2.313,1.369,1.369,0,0,1,1.288-1.285,12.679,12.679,0,0,1,3.618-.026,3.4,3.4,0,0,1,2.88,3.734c0,.283-.185.231-.346.231h-3.631Z"
          transform="translate(-277.406 -12.823)"
          fill="#fefefe"
        />
      </g>
    </svg>
  );
};

export function notificationIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.844"
      height="22.041"
      viewBox="0 0 19.844 22.041"
    >
      <path
        id="notif"
        d="M353.023,357.772c0,.958,0,1.917,0,2.875a1.658,1.658,0,0,0,.3.991q.712,1.015,1.426,2.029a1.518,1.518,0,0,1,.137,1.646,1.481,1.481,0,0,1-1.385.861c-1.42.011-2.84.007-4.259,0-.169,0-.247.033-.3.216a3.931,3.931,0,0,1-7.6.009c-.05-.19-.131-.228-.314-.226-1.379.009-2.758,0-4.136.006a1.537,1.537,0,0,1-1.5-.88,1.559,1.559,0,0,1,.209-1.723c.487-.657.945-1.337,1.407-2.012a1.6,1.6,0,0,0,.253-.932c0-1.81-.037-3.621.006-5.431a7.622,7.622,0,0,1,4.7-7.22,7.864,7.864,0,0,1,10.856,5.434,8.219,8.219,0,0,1,.2,1.8c0,.852,0,1.7,0,2.556Zm.439,6.823c-.477-.686-.934-1.352-1.4-2.012a3.315,3.315,0,0,1-.618-1.978c.007-1.777,0-3.555,0-5.332a6.96,6.96,0,0,0-.091-1.149,6.3,6.3,0,0,0-12.517,1.01q-.016,2.715,0,5.43a3.424,3.424,0,0,1-.65,2.068c-.459.643-.9,1.3-1.369,1.964Zm-6.123,1.583h-4.4a2.325,2.325,0,0,0,4.4,0Z"
        transform="translate(-335.223 -347.285)"
        fill="#010101"
      />
    </svg>
  );
}

export const SettingsIcon = (
  colorVal = "#020202",
  width = "30",
  height = "30"
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 22.047 22.053"
    >
      <g id="setting" transform="translate(0)">
        <path
          id="Path_31458"
          data-name="Path 31458"
          d="M330.454,292.44c.1.076.224.06.335.1a2.037,2.037,0,0,1,1.391,1.966c0,.42.007.414.4.568.279.11.555.23.824.362a.2.2,0,0,0,.29-.049,2.172,2.172,0,0,1,1.26-.763,1.909,1.909,0,0,1,1.666.435,14.857,14.857,0,0,1,1.232,1.229,2.009,2.009,0,0,1-.1,2.733c-.108.114-.282.217-.3.345s.114.28.174.425c.1.251.214.5.294.759a.237.237,0,0,0,.29.195,2.09,2.09,0,0,1,1.335.312,1.951,1.951,0,0,1,.934,1.649,10.042,10.042,0,0,1-.031,1.782,2,2,0,0,1-1.939,1.686c-.17,0-.379-.066-.5.032s-.125.294-.188.445c-.105.25-.207.5-.329.745a.2.2,0,0,0,.049.29,2.179,2.179,0,0,1,.759,1.239,1.948,1.948,0,0,1-.471,1.737c-.346.382-.714.746-1.089,1.1a2.014,2.014,0,0,1-2.831-.02c-.114-.108-.217-.282-.346-.3s-.28.116-.424.176c-.251.1-.5.216-.759.294a.235.235,0,0,0-.2.289,2.1,2.1,0,0,1-.36,1.406,1.882,1.882,0,0,1-1.41.846,8.663,8.663,0,0,1-1.995-.019,1.989,1.989,0,0,1-1.664-1.935c0-.17.066-.379-.032-.5s-.294-.125-.445-.188c-.25-.105-.5-.2-.745-.328a.2.2,0,0,0-.29.049,2.182,2.182,0,0,1-1.26.763,1.923,1.923,0,0,1-1.682-.448,15.741,15.741,0,0,1-1.2-1.2,1.962,1.962,0,0,1,.07-2.707c.291-.29.364-.507.138-.856a2.828,2.828,0,0,1-.284-.715.237.237,0,0,0-.289-.2,2.09,2.09,0,0,1-1.458-.4,2.016,2.016,0,0,1-.742-1.076c-.016-.056,0-.132-.078-.164v-2.151c.075-.04.062-.121.082-.185a2.028,2.028,0,0,1,1.028-1.236,2.137,2.137,0,0,1,1.167-.216.237.237,0,0,0,.289-.2,2.839,2.839,0,0,1,.284-.715c.227-.35.152-.566-.138-.856a1.963,1.963,0,0,1-.069-2.707,15.921,15.921,0,0,1,1.2-1.2,1.92,1.92,0,0,1,1.683-.447,2.151,2.151,0,0,1,1.245.749.224.224,0,0,0,.324.053c.24-.125.495-.223.746-.324.443-.178.445-.176.456-.661a2.016,2.016,0,0,1,1.476-1.92c.056-.016.133,0,.164-.078h2.065Zm-1.007,20.738c.222,0,.444,0,.667,0a.732.732,0,0,0,.775-.763c0-.287,0-.574,0-.861a.654.654,0,0,1,.536-.7,8.182,8.182,0,0,0,1.876-.779.639.639,0,0,1,.874.113c.205.2.4.408.61.607a.729.729,0,0,0,1.089,0q.469-.459.928-.928a.729.729,0,0,0,0-1.089c-.2-.212-.417-.414-.621-.625a.628.628,0,0,1-.111-.84,8.186,8.186,0,0,0,.794-1.915.647.647,0,0,1,.675-.516c.294,0,.588,0,.882,0a.731.731,0,0,0,.764-.774q0-.645,0-1.29a.731.731,0,0,0-.774-.785c-.287,0-.574,0-.861,0a.652.652,0,0,1-.689-.526,8.239,8.239,0,0,0-.786-1.9.634.634,0,0,1,.112-.857c.2-.211.419-.413.621-.625a.726.726,0,0,0,0-1.073q-.466-.477-.943-.943a.725.725,0,0,0-1.073,0c-.212.2-.414.417-.625.622a.636.636,0,0,1-.857.111,8.144,8.144,0,0,0-1.9-.786.651.651,0,0,1-.526-.689c0-.294,0-.588,0-.882a.727.727,0,0,0-.763-.752c-.437,0-.875,0-1.312,0a.73.73,0,0,0-.774.763c0,.294,0,.588,0,.882a.646.646,0,0,1-.515.676,8.2,8.2,0,0,0-1.915.794.631.631,0,0,1-.84-.11c-.211-.2-.414-.417-.625-.622a.728.728,0,0,0-1.088,0q-.468.46-.928.928a.727.727,0,0,0,0,1.088c.2.206.407.4.607.61a.64.64,0,0,1,.115.874,8.181,8.181,0,0,0-.779,1.876.652.652,0,0,1-.7.538c-.294,0-.588,0-.882,0a.725.725,0,0,0-.743.75c0,.445,0,.889,0,1.334a.73.73,0,0,0,.773.764c.287,0,.574,0,.861,0a.649.649,0,0,1,.689.525,8.191,8.191,0,0,0,.786,1.9.636.636,0,0,1-.11.857c-.2.211-.418.414-.622.625a.725.725,0,0,0,0,1.073q.466.477.943.943a.726.726,0,0,0,1.073,0c.212-.2.415-.416.625-.622a.635.635,0,0,1,.857-.113,8.3,8.3,0,0,0,1.9.786.651.651,0,0,1,.528.687c0,.3,0,.6,0,.9a.726.726,0,0,0,.739.732c.222,0,.445,0,.667,0Z"
          transform="translate(-318.45 -292.44)"
          fill={colorVal}
        />
        <path
          id="Path_31459"
          data-name="Path 31459"
          d="M462.992,441.76a4.79,4.79,0,1,1,4.795-4.774A4.789,4.789,0,0,1,462.992,441.76Zm.016-8.289a3.5,3.5,0,1,0,3.488,3.5A3.494,3.494,0,0,0,463.008,433.471Z"
          transform="translate(-451.984 -425.956)"
          fill={colorVal}
        />
      </g>
    </svg>
  );
};

export function helpIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="42"
      viewBox="0 0 30.326 30.326"
    >
      <g
        id="Help_04"
        data-name="Help 04"
        transform="translate(-267.19 -286.63)"
      >
        <circle
          id="Ellipse_1999"
          data-name="Ellipse 1999"
          cx="14.163"
          cy="14.163"
          r="14.163"
          transform="translate(268.19 287.63)"
          fill="none"
          stroke="#69d2f9"
          stroke-miterlimit="10"
          stroke-width="2"
        />
        <circle
          id="Ellipse_2000"
          data-name="Ellipse 2000"
          cx="11.658"
          cy="11.658"
          r="11.658"
          transform="translate(270.694 290.135)"
          fill="#69d2f9"
        />
        <g
          id="Group_24382"
          data-name="Group 24382"
          transform="translate(279.418 296.751)"
        >
          <path
            id="Path_32519"
            data-name="Path 32519"
            d="M478.3,455.761c0-.293,0-.587,0-.88a.709.709,0,0,1,.682-.759,1.56,1.56,0,0,0,1.208-.589,1.387,1.387,0,0,0,.151-1.534,1.371,1.371,0,0,0-1.38-.811,1.443,1.443,0,0,0-1.4,1.442.734.734,0,1,1-1.467-.021,2.936,2.936,0,1,1,3.859,2.81.232.232,0,0,0-.195.279c.015.311.007.623,0,.935a.734.734,0,1,1-1.466.008c0-.293,0-.587,0-.88Z"
            transform="translate(-476.1 -449.708)"
            fill="#fff"
          />
          <path
            id="Path_32520"
            data-name="Path 32520"
            d="M520.919,631.166a.913.913,0,1,1,.91-.929A.918.918,0,0,1,520.919,631.166Z"
            transform="translate(-517.979 -621.082)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
}

export function infoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.929"
      height="19.964"
      viewBox="0 0 19.929 19.964"
    >
      <g id="info" transform="translate(-301.157 -353.61)">
        <path
          id="Path_31460"
          data-name="Path 31460"
          d="M311.864,373.574h-1.556c-.02-.063-.075-.037-.114-.041a10.639,10.639,0,0,1-1.113-.171,9.982,9.982,0,0,1-7.7-11.781,9.953,9.953,0,0,1,13.21-7.283,9.669,9.669,0,0,1,6.394,7.9,2.834,2.834,0,0,0,.1.636v1.6c-.054.014-.036.06-.041.095-.054.365-.09.733-.163,1.094a9.992,9.992,0,0,1-8.595,7.888.923.923,0,0,0-.424.068Zm-.759-1.813a8.149,8.149,0,1,0-8.13-8.169A8.171,8.171,0,0,0,311.105,371.761Z"
          fill="#010101"
        />
        <path
          id="Path_31461"
          data-name="Path 31461"
          d="M501.883,543.72c0,.914.011,1.828,0,2.742a.889.889,0,0,1-1.19.824.87.87,0,0,1-.6-.8c-.011-.544-.006-1.089-.007-1.633,0-1.264,0-2.528,0-3.793a.9.9,0,0,1,.726-.943.883.883,0,0,1,1.07.842c.014.92,0,1.841,0,2.762h0Z"
          transform="translate(-189.858 -177.992)"
        />
        <path
          id="Path_31462"
          data-name="Path 31462"
          d="M494.647,447.34a1.205,1.205,0,1,1-1.209,1.19A1.21,1.21,0,0,1,494.647,447.34Z"
          transform="translate(-183.519 -89.459)"
          fill="#020202"
        />
      </g>
    </svg>
  );
}

export function DownArrow() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 6.914 4.196"
    >
      <path
        id="chevron-down"
        d="M8.845,127.579,5.768,124.5a.38.38,0,0,1,0-.537l.359-.359a.38.38,0,0,1,.537,0l2.45,2.439,2.45-2.439a.38.38,0,0,1,.537,0l.359.359a.38.38,0,0,1,0,.537l-3.077,3.077A.38.38,0,0,1,8.845,127.579Z"
        transform="translate(-5.656 -123.495)"
        fill="#838eab"
      />
    </svg>
  );
}

export const EditIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 26 26"
    >
      <g
        id="Group_5979"
        data-name="Group 5979"
        transform="translate(-611 -236)"
      >
        <g
          id="Group_5974"
          data-name="Group 5974"
          transform="translate(618.5 243.5)"
        >
          <g id="Group_5800" data-name="Group 5800" transform="translate(0 0)">
            <g id="Group_223" data-name="Group 223">
              <g id="Group_222" data-name="Group 222">
                <path
                  id="Path_142"
                  data-name="Path 142"
                  d="M3,12.5V15H5.5l7.372-7.372-2.5-2.5ZM14.805,5.692a.664.664,0,0,0,0-.94l-1.56-1.56a.664.664,0,0,0-.94,0l-1.22,1.22,2.5,2.5,1.22-1.22Z"
                  transform="translate(-3 -2.998)"
                  fill="#848484"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export function CalPickerIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 20.579 20.579"
    >
      <g
        id="Group_19953"
        data-name="Group 19953"
        transform="translate(-367.938 -314.891)"
      >
        <path
          id="Path_30858"
          data-name="Path 30858"
          d="M89.292,1.953H87.358v-1A.951.951,0,0,0,86.411,0H84.994a.949.949,0,0,0-.947.951v1H76.521v-1A.951.951,0,0,0,75.575,0H74.158a.951.951,0,0,0-.947.951v1H71.276A1.285,1.285,0,0,0,69.995,3.24V19.292a1.289,1.289,0,0,0,1.282,1.287H89.292a1.289,1.289,0,0,0,1.282-1.287V3.24a1.285,1.285,0,0,0-1.282-1.287ZM85.028.985h1.35V3.906h-1.35Zm-10.836,0h1.35V3.906h-1.35ZM70.975,3.24a.3.3,0,0,1,.3-.3h1.934v1a.951.951,0,0,0,.947.953h1.417a.951.951,0,0,0,.947-.953v-1h7.526v1h0a.951.951,0,0,0,.947.953h1.417a.951.951,0,0,0,.947-.953v-1h1.934a.3.3,0,0,1,.3.3V6.01H70.975ZM89.594,19.292h0a.3.3,0,0,1-.3.3H71.277a.3.3,0,0,1-.3-.3V7H89.594Z"
          transform="translate(297.944 314.891)"
          fill="#0070d2"
        />
        <path
          id="Path_30859"
          data-name="Path 30859"
          d="M256.4,216.69h1.6a.7.7,0,0,0,.692-.7v-1.608a.7.7,0,0,0-.692-.7h-1.6a.7.7,0,0,0-.692.7v1.608a.7.7,0,0,0,.692.7Zm.288-2.018h1.028v1.034h-1.028Z"
          transform="translate(119.052 109.056)"
          fill="#0070d2"
        />
        <path
          id="Path_30860"
          data-name="Path 30860"
          d="M363.7,216.69h1.6a.7.7,0,0,0,.692-.7v-1.608a.7.7,0,0,0-.692-.7h-1.6a.7.7,0,0,0-.692.7v1.608a.7.7,0,0,0,.692.7Zm.288-2.018h1.028v1.034h-1.028Z"
          transform="translate(15.696 109.056)"
          fill="#0070d2"
        />
        <path
          id="Path_30861"
          data-name="Path 30861"
          d="M470.961,216.689h1.6a.7.7,0,0,0,.694-.7v-1.608a.7.7,0,0,0-.694-.7h-1.6a.7.7,0,0,0-.694.7v1.608a.7.7,0,0,0,.694.7Zm.286-2.018h1.029v1.034h-1.029Z"
          transform="translate(-87.619 109.056)"
          fill="#0070d2"
        />
        <path
          id="Path_30862"
          data-name="Path 30862"
          d="M256.4,323.392h1.6a.695.695,0,0,0,.692-.7v-1.6a.695.695,0,0,0-.692-.7h-1.6a.695.695,0,0,0-.692.7v1.6h0a.695.695,0,0,0,.692.7Zm.288-2.02h1.028V322.4H256.69Z"
          transform="translate(119.053 6.275)"
          fill="#0070d2"
        />
        <path
          id="Path_30863"
          data-name="Path 30863"
          d="M149.092,323.392h1.6a.695.695,0,0,0,.692-.7v-1.6a.695.695,0,0,0-.692-.7h-1.6a.695.695,0,0,0-.692.7v1.6h0a.695.695,0,0,0,.692.7Zm.288-2.02h1.028V322.4H149.38Z"
          transform="translate(222.42 6.275)"
          fill="#0070d2"
        />
        <path
          id="Path_30864"
          data-name="Path 30864"
          d="M256.4,430.1h1.6a.692.692,0,0,0,.49-.205.7.7,0,0,0,.2-.493v-1.613a.7.7,0,0,0-.205-.488.692.692,0,0,0-.487-.2h-1.6a.692.692,0,0,0-.49.205.7.7,0,0,0-.2.493v1.613a.7.7,0,0,0,.205.488A.692.692,0,0,0,256.4,430.1Zm.288-2.015h1.028v1.036h-1.028Z"
          transform="translate(119.052 -96.512)"
          fill="#0070d2"
        />
        <path
          id="Path_30865"
          data-name="Path 30865"
          d="M149.092,430.1h1.6a.692.692,0,0,0,.49-.205.7.7,0,0,0,.2-.493v-1.613a.7.7,0,0,0-.205-.488.692.692,0,0,0-.487-.2h-1.6a.692.692,0,0,0-.487.2.7.7,0,0,0-.205.488V429.4a.7.7,0,0,0,.2.493.693.693,0,0,0,.49.205Zm.288-2.015h1.028v1.036h-1.028Z"
          transform="translate(222.42 -96.512)"
          fill="#0070d2"
        />
        <path
          id="Path_30866"
          data-name="Path 30866"
          d="M363.7,323.392h1.6a.695.695,0,0,0,.692-.7v-1.6a.695.695,0,0,0-.692-.7h-1.6a.695.695,0,0,0-.692.7v1.6h0a.695.695,0,0,0,.692.7Zm.288-2.02h1.028V322.4H363.99Z"
          transform="translate(15.697 6.275)"
          fill="#0070d2"
        />
        <path
          id="Path_30867"
          data-name="Path 30867"
          d="M470.961,323.391h1.6a.7.7,0,0,0,.694-.7v-1.6a.7.7,0,0,0-.694-.7h-1.6a.7.7,0,0,0-.694.7v1.6h0a.7.7,0,0,0,.694.7Zm.286-2.02h1.029V322.4h-1.029Z"
          transform="translate(-87.619 6.275)"
          fill="#0070d2"
        />
      </g>
    </svg>
  );
}

export const ProjectManagementIcon = (color = "#09659c") => {
  return (
    <svg
      id="Group_17898"
      data-name="Group 17898"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 23.464 28.656"
    >
      <path
        id="Path_30292"
        data-name="Path 30292"
        d="M428.883,395.36h-4.3a.66.66,0,1,0,0,1.319h4.3a.649.649,0,0,0,.66-.66A.687.687,0,0,0,428.883,395.36Z"
        transform="translate(-408.403 -375.137)"
        fill={color}
      />
      <path
        id="Path_30293"
        data-name="Path 30293"
        d="M183.781,71.32h10.441a.66.66,0,0,0,0-1.319H183.781a.649.649,0,0,0-.66.66.667.667,0,0,0,.66.66Z"
        transform="translate(-179.937 -66.443)"
        fill={color}
      />
      <path
        id="Path_30294"
        data-name="Path 30294"
        d="M166.062,268.9a.649.649,0,0,0-.66-.66h-.66a.66.66,0,1,0,0,1.319h.66A.649.649,0,0,0,166.062,268.9Z"
        transform="translate(-161.874 -254.529)"
        fill={color}
      />
      <path
        id="Path_30295"
        data-name="Path 30295"
        d="M382.121,268.24h-.66a.66.66,0,1,0,0,1.319h.66a.649.649,0,0,0,.66-.66A.667.667,0,0,0,382.121,268.24Z"
        transform="translate(-367.493 -254.528)"
        fill={color}
      />
      <path
        id="Path_30296"
        data-name="Path 30296"
        d="M280.2,154.761v-.66a.66.66,0,1,0-1.319,0v.66a.66.66,0,0,0,1.32,0Z"
        transform="translate(-270.789 -145.611)"
        fill={color}
      />
      <path
        id="Path_30297"
        data-name="Path 30297"
        d="M191.751,180.195l-.66-.66a.649.649,0,0,0-.918.918l.66.66a.677.677,0,0,0,.459.2.571.571,0,0,0,.459-.2A.64.64,0,0,0,191.751,180.195Z"
        transform="translate(-186.445 -170.184)"
        fill={color}
      />
      <path
        id="Path_30298"
        data-name="Path 30298"
        d="M356.85,344.734a.649.649,0,1,0-.918.918l.66.66a.678.678,0,0,0,.459.2.571.571,0,0,0,.459-.2.641.641,0,0,0,0-.918Z"
        transform="translate(-343.713 -326.921)"
        fill={color}
      />
      <path
        id="Path_30299"
        data-name="Path 30299"
        d="M356.85,181.111l.66-.66a.649.649,0,0,0-.918-.918l-.66.66a.641.641,0,0,0,0,.918.677.677,0,0,0,.459.2A.842.842,0,0,0,356.85,181.111Z"
        transform="translate(-343.713 -170.182)"
        fill={color}
      />
      <path
        id="Path_30300"
        data-name="Path 30300"
        d="M191.124,346.311l.66-.66a.649.649,0,0,0-.918-.918l-.688.66a.641.641,0,0,0,0,.918.657.657,0,0,0,.946,0Z"
        transform="translate(-186.448 -326.92)"
        fill={color}
      />
      <path
        id="Path_30301"
        data-name="Path 30301"
        d="M218.581,215.374h1.836l1.692-1.692V211.76a3.859,3.859,0,0,0,1.291-2.9,3.9,3.9,0,1,0-7.8,0,3.963,3.963,0,0,0,1.291,2.9v1.922Zm2.237-2.209-.918.918h-.775l-.918-.918v-.631a3.744,3.744,0,0,0,2.581,0v.631Zm-1.291-6.913a2.61,2.61,0,0,1,.66,5.135v-1.2a.571.571,0,0,0,.459-.2l.66-.66a.649.649,0,1,0-.918-.918l-.229.23a.637.637,0,0,0-1.2,0l-.23-.23a.649.649,0,0,0-.918.918l.66.66a.677.677,0,0,0,.459.2v1.2a2.616,2.616,0,0,1-1.95-2.524,2.518,2.518,0,0,1,2.553-2.61Z"
        transform="translate(-210.751 -194.492)"
        fill={color}
      />
      <path
        id="Path_30302"
        data-name="Path 30302"
        d="M203.773,464.24h-8.232a.66.66,0,1,0,0,1.319h8.232a.66.66,0,0,0,0-1.319Z"
        transform="translate(-191.095 -440.489)"
        fill={color}
      />
      <path
        id="Path_30303"
        data-name="Path 30303"
        d="M461.55,243.934a.641.641,0,0,0-.918,0l-.373.373-.373-.373a.649.649,0,1,0-.918.918l.373.373L459,245.6a.641.641,0,0,0,0,.918.677.677,0,0,0,.459.2.571.571,0,0,0,.459-.2l.373-.373.373.373a.677.677,0,0,0,.459.2.571.571,0,0,0,.459-.2.641.641,0,0,0,0-.918l-.373-.373.373-.373A.669.669,0,0,0,461.55,243.934Z"
        transform="translate(-441.471 -231.284)"
        fill={color}
      />
      <path
        id="Path_30304"
        data-name="Path 30304"
        d="M451.317,172.563a.677.677,0,0,0,.459.2.571.571,0,0,0,.459-.2l1.635-1.635a.649.649,0,1,0-.918-.918l-1.176,1.176-.287-.287a.649.649,0,0,0-.918.918Z"
        transform="translate(-433.505 -161.147)"
        fill={color}
      />
      <path
        id="Path_30305"
        data-name="Path 30305"
        d="M451.317,320.963a.677.677,0,0,0,.459.2.571.571,0,0,0,.459-.2l1.635-1.635a.649.649,0,0,0-.918-.918l-1.176,1.176-.287-.287a.649.649,0,0,0-.918.918Z"
        transform="translate(-433.505 -301.945)"
        fill={color}
      />
      <path
        id="Path_30306"
        data-name="Path 30306"
        d="M453.511,448.331l-1.176,1.176-.287-.287a.649.649,0,0,0-.918.918l.746.746a.678.678,0,0,0,.459.2.571.571,0,0,0,.459-.2l1.635-1.635a.649.649,0,1,0-.918-.918Z"
        transform="translate(-434.034 -425.211)"
        fill={color}
      />
      <path
        id="Path_30307"
        data-name="Path 30307"
        d="M144.426,6.4a.613.613,0,0,0-.258-.516L139,.722a.625.625,0,0,0-.143-.086l-.029-.029c-.057-.029-.086-.029-.143-.057H123.573a2.577,2.577,0,0,0-2.61,2.582V26.594a2.62,2.62,0,0,0,2.61,2.61h18.243a2.62,2.62,0,0,0,2.61-2.61V6.4Zm-5.221-3.643,2.983,2.983h-2.983Zm2.61,25.156H123.573a1.285,1.285,0,0,1-1.291-1.291V3.131a1.285,1.285,0,0,1,1.291-1.291h14.342V6.4a.649.649,0,0,0,.66.66h4.561V26.623a1.329,1.329,0,0,1-1.319,1.291Z"
        transform="translate(-120.963 -0.549)"
        fill={color}
      />
    </svg>
  );
};

export const BIDashboardsIcon = (color = "#09659c") => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 27 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 18.141V0.901759C0.163581 0.239187 0.461875 0.00206186 1.15675 0.00206186C9.11861 0.000687231 17.0798 0.00206195 25.0416 0C25.3612 0 25.6513 0.0646079 25.8912 0.285923C26.1413 0.516174 26.2163 0.810345 26.2156 1.14094C26.2121 3.07642 26.2135 5.01122 26.2135 6.9467C26.2135 10.553 26.1977 14.1587 26.2252 17.765C26.2314 18.6194 25.7166 19.0586 24.9227 19.0531C21.3679 19.0297 17.8138 19.0428 14.259 19.0428C14.1821 19.0428 14.1058 19.0421 14.0288 19.0428C13.7161 19.0476 13.6913 19.0682 13.6893 19.3761C13.6858 20.0242 13.6872 20.6717 13.6893 21.3198C13.6899 21.6772 13.7044 21.691 14.0666 21.691C16.5554 21.6917 19.0448 21.691 21.5336 21.691C21.6614 21.691 21.79 21.6848 21.9164 21.7027C22.2243 21.7453 22.4367 21.9893 22.4395 22.2999C22.4415 22.5886 22.2285 22.8216 21.9185 22.8663C21.8085 22.8821 21.6972 22.8787 21.5865 22.8787C15.9265 22.8787 10.2664 22.8787 4.60639 22.8787C4.47855 22.8787 4.35002 22.8848 4.22424 22.8587C3.94313 22.8003 3.75068 22.5721 3.75137 22.302C3.75205 22.0023 3.9555 21.7563 4.24692 21.7068C4.37339 21.6848 4.50191 21.6924 4.62975 21.6924C7.08485 21.6924 9.53994 21.6924 11.995 21.6924C12.0803 21.6924 12.1655 21.6896 12.2507 21.691C12.4198 21.6944 12.4995 21.6181 12.5002 21.4456C12.5016 20.7212 12.503 19.9967 12.4995 19.2716C12.4988 19.1087 12.4184 19.0421 12.2624 19.0441C12.1689 19.0455 12.0748 19.0428 11.9813 19.0428C8.39281 19.0428 4.80365 19.0428 1.21517 19.0441C0.920315 19.0441 0.641265 19.016 0.391083 18.8318C0.152584 18.6565 0.0508606 18.4173 0.00137388 18.1417L0 18.141Z"
        fill={color}
      />
      <path
        d="M13.1154 1.11896C16.3973 1.11896 19.6792 1.11896 22.9605 1.11896C23.6169 1.11896 24.2732 1.12721 24.9296 1.11896C25.098 1.1169 25.1461 1.16295 25.1461 1.33203C25.142 5.9013 25.142 10.4706 25.1455 15.0405C25.1455 15.1794 25.1159 15.2302 24.9647 15.2302C21.8704 15.2261 18.7761 15.2261 15.6818 15.2302C15.534 15.2302 15.4983 15.1856 15.5004 15.044C15.5079 14.4302 15.5052 13.8164 15.5024 13.2027C15.5004 12.7978 15.3127 12.6095 14.9079 12.6081C14.2343 12.6054 13.5608 12.6047 12.8879 12.6081C12.4995 12.6102 12.3085 12.7958 12.3043 13.1903C12.2968 13.8041 12.2975 14.4178 12.3057 15.0316C12.3078 15.1856 12.2727 15.2364 12.1112 15.2309C11.7112 15.2186 11.3098 15.2137 10.9098 15.2323C10.6974 15.2419 10.6438 15.1842 10.6445 14.9691C10.652 11.9682 10.65 8.96742 10.6493 5.9666C10.6493 5.86419 10.6541 5.7604 10.6362 5.66074C10.5929 5.42431 10.3874 5.2566 10.1173 5.25454C9.41005 5.24835 8.70212 5.24767 7.99487 5.25454C7.66908 5.25798 7.47251 5.45661 7.45602 5.77896C7.44777 5.94873 7.45258 6.11987 7.45258 6.29032C7.45258 9.17155 7.44846 12.0535 7.45945 14.9347C7.46014 15.1911 7.38797 15.2467 7.14947 15.2323C6.79276 15.211 6.43261 15.2082 6.07589 15.233C5.82708 15.2502 5.79134 15.156 5.79203 14.9354C5.80027 13.0514 5.79684 11.1675 5.79684 9.28358C5.79684 8.70692 5.65113 8.5619 5.07172 8.5619C4.4497 8.5619 3.82699 8.55984 3.20497 8.56259C2.7809 8.56465 2.60151 8.74473 2.60151 9.17293C2.60014 11.1084 2.59807 13.0432 2.60495 14.9787C2.60563 15.1746 2.56371 15.2426 2.35682 15.2323C1.98292 15.2137 1.60696 15.2206 1.23169 15.2302C1.08598 15.2344 1.04749 15.1911 1.04886 15.046C1.05711 14.2192 1.05505 13.3924 1.05574 12.5655C1.05986 8.84027 1.06605 5.11433 1.06124 1.38908C1.06124 1.15264 1.12447 1.10247 1.35266 1.10316C5.27379 1.11072 9.19493 1.10865 13.1161 1.10865C13.1161 1.11209 13.1161 1.11621 13.1161 1.11965L13.1154 1.11896Z"
        fill="#FEFEFE"
      />
      <path
        d="M13.1202 16.2825C17.0324 16.2825 20.9453 16.2845 24.8575 16.277C25.096 16.277 25.1592 16.3409 25.1475 16.5725C25.1283 16.9554 25.1344 17.3396 25.1454 17.7231C25.1503 17.8922 25.0966 17.9348 24.9296 17.9348C22.1426 17.9279 19.3548 17.9286 16.5677 17.9272C14.701 17.9258 12.8342 17.9224 10.9675 17.921C7.7543 17.919 4.54041 17.9155 1.32721 17.9203C1.11346 17.9203 1.0248 17.8867 1.0406 17.6468C1.06466 17.2818 1.06054 16.9134 1.04404 16.5478C1.03442 16.3388 1.08803 16.2777 1.30591 16.2783C3.07849 16.288 4.85177 16.2838 6.62504 16.2838H13.1202V16.2825Z"
        fill="#FEFEFE"
      />
      <path
        d="M8.49392 10.7592C8.49392 9.35369 8.49873 7.94882 8.48842 6.54326C8.48705 6.335 8.55097 6.28208 8.74341 6.29788C8.93792 6.31369 9.13587 6.31507 9.33038 6.29788C9.5462 6.27795 9.61837 6.33294 9.61562 6.57006C9.60118 7.7708 9.60874 8.97154 9.60874 10.1723C9.60874 11.782 9.60599 13.3917 9.61287 15.0014C9.61355 15.1732 9.58263 15.2474 9.3943 15.2295C9.10082 15.2021 8.70561 15.3491 8.53928 15.1718C8.39288 15.0158 8.49461 14.624 8.49461 14.336C8.49254 13.1435 8.49392 11.9511 8.49392 10.7592Z"
        fill="#FEFEFE"
      />
      <path
        d="M3.6386 12.4088C3.6386 11.5572 3.64341 10.7056 3.63448 9.85471C3.63242 9.66707 3.66266 9.5736 3.87847 9.59834C4.16302 9.63065 4.54654 9.47944 4.70806 9.65608C4.84965 9.81141 4.75274 10.1887 4.75274 10.4678C4.75411 11.949 4.74518 13.4308 4.76099 14.912C4.76373 15.189 4.67988 15.2591 4.42558 15.2309C4.24069 15.2103 4.04961 15.211 3.86473 15.2309C3.66128 15.2529 3.63173 15.169 3.6331 14.9883C3.64272 14.1284 3.63722 13.2686 3.63722 12.4088H3.6386Z"
        fill="#FEFEFE"
      />
      <path
        d="M13.3498 14.4309C13.3498 14.2267 13.3566 14.0219 13.347 13.8178C13.3415 13.6892 13.3738 13.6363 13.514 13.6425C13.7773 13.6535 14.0419 13.6514 14.3058 13.6432C14.4316 13.6398 14.4653 13.6879 14.4639 13.8061C14.4584 14.2315 14.4584 14.6577 14.4639 15.0838C14.4653 15.1965 14.4254 15.2309 14.3168 15.2288C14.0357 15.2233 13.7546 15.2227 13.4735 15.2288C13.369 15.2309 13.3449 15.1903 13.347 15.0948C13.3525 14.8735 13.3484 14.6522 13.3484 14.4309H13.3498Z"
        fill="#FDFDFD"
      />
      <path
        d="M18.8901 12.936C15.9697 12.9422 13.5593 10.5517 13.5503 7.64092C13.5414 4.66347 15.9353 2.25443 18.9059 2.25305C21.8277 2.25168 24.2326 4.66003 24.236 7.59212C24.2401 10.5345 21.8435 12.9298 18.8894 12.936H18.8901Z"
        fill={color}
      />
      <path
        d="M19.4159 5.53153C19.4159 4.8669 19.4214 4.20226 19.4117 3.53763C19.409 3.36992 19.4605 3.33831 19.6159 3.36099C21.3163 3.6043 22.8456 5.11983 23.1184 6.83949C23.4971 9.22791 22.0256 11.3476 19.6557 11.8218C19.1835 11.9167 18.7086 11.9105 18.2323 11.8466C18.0708 11.8246 18.0474 11.7744 18.1003 11.6191C18.5058 10.4211 18.8969 9.2176 19.3024 8.0203C19.3863 7.77286 19.42 7.52818 19.4179 7.26975C19.4117 6.69034 19.4159 6.11094 19.4159 5.53153Z"
        fill="#FEFEFE"
      />
      <path
        d="M14.5881 7.68626C14.6019 7.09104 14.6823 6.59068 14.8596 6.10612C14.9084 5.97416 14.9366 5.91161 15.0981 6.00646C16.1002 6.59686 17.1092 7.17489 18.1189 7.75293C18.2254 7.8141 18.2529 7.86771 18.2117 7.99005C17.8385 9.09113 17.468 10.1929 17.1099 11.2995C17.048 11.4905 16.9676 11.4369 16.8577 11.3737C15.4026 10.5379 14.6603 9.27396 14.5881 7.68626Z"
        fill="#FEFEFE"
      />
      <path
        d="M18.365 6.68758C17.4165 6.14048 16.5079 5.61331 15.5951 5.0937C15.4721 5.02359 15.492 4.97411 15.5656 4.88613C16.2577 4.05723 17.1333 3.5493 18.1959 3.35891C18.3258 3.33555 18.3691 3.36716 18.3684 3.50944C18.3623 4.55553 18.365 5.60162 18.365 6.68758Z"
        fill="#FEFEFE"
      />
    </svg>
  );
};

export const ResourceManagementIcon = (
  strokeColor = "#09659c",
  fillColor = "#085f93"
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 27.326 24.834"
    >
      <g
        id="Resource_Management"
        data-name="Resource Management"
        transform="translate(0.051 0.064)"
      >
        <path
          id="Path_31973"
          data-name="Path 31973"
          d="M564.7,395.906a2.406,2.406,0,0,0-.152.7,5.74,5.74,0,1,1,.1-1.738c0,.048-.02.11.052.132v.9Zm-.879-.5a4.89,4.89,0,1,0-4.87,4.893,4.883,4.883,0,0,0,4.87-4.893Z"
          transform="translate(-537.475 -389.431)"
          fill={fillColor}
          stroke={strokeColor}
          stroke-width="0.1"
        />
        <path
          id="Path_31974"
          data-name="Path 31974"
          d="M331.693,458.416l-.023.008-.02-.015v-1.964a.134.134,0,0,0,.048-.005l0,1.975Z"
          transform="translate(-331.65 -451.457)"
          fill={fillColor}
          stroke={strokeColor}
          stroke-width="0.1"
        />
        <path
          id="Path_31975"
          data-name="Path 31975"
          d="M439.108,557.3a3.6,3.6,0,1,1,3.9-.018c.039.066.11.069.17.091a6.3,6.3,0,0,1,4.167,5.787c.01.407-.139.562-.554.562H435.309c-.43,0-.574-.152-.56-.581a6.3,6.3,0,0,1,4.186-5.774l.174-.067Zm1.938,5.572c1.735,0,3.472,0,5.207,0,.194,0,.235-.055.214-.238a5.461,5.461,0,0,0-10.838,0c-.026.214.043.245.236.243C437.592,562.874,439.319,562.877,441.046,562.877Zm.016-11.355a2.74,2.74,0,1,0,2.74,2.76A2.753,2.753,0,0,0,441.062,551.522Z"
          transform="translate(-427.436 -539.006)"
          fill={fillColor}
          stroke={strokeColor}
          stroke-width="0.1"
        />
        <path
          id="Path_31976"
          data-name="Path 31976"
          d="M332.26,396.453q0-.987,0-1.975a.428.428,0,0,1,.465-.312h.026c.272-.017.6.107.8-.052s.206-.473.32-.711a.162.162,0,0,0-.047-.224q-.25-.238-.489-.487a.42.42,0,0,1-.007-.672q.585-.6,1.183-1.182a.426.426,0,0,1,.674,0c.006.006.012.013.019.018.2.181.352.5.6.531.229.027.482-.184.73-.271a.18.18,0,0,0,.141-.21q-.011-.358,0-.716a.4.4,0,0,1,.43-.433q.877-.012,1.754,0a.4.4,0,0,1,.431.434c0,.018,0,.035,0,.053.006.273-.08.606.046.8s.467.208.7.323a.181.181,0,0,0,.251-.041q.237-.251.487-.489a.416.416,0,0,1,.653-.014q.619.6,1.222,1.218a.413.413,0,0,1-.007.635,6.276,6.276,0,0,1-.452.449c-.123.108-.179.206-.065.352a.386.386,0,0,1,.076.168c.075.487.383.6.821.526a1.106,1.106,0,0,1,.265,0,.407.407,0,0,1,.425.418q.018.888,0,1.777a.4.4,0,0,1-.418.421,4.17,4.17,0,0,1-.611,0c-.206-.018-.341.031-.374.255a.761.761,0,0,1-.062.174.716.716,0,0,0,.165.84c.075.075.152.148.225.226a.408.408,0,0,1,.014.633q-.61.629-1.241,1.238a.418.418,0,0,1-.618-.006c-.013-.011-.025-.025-.038-.037-.2-.189-.372-.484-.6-.534-.211-.046-.477.179-.725.267a.183.183,0,0,0-.148.209c.008.23.006.46,0,.689a.422.422,0,0,1-.452.472c-.567.009-1.134.008-1.7,0a.421.421,0,0,1-.462-.462c-.006-.23-.008-.46,0-.689a.189.189,0,0,0-.163-.223,1.707,1.707,0,0,1-.464-.189.315.315,0,0,0-.484.093,3.691,3.691,0,0,1-.392.4.419.419,0,0,1-.637,0q-.62-.6-1.222-1.219a.412.412,0,0,1,0-.633l.037-.038c.182-.2.5-.352.533-.6.028-.228-.188-.479-.274-.728a.183.183,0,0,0-.213-.141c-.23,0-.461,0-.691,0a.406.406,0,0,1-.447-.329Zm8.847,2.839c.2-.213.369-.4.55-.567.107-.1.087-.162-.009-.25-.144-.13-.277-.274-.415-.411a.43.43,0,0,1-.071-.577,4.051,4.051,0,0,0,.494-1.192.431.431,0,0,1,.461-.356c.2,0,.408,0,.611,0,.091,0,.154-.016.15-.128-.008-.256.07-.556-.04-.753-.079-.14-.412-.026-.631-.043a.758.758,0,0,0-.079,0,.424.424,0,0,1-.467-.345,4.34,4.34,0,0,0-.506-1.216.428.428,0,0,1,.087-.575c.145-.142.288-.287.432-.431.053-.052.1-.1.023-.172-.193-.182-.354-.448-.581-.524-.136-.045-.306.274-.471.418-.02.018-.038.037-.057.056a.441.441,0,0,1-.6.075,3.918,3.918,0,0,0-1.169-.482.446.446,0,0,1-.374-.477c0-.2,0-.407,0-.61,0-.1-.033-.129-.135-.138-.774-.069-.774-.072-.783.684v.026a.459.459,0,0,1-.416.523,4.1,4.1,0,0,0-1.1.455.459.459,0,0,1-.663-.084c-.172-.157-.314-.469-.516-.439s-.339.312-.518.469c-.113.1-.09.162.008.25.144.13.278.272.415.411a.421.421,0,0,1,.079.555,4.551,4.551,0,0,0-.516,1.24.415.415,0,0,1-.451.33c-.2,0-.408,0-.611,0-.089,0-.138.011-.152.123-.092.755-.063.794.674.8h.079a.442.442,0,0,1,.477.372,3.909,3.909,0,0,0,.484,1.167.441.441,0,0,1-.078.6c-.145.143-.287.289-.433.43-.055.054-.1.1-.022.172.192.183.353.448.579.526.131.045.306-.272.469-.417.02-.018.038-.037.057-.056a.433.433,0,0,1,.6-.084,4.061,4.061,0,0,0,1.194.494.433.433,0,0,1,.357.459c0,.2,0,.406,0,.61,0,.067-.016.154.094.15.264-.009.565.087.778-.04.134-.08.028-.379.043-.578a1.04,1.04,0,0,0,0-.106.449.449,0,0,1,.375-.5,3.922,3.922,0,0,0,1.169-.485.431.431,0,0,1,.6.074c.17.18.336.364.521.566Z"
          transform="translate(-332.217 -389.495)"
          fill={fillColor}
          stroke={strokeColor}
          stroke-width="0.1"
        />
        <path
          id="Path_31977"
          data-name="Path 31977"
          d="M395.172,563.323a2.515,2.515,0,0,1-.218.2.392.392,0,0,1-.533-.03.369.369,0,0,1-.069-.526c.309-.386.638-.757.976-1.118a.387.387,0,0,1,.572.023q.478.515.928,1.056a.411.411,0,0,1-.057.573.4.4,0,0,1-.555,0c-.052-.043-.1-.092-.152-.141-.063.079-.035.16-.035.233,0,.981,0,1.962-.006,2.943,0,.212.038.285.269.281.912-.015,1.824-.007,2.736,0a.975.975,0,0,1,.288.031.384.384,0,0,1,.291.421.392.392,0,0,1-.34.384,1.27,1.27,0,0,1-.238.013q-1.634,0-3.268,0c-.457,0-.587-.128-.587-.58q0-1.711,0-3.421v-.343Z"
          transform="translate(-389.829 -549.287)"
          fill={fillColor}
          stroke={strokeColor}
          stroke-width="0.1"
        />
        <path
          id="Path_31978"
          data-name="Path 31978"
          d="M579.041,567.843a2.145,2.145,0,0,1,.2.226.4.4,0,0,1-.028.514.366.366,0,0,1-.523.087c-.4-.312-.774-.645-1.14-.991a.372.372,0,0,1,.038-.567q.507-.468,1.038-.91a.421.421,0,0,1,.577.611.559.559,0,0,1-.155.092c.016.028.03.057.046.084h1.442c.481,0,.5,0,.5-.494q0-1.977,0-3.953a1.3,1.3,0,0,1,.026-.316.379.379,0,0,1,.387-.3.385.385,0,0,1,.416.3,1.063,1.063,0,0,1,.026.289q0,2.362,0,4.723c0,.486-.122.6-.617.606H579.04Z"
          transform="translate(-560.005 -549.462)"
          fill={fillColor}
          stroke={strokeColor}
          stroke-width="0.1"
        />
        <path
          id="Path_31979"
          data-name="Path 31979"
          d="M486.036,387.934H482.4c-.079,0-.16,0-.239,0a.422.422,0,1,1,0-.844c.372-.011.744,0,1.116,0h2.779c-.009-.107-.109-.133-.155-.2a.408.408,0,0,1,0-.537.372.372,0,0,1,.545-.085c.387.309.76.637,1.118.979a.391.391,0,0,1-.065.606c-.308.279-.623.553-.939.822a.427.427,0,0,1-.656,0,.439.439,0,0,1,.086-.63.312.312,0,0,1,.1-.043Z"
          transform="translate(-471.086 -386.181)"
          fill={fillColor}
          stroke={strokeColor}
          stroke-width="0.1"
        />
        <path
          id="Path_31980"
          data-name="Path 31980"
          d="M582.176,414.34a4.3,4.3,0,1,1-4.3-4.29,4.306,4.306,0,0,1,4.3,4.29Zm-.851.015a3.448,3.448,0,1,0-3.456,3.435,3.439,3.439,0,0,0,3.456-3.435Z"
          transform="translate(-556.422 -408.357)"
          fill={fillColor}
          stroke={strokeColor}
          stroke-width="0.1"
        />
        <path
          id="Path_31981"
          data-name="Path 31981"
          d="M376.383,436.73a2.791,2.791,0,1,1,2.806-2.757,2.787,2.787,0,0,1-2.806,2.757Zm.018-.85a1.942,1.942,0,1,0-1.95-1.924,1.937,1.937,0,0,0,1.95,1.924Z"
          transform="translate(-370.624 -427.959)"
          fill={fillColor}
          stroke={strokeColor}
          stroke-width="0.1"
        />
        <path
          id="Path_31982"
          data-name="Path 31982"
          d="M617.792,434.806a.425.425,0,0,1-.252.45.362.362,0,0,1-.46-.091.684.684,0,0,0-.674-.206.372.372,0,0,0-.369.379.384.384,0,0,0,.338.411,1.647,1.647,0,0,0,.291.014,1.247,1.247,0,0,1,.518,2.362c-.142.07-.239.126-.247.315a.411.411,0,0,1-.813.013.294.294,0,0,0-.233-.291,1.053,1.053,0,0,1-.538-.413.426.426,0,0,1,.059-.574.4.4,0,0,1,.573.027.687.687,0,0,0,.648.21.408.408,0,0,0,.4-.415.4.4,0,0,0-.4-.384,2.081,2.081,0,0,1-.6-.078,1.241,1.241,0,0,1-.846-1.113,1.2,1.2,0,0,1,.692-1.185c.145-.075.237-.133.245-.316a.372.372,0,0,1,.413-.363.365.365,0,0,1,.4.347c.009.191.111.237.257.3a.92.92,0,0,1,.6.6Z"
          transform="translate(-595.075 -430.2)"
          fill={fillColor}
          stroke={strokeColor}
          stroke-width="0.1"
        />
      </g>
    </svg>
  );
};

export const FinancialDashboardIcon = (fillColor = "#085f93") => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 28.953 28.807"
    >
      <g
        id="Group_17901"
        data-name="Group 17901"
        transform="translate(-281.277 -1214)"
      >
        <path
          id="Path_30403"
          data-name="Path 30403"
          d="M272.391,57.631a1.533,1.533,0,0,0-.106,1.044,1.3,1.3,0,0,0,.112.3l-.751.751L269.769,61.6a1.605,1.605,0,0,0-.674-.153,1.5,1.5,0,0,0-.668.159l-1.055-1.062a1.589,1.589,0,0,0,.153-.668,1.571,1.571,0,1,0-3.143,0,1.519,1.519,0,0,0,.158.668l-.7.7-.076.076h-.006l-.8.8a1.521,1.521,0,0,0-.674-.158,1.571,1.571,0,1,0,1.566,1.571,1.539,1.539,0,0,0-.153-.657l.011-.012,1.313-1.319.264-.257a1.515,1.515,0,0,0,.668.158,1.531,1.531,0,0,0,.675-.158l1.055,1.055a1.605,1.605,0,0,0-.158.675,1.571,1.571,0,0,0,3.143,0,1.6,1.6,0,0,0-.153-.675l2.621-2.621.006-.007c.006,0,.006.007.012.007a1.524,1.524,0,0,0,1.331,0,1.581,1.581,0,0,0,.85-1.049,1.5,1.5,0,0,0,.047-.369,1.531,1.531,0,0,0-.153-.675,1.569,1.569,0,0,0-2.836,0Zm-10.548,5.611a.447.447,0,0,1,.158-.153.5.5,0,0,1,.276-.076.525.525,0,1,1,0,1.05.533.533,0,0,1-.522-.534.5.5,0,0,1,.083-.275Zm4.11-2.844a.525.525,0,1,1,.528-.521A.522.522,0,0,1,265.952,60.4Zm3.143,3.143a.525.525,0,1,1,.528-.521A.523.523,0,0,1,269.1,63.541Zm5.242-5.235a.518.518,0,0,1-.153.369.543.543,0,0,1-.375.152.521.521,0,0,1-.522-.521.525.525,0,1,1,1.05,0Z"
          transform="translate(29.92 1158.844)"
          fill={fillColor}
        />
        <g
          id="Group_17900"
          data-name="Group 17900"
          transform="translate(-183 952)"
        >
          <path
            id="Path_30404"
            data-name="Path 30404"
            d="M123.826,43.191l-.018-.018s-.006-13.89,0-13.9H98v20.95h12.219c.006.053.006.105.012.153a8,8,0,0,0,.235,1.407,8.133,8.133,0,0,0,.556,1.524,7.444,7.444,0,0,0,.393.733,7.761,7.761,0,0,0,.756,1.05,8.361,8.361,0,0,0,9.469,2.41,7.9,7.9,0,0,0,1.12-.546,8.324,8.324,0,0,0,3.822-4.8,8.252,8.252,0,0,0,.37-2.456,8.345,8.345,0,0,0-3.125-6.514Zm-13.609,5.992H99.041V30.327h23.723V42.458a8.351,8.351,0,0,0-4.192-1.132,7.739,7.739,0,0,0-.909.053,7.366,7.366,0,0,0-1.249.234,8.346,8.346,0,0,0-4.128,2.569V41.848h-3.142v6.285h1.2a8.9,8.9,0,0,0-.129,1.05Zm10.472-3.09a4.176,4.176,0,0,1,2.076,3.612,4.1,4.1,0,0,1-.264,1.448,4.191,4.191,0,0,1-2.176,2.357,4.073,4.073,0,0,1-1.753.387,4.19,4.19,0,0,1-.059-8.379.205.205,0,0,1,.059-.006,4.127,4.127,0,0,1,2.116.581Zm-9.745.141a8.215,8.215,0,0,0-.328.85h-.422V42.9h1.043v2.761c-.105.188-.2.381-.293.575Zm1.039,6.672a6.665,6.665,0,0,1-.434-1.126,7.136,7.136,0,0,1-.041-4.028,7.341,7.341,0,0,1,5.787-5.26,6.243,6.243,0,0,1,.756-.093v2.093a5.237,5.237,0,0,0-4.251,7.364Zm9.85,3.359a7.122,7.122,0,0,1-1,.416,7.375,7.375,0,0,1-2.263.358,7.259,7.259,0,0,1-4.954-1.947,6.688,6.688,0,0,1-.95-1.05c-.059-.076-.112-.153-.164-.228l1.824-1.055a5.231,5.231,0,0,0,1.331,1.284,5.143,5.143,0,0,0,2.914.9,5.2,5.2,0,0,0,2.662-.733,5.259,5.259,0,0,0,1.583-1.448l1.823,1.055a7.326,7.326,0,0,1-2.809,2.451Zm3.864-4.843a7.413,7.413,0,0,1-.334,1.026c-.059.153-.129.3-.2.451v.007l-1.63-.938-.188-.111a5.27,5.27,0,0,0,.463-2.152,5.2,5.2,0,0,0-1.032-3.12,5.052,5.052,0,0,0-1.249-1.2,4.422,4.422,0,0,0-.92-.5,5.025,5.025,0,0,0-.968-.31,5.242,5.242,0,0,0-.545-.082V42.4a7.3,7.3,0,0,1,3.682,1.307,6.688,6.688,0,0,1,1.05.9,7.246,7.246,0,0,1,1.87,6.819Z"
            transform="translate(366.28 232.723)"
            fill={fillColor}
          />
        </g>
        <path
          id="Path_30404-2"
          data-name="Path 30404"
          d="M401.664,332.144a3.228,3.228,0,0,0-.223,1.168,3.145,3.145,0,0,0,5.183,2.392,2.941,2.941,0,0,0,.668-.81,3.094,3.094,0,0,0,.434-1.582,3.136,3.136,0,0,0-2.779-3.12,2.416,2.416,0,0,0-.363-.024,3.147,3.147,0,0,0-2.92,1.976Zm.874.715a2.038,2.038,0,0,1,.516-.967,1.88,1.88,0,0,1,.475-.387,2.092,2.092,0,0,1,1.056-.288h.006a2.094,2.094,0,0,1,2.088,2.094,2.156,2.156,0,0,1-.158.8,2.07,2.07,0,0,1-.645.839,2.029,2.029,0,0,1-1.29.451,2.094,2.094,0,0,1-2.093-2.093,2.276,2.276,0,0,1,.047-.451Z"
          transform="translate(-102.732 901.117)"
          fill={fillColor}
        />
        <path
          id="Path_30405"
          data-name="Path 30405"
          d="M146.15,65.754H147.2V66.8H146.15Z"
          transform="translate(137.894 1150.342)"
          fill={fillColor}
        />
        <path
          id="Path_30406"
          data-name="Path 30406"
          d="M182.61,65.754h5.238V66.8H182.61Z"
          transform="translate(103.528 1150.342)"
          fill={fillColor}
        />
        <path
          id="Path_30407"
          data-name="Path 30407"
          d="M146.15,102.22H147.2v1.048H146.15Z"
          transform="translate(137.894 1115.97)"
          fill={fillColor}
        />
        <path
          id="Path_30408"
          data-name="Path 30408"
          d="M182.61,102.22h5.238v1.048H182.61Z"
          transform="translate(103.528 1115.97)"
          fill={fillColor}
        />
        <path
          id="Path_30409"
          data-name="Path 30409"
          d="M146.18,288.743h3.142v-4.192H146.18Zm1.043-3.143h1.05v2.093h-1.05Z"
          transform="translate(137.865 944.114)"
          fill={fillColor}
        />
        <path
          id="Path_30410"
          data-name="Path 30410"
          d="M219.05,220.049h3.143V211.67H219.05Zm1.05-7.335h1.05V219H220.1Z"
          transform="translate(69.182 1012.808)"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};

export const DropDownFilterIcon = (fillColor = "#343434") => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10.446"
      height="6.531"
      viewBox="0 0 10.446 6.531"
    >
      <g
        id="Group_10723"
        data-name="Group 10723"
        transform="translate(198.93 -278.086) rotate(90)"
      >
        <path
          id="Path_29942"
          data-name="Path 29942"
          d="M0,0,2.314,2.441l.463.488.926.977"
          transform="translate(279.5 189.898)"
          fill={fillColor}
          stroke={fillColor}
          stroke-linecap="round"
          stroke-width="2"
        />
        <path
          id="Path_29941"
          data-name="Path 29941"
          d="M3.669,0,2.293,1.4,0,3.745"
          transform="translate(279.5 193.771)"
          fill={fillColor}
          stroke={fillColor}
          stroke-linecap="round"
          stroke-width="2"
        />
      </g>
    </svg>
  );
};

export const TableFilterIcon = (fillColor = "#343434") => {
  return (
    <svg
      id="filter_1_"
      data-name="filter (1)"
      xmlns="http://www.w3.org/2000/svg"
      width="18.294"
      height="18.913"
      viewBox="0 0 18.294 18.913"
    >
      <path
        fill={fillColor}
        id="Path_11745"
        data-name="Path 11745"
        d="M6.307,17.09a.6.6,0,0,1-.255-.056A.609.609,0,0,1,5.7,16.48V10.034a1.025,1.025,0,0,0-.3-.719L.656,4.575A2.221,2.221,0,0,1,0,2.992V1.425A1.426,1.426,0,0,1,1.424,0H14.241a1.426,1.426,0,0,1,1.424,1.424v1.55a2.25,2.25,0,0,1-.684,1.61l-4.9,4.732a1.022,1.022,0,0,0-.312.733V13.29a2.235,2.235,0,0,1-.781,1.7L6.7,16.943a.611.611,0,0,1-.4.147ZM1.424,1.221a.2.2,0,0,0-.2.2V2.992a1.011,1.011,0,0,0,.3.72L6.261,8.451a2.251,2.251,0,0,1,.656,1.583v5.119l1.272-1.09a1.017,1.017,0,0,0,.356-.772V10.052a2.249,2.249,0,0,1,.684-1.61l4.9-4.732a1.021,1.021,0,0,0,.311-.732V1.425a.2.2,0,0,0-.2-.2Zm0,0"
        transform="translate(0 -0.001)"
      />
      <path
        fill={fillColor}
        id="Path_11746"
        data-name="Path 11746"
        d="M305.382,265.766h-5.29a1.426,1.426,0,0,1-1.424-1.424v-6.918A1.426,1.426,0,0,1,300.092,256h5.29a1.426,1.426,0,0,1,1.424,1.424v6.918A1.426,1.426,0,0,1,305.382,265.766Zm-5.29-8.545a.2.2,0,0,0-.2.2v6.918a.2.2,0,0,0,.2.2h5.29a.2.2,0,0,0,.2-.2v-6.918a.2.2,0,0,0-.2-.2Zm0,0"
        transform="translate(-288.511 -246.853)"
      />
      <path
        fill={fillColor}
        id="Path_11747"
        data-name="Path 11747"
        d="M365.313,337.221h-2.034a.61.61,0,1,1,0-1.221h2.034a.61.61,0,0,1,0,1.221Zm0,0"
        transform="translate(-350.07 -323.801)"
      />
      <path
        fill={fillColor}
        id="Path_11748"
        data-name="Path 11748"
        d="M365.313,401.221h-2.034a.61.61,0,1,1,0-1.221h2.034a.61.61,0,0,1,0,1.221Zm0,0"
        transform="translate(-350.07 -385.36)"
      />
    </svg>
  );
};

export const HighPriorityIcon = (colorVal = "#ea3d2f") => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 16.096 9.277"
    >
      <g
        id="Group_22147"
        data-name="Group 22147"
        transform="translate(1.414 1.414)"
      >
        <g
          id="Group_22146"
          data-name="Group 22146"
          transform="translate(0 6.449) rotate(-90)"
        >
          <path
            id="Path_32100"
            data-name="Path 32100"
            d="M0,0,4.031,4.253l.806.851L6.449,6.8"
            transform="translate(0 0)"
            fill={colorVal}
            stroke={colorVal}
            stroke-linecap="round"
            stroke-width="2"
          />
          <path
            id="Path_32101"
            data-name="Path 32101"
            d="M6.448,0,4.03,2.446,0,6.524"
            transform="translate(0 6.745)"
            fill={colorVal}
            stroke={colorVal}
            stroke-linecap="round"
            stroke-width="2"
          />
        </g>
      </g>
    </svg>
  );
};

export const BlockerPriorityIcon = (colorVal = "#ea3d2f") => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 16.096 15.727"
    >
      <g
        id="Group_22145"
        data-name="Group 22145"
        transform="translate(1.414 1.414)"
      >
        <g
          id="Group_22143"
          data-name="Group 22143"
          transform="translate(0 6.449) rotate(-90)"
        >
          <path
            id="Path_32096"
            data-name="Path 32096"
            d="M0,0,4.031,4.253l.806.851L6.449,6.8"
            transform="translate(0 0)"
            fill={colorVal}
            stroke={colorVal}
            stroke-linecap="round"
            stroke-width="2"
          />
          <path
            id="Path_32097"
            data-name="Path 32097"
            d="M6.448,0,4.03,2.446,0,6.524"
            transform="translate(0 6.745)"
            fill={colorVal}
            stroke={colorVal}
            stroke-linecap="round"
            stroke-width="2"
          />
        </g>
        <g
          id="Group_22144"
          data-name="Group 22144"
          transform="translate(0 12.899) rotate(-90)"
        >
          <path
            id="Path_32098"
            data-name="Path 32098"
            d="M0,0,4.031,4.253l.806.851L6.449,6.8"
            transform="translate(0 0)"
            fill={colorVal}
            stroke={colorVal}
            stroke-linecap="round"
            stroke-width="2"
          />
          <path
            id="Path_32099"
            data-name="Path 32099"
            d="M6.448,0,4.03,2.446,0,6.524"
            transform="translate(0 6.745)"
            fill={colorVal}
            stroke={colorVal}
            stroke-linecap="round"
            stroke-width="2"
          />
        </g>
      </g>
    </svg>
  );
};

export const MediumPriorityIcon = (colorVal = "#fc8f00") => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 16.531 21.005"
    >
      <g
        id="Group_22155"
        data-name="Group 22155"
        transform="translate(2 3.624)"
      >
        <path
          id="Path_32110"
          data-name="Path 32110"
          d="M7.589-1.141,4.31,2.166-1.155,7.679"
          transform="translate(6.284 13.758) rotate(-135)"
          fill={colorVal}
          stroke={colorVal}
          stroke-linecap="round"
          stroke-width="2"
        />
        <path
          id="Path_32111"
          data-name="Path 32111"
          d="M7.589-1.141,4.31,2.166-1.155,7.679"
          transform="translate(6.173 9.172) rotate(-135)"
          fill={colorVal}
          stroke={colorVal}
          stroke-linecap="round"
          stroke-width="2"
        />
      </g>
    </svg>
  );
};

export const LowPriorityIcon = (colorVal = "#0070d2") => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 16.096 9.277"
    >
      <g
        id="Group_22154"
        data-name="Group 22154"
        transform="translate(14.683 7.864) rotate(180)"
      >
        <g
          id="Group_22153"
          data-name="Group 22153"
          transform="translate(0 6.449) rotate(-90)"
        >
          <path
            id="Path_32108"
            data-name="Path 32108"
            d="M0,0,4.031,4.253l.806.851L6.449,6.8"
            transform="translate(0 0)"
            fill={colorVal}
            stroke={colorVal}
            stroke-linecap="round"
            stroke-width="2"
          />
          <path
            id="Path_32109"
            data-name="Path 32109"
            d="M6.448,0,4.03,2.446,0,6.524"
            transform="translate(0 6.745)"
            fill={colorVal}
            stroke={colorVal}
            stroke-linecap="round"
            stroke-width="2"
          />
        </g>
      </g>
    </svg>
  );
};

export const LowestPriorityIcon = (colorVal = "#0070d2") => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 16.096 15.727"
    >
      <g
        id="Group_22152"
        data-name="Group 22152"
        transform="translate(14.683 14.313) rotate(180)"
      >
        <g
          id="Group_22150"
          data-name="Group 22150"
          transform="translate(0 6.449) rotate(-90)"
        >
          <path
            id="Path_32104"
            data-name="Path 32104"
            d="M0,0,4.031,4.253l.806.851L6.449,6.8"
            transform="translate(0 0)"
            fill={colorVal}
            stroke={colorVal}
            stroke-linecap="round"
            stroke-width="2"
          />
          <path
            id="Path_32105"
            data-name="Path 32105"
            d="M6.448,0,4.03,2.446,0,6.524"
            transform="translate(0 6.745)"
            fill={colorVal}
            stroke={colorVal}
            stroke-linecap="round"
            stroke-width="2"
          />
        </g>
        <g
          id="Group_22151"
          data-name="Group 22151"
          transform="translate(0 12.899) rotate(-90)"
        >
          <path
            id="Path_32106"
            data-name="Path 32106"
            d="M0,0,4.031,4.253l.806.851L6.449,6.8"
            transform="translate(0 0)"
            fill={colorVal}
            stroke={colorVal}
            stroke-linecap="round"
            stroke-width="2"
          />
          <path
            id="Path_32107"
            data-name="Path 32107"
            d="M6.448,0,4.03,2.446,0,6.524"
            transform="translate(0 6.745)"
            fill={colorVal}
            stroke={colorVal}
            stroke-linecap="round"
            stroke-width="2"
          />
        </g>
      </g>
    </svg>
  );
};

export const AdminSettings = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20.483"
      height="30.055"
      viewBox="0 0 20.483 30.055"
    >
      <g
        id="admin_setting"
        data-name="admin setting"
        transform="translate(-410.085 -388.119)"
      >
        <path
          id="Path_32418"
          data-name="Path 32418"
          d="M419.454,418.124a1.074,1.074,0,0,1-.75-1.222c.023-.225-.06-.311-.276-.378a7.858,7.858,0,0,1-1.016-.416.232.232,0,0,0-.323.05c-.606.682-1.22.8-1.981-.037-.169-.185-.367-.344-.541-.525a.9.9,0,0,1,.005-1.3c.141-.145.295-.278.437-.41l-.576-1.336a5.67,5.67,0,0,1-1.09-.2c-.373-.145-.486-.523-.514-.941H411c-.136,0-.271,0-.406,0a.414.414,0,0,1-.439-.415,19.353,19.353,0,0,1,.39-5.762,9.787,9.787,0,0,1,5.169-6.067l.24-.118a6.182,6.182,0,0,1-1.644-5.934,5.979,5.979,0,0,1,2.459-3.577,6.213,6.213,0,0,1,7.942,9.5,1.816,1.816,0,0,0,.161.1,9.71,9.71,0,0,1,5.634,8.916c.027.908.006,1.819,0,2.728,0,.49-.149.632-.647.633-.676,0-1.351,0-2.051,0a.933.933,0,0,1-.492.993,5.842,5.842,0,0,1-1.106.223l-.613,1.39a3.465,3.465,0,0,1,.407.333.906.906,0,0,1-.021,1.324c-.279.281-.567.555-.862.819a.954.954,0,0,1-1.338-.017,4.557,4.557,0,0,1-.365-.424c-.536.2-1,.361-1.452.54a.281.281,0,0,0-.117.195,1.789,1.789,0,0,0-.005.347,1,1,0,0,1-.77,1h-1.626Zm10.052-7.683a30.3,30.3,0,0,0-.019-3.276,8.673,8.673,0,0,0-5.387-7.334.478.478,0,0,0-.5.04,6.056,6.056,0,0,1-6.561-.007.461.461,0,0,0-.475-.037,8.852,8.852,0,0,0-5.006,5.37,15.064,15.064,0,0,0-.45,5.2c0,.015.023.029.037.047h1.671a1.054,1.054,0,0,1,1.228-1,.758.758,0,0,0,.23-.005.365.365,0,0,0,.208-.141c.182-.4.347-.812.537-1.265-.117-.107-.268-.229-.4-.368a.9.9,0,0,1,.012-1.322q.419-.422.861-.821a.952.952,0,0,1,1.338,0c.123.109.23.237.358.338a.272.272,0,0,0,.223.044c.446-.175.886-.365,1.342-.555,0-.167,0-.351,0-.534a.947.947,0,0,1,.939-.975c.435-.012.871-.012,1.305,0a.934.934,0,0,1,.895.895,3.081,3.081,0,0,1,0,.406.233.233,0,0,0,.2.285,2.713,2.713,0,0,1,.756.285.643.643,0,0,0,.952-.144.927.927,0,0,1,1.376,0c.286.261.565.529.84.8a.915.915,0,0,1-.015,1.385c-.137.133-.276.261-.386.366.17.4.346.759.469,1.133a.327.327,0,0,0,.393.268,2.114,2.114,0,0,1,.606.029.942.942,0,0,1,.731.894H429.5Zm-9.2-10.585a5.246,5.246,0,1,0-5.222-5.257A5.237,5.237,0,0,0,420.306,399.857Zm4.189,6.38c-.237.212-.458.4-.667.6a.579.579,0,0,1-.734.085c-.548-.254-1.113-.477-1.683-.678-.347-.122-.459-.216-.465-.592,0-.287,0-.574,0-.848H419.74a.339.339,0,0,0-.026.081c.005.261.017.522.019.783a.507.507,0,0,1-.465.593,5.144,5.144,0,0,0-1.741.688.5.5,0,0,1-.682-.077c-.214-.223-.417-.457-.642-.7l-.875.831c.222.223.421.42.616.621a.486.486,0,0,1,.071.724,4.7,4.7,0,0,0-.71,1.606.5.5,0,0,1-.573.451c-.3,0-.594,0-.9,0v1.123h.83c.415,0,.526.121.665.5a14.64,14.64,0,0,0,.678,1.557c.175.347.184.517-.107.79-.2.191-.41.379-.627.579l.837.791c.221-.2.423-.378.624-.56.325-.293.436-.276.824-.095a15.314,15.314,0,0,0,1.607.639c.38.127.5.221.5.626,0,.266,0,.532,0,.792H420.9c0-.291,0-.551,0-.811,0-.384.119-.481.484-.6a17.68,17.68,0,0,0,1.662-.655c.365-.167.5-.188.794.112.2.206.371.439.562.668l.943-.9c-.227-.2-.43-.368-.614-.552-.275-.275-.259-.434-.09-.771.257-.514.487-1.044.694-1.581.126-.324.228-.444.579-.451.3-.006.6,0,.9,0v-1.132c-.323,0-.621,0-.92,0-.348,0-.459-.128-.581-.447-.208-.547-.439-1.087-.7-1.611-.163-.329-.17-.513.1-.769.2-.192.409-.38.637-.592Z"
          stroke="#000"
          stroke-width="0.1"
        />
        <path
          id="Path_32419"
          data-name="Path 32419"
          d="M502.6,645.139a3.306,3.306,0,0,1-3.342-2.657,3.157,3.157,0,0,1,2.434-3.561,3.284,3.284,0,0,1,4.094,2.727,3.169,3.169,0,0,1-2.488,3.395A6.746,6.746,0,0,1,502.6,645.139Zm2.242-3.163a2.245,2.245,0,0,0-2.074-2.186,2.358,2.358,0,0,0-2.5,1.562,2.152,2.152,0,0,0,1.128,2.559A2.333,2.333,0,0,0,504.844,641.976Z"
          transform="translate(-82.187 -230.99)"
        />
      </g>
    </svg>
  );
};

export const SideSettingsIcon = (fillColor = "#085f93") => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 22.047 22.053"
    >
      <g id="setting" transform="translate(0)">
        <path
          id="Path_31458"
          data-name="Path 31458"
          d="M330.454,292.44c.1.076.224.06.335.1a2.037,2.037,0,0,1,1.391,1.966c0,.42.007.414.4.568.279.11.555.23.824.362a.2.2,0,0,0,.29-.049,2.172,2.172,0,0,1,1.26-.763,1.909,1.909,0,0,1,1.666.435,14.857,14.857,0,0,1,1.232,1.229,2.009,2.009,0,0,1-.1,2.733c-.108.114-.282.217-.3.345s.114.28.174.425c.1.251.214.5.294.759a.237.237,0,0,0,.29.195,2.09,2.09,0,0,1,1.335.312,1.951,1.951,0,0,1,.934,1.649,10.042,10.042,0,0,1-.031,1.782,2,2,0,0,1-1.939,1.686c-.17,0-.379-.066-.5.032s-.125.294-.188.445c-.105.25-.207.5-.329.745a.2.2,0,0,0,.049.29,2.179,2.179,0,0,1,.759,1.239,1.948,1.948,0,0,1-.471,1.737c-.346.382-.714.746-1.089,1.1a2.014,2.014,0,0,1-2.831-.02c-.114-.108-.217-.282-.346-.3s-.28.116-.424.176c-.251.1-.5.216-.759.294a.235.235,0,0,0-.2.289,2.1,2.1,0,0,1-.36,1.406,1.882,1.882,0,0,1-1.41.846,8.663,8.663,0,0,1-1.995-.019,1.989,1.989,0,0,1-1.664-1.935c0-.17.066-.379-.032-.5s-.294-.125-.445-.188c-.25-.105-.5-.2-.745-.328a.2.2,0,0,0-.29.049,2.182,2.182,0,0,1-1.26.763,1.923,1.923,0,0,1-1.682-.448,15.741,15.741,0,0,1-1.2-1.2,1.962,1.962,0,0,1,.07-2.707c.291-.29.364-.507.138-.856a2.828,2.828,0,0,1-.284-.715.237.237,0,0,0-.289-.2,2.09,2.09,0,0,1-1.458-.4,2.016,2.016,0,0,1-.742-1.076c-.016-.056,0-.132-.078-.164v-2.151c.075-.04.062-.121.082-.185a2.028,2.028,0,0,1,1.028-1.236,2.137,2.137,0,0,1,1.167-.216.237.237,0,0,0,.289-.2,2.839,2.839,0,0,1,.284-.715c.227-.35.152-.566-.138-.856a1.963,1.963,0,0,1-.069-2.707,15.921,15.921,0,0,1,1.2-1.2,1.92,1.92,0,0,1,1.683-.447,2.151,2.151,0,0,1,1.245.749.224.224,0,0,0,.324.053c.24-.125.495-.223.746-.324.443-.178.445-.176.456-.661a2.016,2.016,0,0,1,1.476-1.92c.056-.016.133,0,.164-.078h2.065Zm-1.007,20.738c.222,0,.444,0,.667,0a.732.732,0,0,0,.775-.763c0-.287,0-.574,0-.861a.654.654,0,0,1,.536-.7,8.182,8.182,0,0,0,1.876-.779.639.639,0,0,1,.874.113c.205.2.4.408.61.607a.729.729,0,0,0,1.089,0q.469-.459.928-.928a.729.729,0,0,0,0-1.089c-.2-.212-.417-.414-.621-.625a.628.628,0,0,1-.111-.84,8.186,8.186,0,0,0,.794-1.915.647.647,0,0,1,.675-.516c.294,0,.588,0,.882,0a.731.731,0,0,0,.764-.774q0-.645,0-1.29a.731.731,0,0,0-.774-.785c-.287,0-.574,0-.861,0a.652.652,0,0,1-.689-.526,8.239,8.239,0,0,0-.786-1.9.634.634,0,0,1,.112-.857c.2-.211.419-.413.621-.625a.726.726,0,0,0,0-1.073q-.466-.477-.943-.943a.725.725,0,0,0-1.073,0c-.212.2-.414.417-.625.622a.636.636,0,0,1-.857.111,8.144,8.144,0,0,0-1.9-.786.651.651,0,0,1-.526-.689c0-.294,0-.588,0-.882a.727.727,0,0,0-.763-.752c-.437,0-.875,0-1.312,0a.73.73,0,0,0-.774.763c0,.294,0,.588,0,.882a.646.646,0,0,1-.515.676,8.2,8.2,0,0,0-1.915.794.631.631,0,0,1-.84-.11c-.211-.2-.414-.417-.625-.622a.728.728,0,0,0-1.088,0q-.468.46-.928.928a.727.727,0,0,0,0,1.088c.2.206.407.4.607.61a.64.64,0,0,1,.115.874,8.181,8.181,0,0,0-.779,1.876.652.652,0,0,1-.7.538c-.294,0-.588,0-.882,0a.725.725,0,0,0-.743.75c0,.445,0,.889,0,1.334a.73.73,0,0,0,.773.764c.287,0,.574,0,.861,0a.649.649,0,0,1,.689.525,8.191,8.191,0,0,0,.786,1.9.636.636,0,0,1-.11.857c-.2.211-.418.414-.622.625a.725.725,0,0,0,0,1.073q.466.477.943.943a.726.726,0,0,0,1.073,0c.212-.2.415-.416.625-.622a.635.635,0,0,1,.857-.113,8.3,8.3,0,0,0,1.9.786.651.651,0,0,1,.528.687c0,.3,0,.6,0,.9a.726.726,0,0,0,.739.732c.222,0,.445,0,.667,0Z"
          transform="translate(-318.45 -292.44)"
          fill={fillColor}
        />
        <path
          id="Path_31459"
          data-name="Path 31459"
          d="M462.992,441.76a4.79,4.79,0,1,1,4.795-4.774A4.789,4.789,0,0,1,462.992,441.76Zm.016-8.289a3.5,3.5,0,1,0,3.488,3.5A3.494,3.494,0,0,0,463.008,433.471Z"
          transform="translate(-451.984 -425.956)"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};

export const HomeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20.475"
      height="19.93"
      viewBox="0 0 20.475 19.93"
    >
      <path
        id="home"
        d="M437.768,455.542v.4a1.808,1.808,0,0,1-1.059,1.166.582.582,0,0,1-.655-.093,1.894,1.894,0,0,0-.225-.175.358.358,0,0,0-.04.254q0,4.174,0,8.349a1.067,1.067,0,0,1-.546,1,1.1,1.1,0,0,1-.556.141c-1.231.008-2.463.013-3.695,0a1,1,0,0,1-1.029-1.061q0-2.936,0-5.872c0-.073,0-.147,0-.219a.143.143,0,0,0-.152-.15c-.053,0-.107,0-.159,0h-3.835c-.288,0-.291,0-.291.288q0,2.886,0,5.772a1.217,1.217,0,0,1-.331.932,1.089,1.089,0,0,1-.777.315c-1.165.009-2.33.015-3.5,0a1.082,1.082,0,0,1-1.1-1.149c-.008-.786,0-1.571,0-2.357q0-3.056,0-6.111a.359.359,0,0,0-.04-.249c-.146.129-.294.249-.434.378a1.035,1.035,0,0,1-1.559-.025,1.6,1.6,0,0,0-.142-.14,1.117,1.117,0,0,1,.076-1.679c.423-.319.79-.712,1.183-1.07q1.112-1.016,2.222-2.035c.541-.494,1.078-.99,1.617-1.484l1.737-1.591c.535-.49,1.071-.978,1.6-1.471q.314-.293.634-.579a1.2,1.2,0,0,1,1.712,0q1.828,1.609,3.664,3.209,2.156,1.886,4.314,3.77c.321.279.639.563.962.841a1,1,0,0,1,.408.7Z"
        transform="translate(-417.295 -446.659)"
        fill="#020202"
      />
    </svg>
  );
};

export const BackIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10.683"
      height="18.989"
      viewBox="0 0 10.683 18.989"
    >
      <g
        id="Group_22991"
        data-name="Group 22991"
        transform="translate(288.769 207.474) rotate(180)"
      >
        <path
          id="Path_29942"
          data-name="Path 29942"
          d="M0,0,4.91,5.18l.982,1.036L7.855,8.287"
          transform="translate(279.5 189.898)"
          fill="#343434"
          stroke="#343434"
          stroke-linecap="round"
          stroke-width="2"
        />
        <path
          id="Path_29941"
          data-name="Path 29941"
          d="M7.783,0,4.864,2.98,0,7.946"
          transform="translate(279.5 198.113)"
          fill="#343434"
          stroke="#343434"
          stroke-linecap="round"
          stroke-width="2"
        />
      </g>
    </svg>
  );
};

export const RightIcon = (fillColor = "#4b5558") => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9.334"
      height="12.375"
      viewBox="0 0 9.334 12.375"
    >
      <path
        id="Polygon_122"
        data-name="Polygon 122"
        d="M6.188,0l6.188,9.334H0Z"
        transform="translate(9.334) rotate(90)"
        fill={fillColor}
      />
    </svg>
  );
};

export const LeftIcon = (fillColor = "#4b5558") => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9.334"
      height="12.375"
      viewBox="0 0 9.334 12.375"
    >
      <path
        id="Polygon_123"
        data-name="Polygon 123"
        d="M6.188,0l6.188,9.334H0Z"
        transform="translate(0 12.375) rotate(-90)"
        fill={fillColor}
      />
    </svg>
  );
};

export const UploadIcon = ({ background = "#fff", color = "#09659c" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
    >
      <defs>
        <filter
          id="Path_29676"
          x="0"
          y="0"
          width="36"
          height="36"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="1" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feFlood flood-opacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g
        id="Component_633_4"
        data-name="Component 633 – 4"
        transform="translate(9 8)"
      >
        <g id="Download">
          <g transform="matrix(1, 0, 0, 1, -9, -8)" filter="url(#Path_29676)">
            <path
              id="Path_29676-2"
              data-name="Path 29676"
              d="M3.342,0H23.4a3.342,3.342,0,0,1,3.342,3.342V23.4A3.342,3.342,0,0,1,23.4,26.739H3.342A3.342,3.342,0,0,1,0,23.4V3.342A3.342,3.342,0,0,1,3.342,0Z"
              transform="translate(9 8)"
              fill={background}
            />
          </g>
          <g
            id="Icon_feather-download"
            data-name="Icon feather-download"
            transform="translate(6.943 6.943)"
          >
            <path
              id="Path_12348"
              data-name="Path 12348"
              d="M17.353,22.5v2.658a1.381,1.381,0,0,1-1.428,1.329h-10A1.381,1.381,0,0,1,4.5,25.158V22.5"
              transform="translate(-4.5 -13.634)"
              fill="none"
              stroke={color}
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
            />
            <path
              id="Path_12349"
              data-name="Path 12349"
              d="M10.5,15l3.768,3.323L18.036,15"
              transform="translate(20.694 18.323) rotate(180)"
              fill="none"
              stroke={color}
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
            />
            <path
              id="Path_12350"
              data-name="Path 12350"
              d="M18,12.475V4.5"
              transform="translate(24.427 12.954) rotate(180)"
              fill="#0070d2"
              stroke={color}
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const DownloadIcon = ({
  background = "#fff",
  color = "#09659c",
  width = "36",
  height = "36",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 36 36"
    >
      <defs>
        <filter
          id="Path_29676"
          x="0"
          y="0"
          width="36"
          height="36"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="1" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feFlood flood-opacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g
        id="Component_632_87"
        data-name="Component 632 – 87"
        transform="translate(9 8)"
      >
        <g
          id="Group_22510"
          data-name="Group 22510"
          transform="translate(-1181 -294.13)"
        >
          <g
            transform="matrix(1, 0, 0, 1, 1172, 286.13)"
            filter="url(#Path_29676)"
          >
            <path
              id="Path_29676-2"
              data-name="Path 29676"
              d="M3.342,0H23.4a3.342,3.342,0,0,1,3.342,3.342V23.4A3.342,3.342,0,0,1,23.4,26.739H3.342A3.342,3.342,0,0,1,0,23.4V3.342A3.342,3.342,0,0,1,3.342,0Z"
              transform="translate(9 8)"
              fill={background}
            />
          </g>
          <g
            id="Icon_feather-download"
            data-name="Icon feather-download"
            transform="translate(1187.943 301.074)"
          >
            <path
              id="Path_12348"
              data-name="Path 12348"
              d="M17.353,22.5v2.658a1.381,1.381,0,0,1-1.428,1.329h-10A1.381,1.381,0,0,1,4.5,25.158V22.5"
              transform="translate(-4.5 -13.634)"
              fill="none"
              stroke={color}
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
            />
            <path
              id="Path_12349"
              data-name="Path 12349"
              d="M10.5,15l3.768,3.323L18.036,15"
              transform="translate(-7.842 -9.868)"
              fill="none"
              stroke={color}
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
            />
            <path
              id="Path_12350"
              data-name="Path 12350"
              d="M18,12.475V4.5"
              transform="translate(-11.574 -4.5)"
              fill="#0070d2"
              stroke={color}
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const DepartmentHierarchyIcon = () => {
  return (
    <svg
      width="25px"
      height="25px"
      viewBox="0 0 32 32"
      data-name="Layer 1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <style></style>
      </defs>
      <title />
      <path
        fill="#085F93"
        class="cls-1"
        d="M28,22H27V19a2,2,0,0,0-2-2H17V14h3a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2h3v3H7a2,2,0,0,0-2,2v3H4a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2H8a2,2,0,0,0,2-2V24a2,2,0,0,0-2-2H7V19h8v3H14a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V24a2,2,0,0,0-2-2H17V19h8v3H24a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V24A2,2,0,0,0,28,22ZM12,4h8v8H12ZM8,28H4V24H8Zm10,0H14V24h4Zm10,0H24V24h4Z"
      />
    </svg>
  );
};

export const MembersHierarchyIcon = ({ fill = "#085F93", width = "25px" }) => {
  return (
    <svg
      fill={fill}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height="25px"
      viewBox="0 0 256 227"
      enable-background="new 0 0 256 227"
    >
      <path
        d="M127.967,143.833c8.442,0,15.285,6.844,15.285,15.285s-6.844,15.285-15.285,15.285s-15.285-6.844-15.285-15.285
	S119.525,143.833,127.967,143.833z M103.145,224.833v-23.712c0-1.176,0.719-1.894,1.894-1.894c1.176,0,1.894,0.719,1.894,1.894
	v23.712h42.068v-23.712c0-1.176,0.719-1.894,1.894-1.894s1.894,0.719,1.894,1.894v23.712h13.391v-27.566
	c0-10.517-8.623-19.074-19.074-19.074h-38.214c-10.517,0-19.074,8.623-19.074,19.074v27.566H103.145z M127.967,2.167
	c8.442,0,15.285,6.844,15.285,15.285s-6.844,15.285-15.285,15.285s-15.285-6.844-15.285-15.285S119.525,2.167,127.967,2.167z
	 M103.145,83.167V59.455c0-1.176,0.719-1.894,1.894-1.894c1.176,0,1.894,0.719,1.894,1.894v23.712h42.068V59.455
	c0-1.176,0.719-1.894,1.894-1.894s1.894,0.719,1.894,1.894v23.712h13.391V55.601c0-10.517-8.623-19.074-19.074-19.074h-38.214
	c-10.517,0-19.074,8.623-19.074,19.074v27.566H103.145z M215.786,143.833c8.442,0,15.285,6.844,15.285,15.285
	s-6.844,15.285-15.285,15.285s-15.285-6.844-15.285-15.285S207.344,143.833,215.786,143.833z M190.964,224.833v-23.712
	c0-1.176,0.719-1.894,1.894-1.894c1.176,0,1.894,0.719,1.894,1.894v23.712h42.068v-23.712c0-1.176,0.719-1.894,1.894-1.894
	c1.176,0,1.894,0.719,1.894,1.894v23.712H254v-27.566c0-10.517-8.623-19.074-19.074-19.074h-38.214
	c-10.517,0-19.074,8.623-19.074,19.074v27.566H190.964z M40.148,143.833c8.442,0,15.285,6.844,15.285,15.285
	s-6.844,15.285-15.285,15.285s-15.285-6.844-15.285-15.285S31.706,143.833,40.148,143.833z M15.326,224.833v-23.712
	c0-1.176,0.719-1.894,1.894-1.894s1.894,0.719,1.894,1.894v23.712h42.068v-23.712c0-1.176,0.719-1.894,1.894-1.894
	c1.176,0,1.894,0.719,1.894,1.894v23.712h13.391v-27.566c0-10.517-8.623-19.074-19.074-19.074H21.074
	C10.557,178.193,2,186.816,2,197.267v27.566H15.326z M132,109.434v-16.25h-8v16.25H36.181v24.25h8v-16.25H124v16.25h8v-16.25h79.819
	v16.25h8v-24.25H132z"
      />
    </svg>
  );
};

export const DelegationsIcon = ({ fill = "#085F93", width = "25px" }) => {
  return (
    <svg
      fill={fill}
      class="MuiSvgIcon-root delegationsIcon"
      focusable="false"
      aria-hidden="true"
      width={width}
      height="25px"
    >
      <path d="M8 10H5V7H3v3H0v2h3v3h2v-3h3v-2zm10 1c1.66 0 2.99-1.34 2.99-3S19.66 5 18 5c-.32 0-.63.05-.91.14.57.81.9 1.79.9 2.86s-.34 2.04-.9 2.86c.28.09.59.14.91.14zm-5 0c1.66 0 2.99-1.34 2.99-3S14.66 5 13 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm6.62 2.16c.83.73 1.38 1.66 1.38 2.84v2h3v-2c0-1.54-2.37-2.49-4.38-2.84zM13 13c-2 0-6 1-6 3v2h12v-2c0-2-4-3-6-3z"></path>
    </svg>
  );
};

export const AcceptIcon = (fillColor = "#FEFEFE") => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.5344 0H5.5811C5.23668 0.052199 4.81676 0.559275 4.81676 0.559275L0.184562 5.55546C0.178503 5.56385 0.170579 5.57271 0.160326 5.58156L0.0904162 5.65707C0.0316924 5.73397 0.00838912 5.81087 0 5.87099V24.0073C0 24.2502 0.197145 24.4473 0.439963 24.4473H18.5344C18.7772 24.4473 18.9743 24.2502 18.9743 24.0073V0.439962C18.9743 0.197143 18.7772 0 18.5344 0Z"
        fill="black"
      />
      <path
        d="M5.40036 1.59145V4.91867C5.40036 5.29338 5.09836 5.59679 4.72551 5.59679H1.39596C1.21186 5.59679 1.06226 5.74686 1.06226 5.93189V23.1976C1.06226 23.3827 1.2114 23.5327 1.39596 23.5327H17.7156C17.8997 23.5327 18.0493 23.3827 18.0493 23.1976V1.59145C18.0493 1.40642 17.9002 1.25635 17.7156 1.25635H5.73407C5.54997 1.25635 5.40036 1.40642 5.40036 1.59145Z"
        fill={fillColor}
      />
      <path
        d="M4.60675 1.72461C3.5693 2.76206 2.54023 3.79113 1.50464 4.82719C1.89473 4.82719 2.28995 4.82719 2.68471 4.82719C3.27474 4.82719 3.86478 4.82486 4.45481 4.82905C4.56061 4.82998 4.61048 4.81787 4.60955 4.6897C4.60395 3.70211 4.60628 2.71453 4.60628 1.72461H4.60675Z"
        fill={fillColor}
      />
      <path
        d="M21.0776 21.6467C21.0757 23.6759 19.4394 25.3179 17.4185 25.3179C15.3842 25.3179 13.7474 23.6703 13.7529 21.6281C13.7585 19.6165 15.4168 17.9867 17.4502 17.9942C19.438 18.0016 21.0799 19.6543 21.078 21.6467H21.0776Z"
        fill="#FCFCFC"
        stroke="#00C951"
        stroke-miterlimit="10"
      />
      <path
        d="M16.6439 23.6805C16.5073 23.6824 16.402 23.619 16.3083 23.5258C15.7933 23.0099 15.2755 22.4963 14.7629 21.978C14.5606 21.7739 14.5494 21.5469 14.7181 21.3707C14.8929 21.1885 15.1292 21.1987 15.344 21.4099C15.7248 21.7846 16.1056 22.1593 16.4747 22.5447C16.5959 22.671 16.6635 22.6762 16.7898 22.5475C17.5569 21.7678 18.3338 20.9983 19.1056 20.2237C19.2301 20.0988 19.3592 19.9935 19.5489 20.0289C19.828 20.0811 19.9679 20.3962 19.8206 20.6404C19.7861 20.6973 19.7362 20.7462 19.6887 20.7942C18.7901 21.6942 17.8906 22.5932 16.992 23.4927C16.8942 23.5906 16.7912 23.6749 16.6439 23.6801V23.6805Z"
        fill="#00C951"
      />
      <path
        d="M10.8911 8.16314C9.65464 8.16314 8.41818 8.16314 7.18172 8.16314C7.1132 8.16314 7.04376 8.16733 6.97572 8.16034C6.74921 8.13704 6.59121 7.96879 6.58888 7.75393C6.58702 7.53908 6.74362 7.36617 6.96826 7.34147C7.0363 7.33401 7.10528 7.33821 7.17426 7.33821C9.67282 7.33821 12.1714 7.33821 14.6699 7.33821C14.7385 7.33821 14.8079 7.33354 14.8759 7.34193C15.0987 7.3685 15.2609 7.54607 15.2483 7.75999C15.2353 7.98743 15.1048 8.12072 14.8829 8.15894C14.8079 8.17199 14.7287 8.1636 14.6513 8.1636C13.3976 8.1636 12.1443 8.1636 10.8906 8.1636L10.8911 8.16314Z"
        fill="black"
      />
      <path
        d="M10.9202 11.877C9.66645 11.877 8.41321 11.877 7.1595 11.877C7.08214 11.877 7.00197 11.8854 6.92834 11.8682C6.72234 11.8197 6.59417 11.6873 6.5923 11.4711C6.59044 11.2427 6.72047 11.1048 6.94092 11.0591C7.01549 11.0437 7.09472 11.0521 7.17209 11.0521C9.67065 11.0521 12.1692 11.0521 14.6678 11.0521C14.7363 11.0521 14.8057 11.0474 14.8738 11.0554C15.0975 11.081 15.2601 11.2567 15.2494 11.4706C15.2378 11.6981 15.1082 11.8323 14.8868 11.8719C14.8118 11.8854 14.7326 11.877 14.6557 11.877C13.4108 11.877 12.1655 11.877 10.9206 11.877H10.9202Z"
        fill="black"
      />
      <path
        d="M10.9202 15.5899C9.66645 15.5899 8.41321 15.5899 7.1595 15.5899C7.08214 15.5899 7.00197 15.5983 6.92834 15.5811C6.72234 15.5326 6.59417 15.4002 6.5923 15.184C6.59044 14.9556 6.72047 14.8176 6.94045 14.772C7.01502 14.7566 7.09425 14.765 7.17162 14.765C9.67018 14.765 12.1687 14.765 14.6673 14.765C14.7358 14.765 14.8053 14.7603 14.8733 14.7682C15.097 14.7939 15.2597 14.9696 15.249 15.1835C15.2373 15.4109 15.1077 15.5452 14.8864 15.5848C14.8113 15.5983 14.7321 15.5899 14.6552 15.5899C13.4103 15.5899 12.165 15.5899 10.9202 15.5899Z"
        fill="black"
      />
      <path
        d="M4.52122 6.51313C4.77848 6.51313 5.03575 6.50987 5.29301 6.51406C5.59875 6.51919 5.75768 6.66973 5.76094 6.96894C5.76607 7.49186 5.76653 8.01525 5.76094 8.53864C5.75768 8.82527 5.59922 8.98373 5.31305 8.98699C4.79013 8.99258 4.26674 8.99258 3.74336 8.98699C3.44414 8.98419 3.29081 8.82527 3.28848 8.51953C3.28428 8.005 3.28382 7.49046 3.28848 6.97546C3.29128 6.67206 3.44601 6.51966 3.74942 6.51406C4.00668 6.5094 4.26395 6.51313 4.52122 6.51313Z"
        fill="black"
      />
      <path
        d="M5.76262 11.4623C5.76262 11.7196 5.76635 11.9769 5.76168 12.2341C5.75656 12.5385 5.60416 12.6974 5.30448 12.7002C4.78156 12.7053 4.25817 12.7058 3.73478 12.7002C3.44908 12.6969 3.29155 12.5375 3.28876 12.2504C3.28363 11.7275 3.28363 11.2041 3.28876 10.6807C3.29155 10.3913 3.44675 10.2319 3.73198 10.2287C4.26376 10.2226 4.79554 10.2226 5.32732 10.2287C5.59856 10.2319 5.7533 10.3913 5.76075 10.6649C5.76774 10.9306 5.76215 11.1967 5.76262 11.4623Z"
        fill="black"
      />
      <path
        d="M5.76262 15.1774C5.76262 15.4431 5.76821 15.7092 5.76122 15.9749C5.75423 16.248 5.5995 16.4092 5.32871 16.4125C4.78855 16.4195 4.24791 16.42 3.70775 16.412C3.45188 16.4083 3.29342 16.2457 3.29016 15.9875C3.28316 15.4473 3.28316 14.9067 3.29016 14.3665C3.29342 14.1078 3.45188 13.9466 3.70821 13.9428C4.24838 13.9349 4.78901 13.9354 5.32918 13.9424C5.59996 13.9456 5.75376 14.1064 5.76122 14.38C5.76821 14.6457 5.76262 14.9118 5.76262 15.1774Z"
        fill="black"
      />
      <path
        d="M4.52021 20.1284C4.25455 20.1284 3.98843 20.134 3.72278 20.1265C3.45106 20.1191 3.29307 19.963 3.28981 19.6898C3.28328 19.1581 3.28328 18.6263 3.28981 18.0945C3.29307 17.8107 3.45386 17.6573 3.74515 17.6546C4.26807 17.6499 4.79146 17.6494 5.31485 17.6546C5.60101 17.6578 5.75854 17.8163 5.76134 18.1038C5.76693 18.6268 5.76693 19.1501 5.76134 19.6735C5.75807 19.9718 5.59821 20.1224 5.29201 20.1275C5.03474 20.1317 4.77748 20.1284 4.52021 20.1279V20.1284Z"
        fill="black"
      />
      <path
        d="M9.47467 18.4774C10.2642 18.4774 11.0537 18.4765 11.8432 18.4774C12.1718 18.4779 12.3573 18.6247 12.3619 18.882C12.3666 19.1406 12.1783 19.3014 11.8576 19.3014C10.2614 19.3028 8.66512 19.3014 7.06886 19.3028C6.87218 19.3028 6.71744 19.2441 6.62796 19.0567C6.55758 18.9095 6.58042 18.7715 6.67177 18.6448C6.77151 18.5063 6.91692 18.4746 7.08004 18.4751C7.87794 18.4784 8.6763 18.4765 9.4742 18.4765L9.47467 18.4774Z"
        fill="black"
      />
      <path
        d="M4.53561 7.33838C4.80381 7.33838 4.93791 7.47093 4.93791 7.73602C4.93791 8.02132 4.79682 8.16397 4.51463 8.16397C4.24674 8.16397 4.11279 8.03142 4.11279 7.76632C4.11279 7.48103 4.25389 7.33838 4.53607 7.33838H4.53561Z"
        fill="#FEFEFE"
      />
      <path
        d="M4.93789 11.4764C4.93789 11.7434 4.80472 11.8769 4.53838 11.8769C4.25433 11.8769 4.1123 11.7351 4.1123 11.4517C4.1123 11.1847 4.24532 11.0513 4.51135 11.0513C4.7954 11.0513 4.93743 11.193 4.93743 11.4764H4.93789Z"
        fill="#FEFEFE"
      />
      <path
        d="M4.93789 15.1604C4.93789 15.447 4.79742 15.5902 4.51647 15.5902C4.24734 15.5902 4.11262 15.4583 4.1123 15.1945C4.1123 14.9079 4.25278 14.7646 4.53372 14.7646C4.80286 14.7646 4.93743 14.8966 4.93743 15.1604H4.93789Z"
        fill="#FEFEFE"
      />
      <path
        d="M4.93793 18.893C4.93793 19.1668 4.79964 19.3037 4.52304 19.3037C4.24645 19.3037 4.10955 19.1654 4.11235 18.8888C4.11514 18.6122 4.25344 18.4753 4.52724 18.4781C4.80103 18.4809 4.93793 18.6192 4.93793 18.893Z"
        fill="#FEFEFE"
      />
    </svg>
  );
};

export const DownloadTemplateIcon = ({ color = "#0070d2" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="9 8 26.74 26.74"
      width="28"
      height="27"
    >
      <defs>
        <filter
          id="Path_29676"
          x="0"
          y="0"
          width="44.739"
          height="44.738"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="1" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feFlood flood-opacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g
        id="Group_24536"
        data-name="Group 24536"
        transform="translate(-8945.664 -20269.439)"
      >
        <g id="Download" transform="translate(8954.664 20277.439)">
          <g transform="matrix(1, 0, 0, 1, -9, -8)" filter="url(#Path_29676)">
            <path
              id="Path_29676-2"
              data-name="Path 29676"
              d="M3.342,0H23.4a3.342,3.342,0,0,1,3.342,3.342V23.4A3.342,3.342,0,0,1,23.4,26.739H3.342A3.342,3.342,0,0,1,0,23.4V3.342A3.342,3.342,0,0,1,3.342,0Z"
              transform="translate(9 8)"
              fill={color}
            />
          </g>
        </g>
        <g id="excel" transform="translate(8575.32 19934.873)">
          <path
            id="Path_32596"
            data-name="Path 32596"
            d="M401.708,350.181v11.512a.568.568,0,0,1-.651.474q-1.868,0-3.737,0H394.2a.266.266,0,0,0-.3.3c0,.415,0,.831,0,1.246a.635.635,0,0,1-.809.668q-3.673-.685-7.346-1.377c-.46-.086-.919-.175-1.38-.257a1.639,1.639,0,0,1-.239-.054.56.56,0,0,1-.4-.554c0-.035,0-.07,0-.105V349.828a.594.594,0,0,1,.564-.691q3.742-.7,7.484-1.4c.443-.083.885-.168,1.328-.248a.629.629,0,0,1,.8.655c.005.427,0,.854,0,1.281,0,.284,0,.284.281.284h6.7c.076,0,.152,0,.228,0a.552.552,0,0,1,.6.474Z"
            transform="translate(0 0)"
            fill="#fff"
          />
          <path
            id="Path_32597"
            data-name="Path 32597"
            d="M417.4,391.063l-2.832-.529c-1.595-.3-3.188-.6-4.785-.891-.193-.035-.244-.1-.244-.292q.011-5.5,0-11c0-.146.038-.194.18-.22q3.693-.683,7.383-1.377l.3-.054v14.363Z"
            transform="translate(-24.684 -27.944)"
            fill="#fefefe"
          />
          <path
            id="Path_32598"
            data-name="Path 32598"
            d="M620.627,430.029c0,1.626,0,3.252,0,4.878,0,.146-.034.179-.18.179q-3.193-.008-6.386,0c-.145,0-.187-.031-.18-.179.014-.274.008-.55,0-.824,0-.1.025-.127.125-.126.514,0,1.029.007,1.544,0a.561.561,0,1,0-.009-1.12c-.509,0-1.017,0-1.526,0-.109,0-.138-.026-.135-.135.008-.286.008-.573,0-.86,0-.109.027-.135.135-.135.514.006,1.029.008,1.544,0a.56.56,0,1,0-.01-1.119c-.509,0-1.018,0-1.526,0-.116,0-.146-.031-.143-.144.008-.286.007-.573,0-.86,0-.1.029-.125.127-.124.5,0,.994,0,1.491,0a.564.564,0,1,0,.006-1.122c-.5,0-.994,0-1.492,0-.112,0-.136-.031-.133-.136.007-.286.009-.573,0-.86,0-.113.032-.134.137-.133q.772.008,1.544,0a.539.539,0,0,0,.523-.345.53.53,0,0,0-.112-.6.567.567,0,0,0-.441-.176c-.5,0-1.006,0-1.509,0-.119,0-.144-.036-.141-.146.007-.281.006-.561,0-.842,0-.1.008-.142.128-.141q3.246.007,6.491,0c.151,0,.121.081.121.164v4.9Z"
            transform="translate(-220.042 -74.091)"
            fill={color}
          />
          <path
            id="Path_32599"
            data-name="Path 32599"
            d="M453.01,463.914a.657.657,0,0,1-.16.419c-.55.7-1.095,1.413-1.649,2.115-.084.107-.091.166,0,.272q.828.929,1.641,1.873a.558.558,0,0,1-.269.941.574.574,0,0,1-.6-.231c-.484-.555-.974-1.105-1.451-1.666-.109-.128-.156-.122-.255.008-.419.554-.85,1.1-1.277,1.649a.548.548,0,0,1-.578.24.54.54,0,0,1-.442-.421.585.585,0,0,1,.142-.52c.478-.612.952-1.228,1.433-1.838.077-.1.075-.149-.008-.243q-.718-.8-1.421-1.622a.559.559,0,0,1,.277-.939.571.571,0,0,1,.588.224c.415.476.835.947,1.244,1.427.1.112.138.1.222-.007.5-.658,1.016-1.311,1.525-1.966a.559.559,0,0,1,.58-.242.544.544,0,0,1,.439.427.834.834,0,0,1,.015.1Z"
            transform="translate(-61.411 -110.806)"
            fill={color}
          />
          <path
            id="Path_32600"
            data-name="Path 32600"
            d="M691.768,450.587c.187,0,.374,0,.562,0a.56.56,0,1,1,0,1.119c-.374.007-.748.008-1.123,0a.559.559,0,0,1,0-1.119c.187-.006.374,0,.562,0Z"
            transform="translate(-293.433 -98.58)"
            fill="#fff"
          />
          <path
            id="Path_32601"
            data-name="Path 32601"
            d="M691.764,501.668c.187,0,.374,0,.562,0a.56.56,0,0,1,0,1.119c-.38.008-.76.008-1.14,0a.559.559,0,0,1,0-1.117c.193-.007.386,0,.579,0Z"
            transform="translate(-293.422 -147.415)"
            fill="#fff"
          />
          <path
            id="Path_32602"
            data-name="Path 32602"
            d="M691.75,553.837c-.181,0-.363,0-.544,0a.56.56,0,1,1,0-1.12q.561-.009,1.123,0a.56.56,0,0,1,0,1.119c-.193.007-.386,0-.579,0Z"
            transform="translate(-293.422 -196.216)"
            fill="#fff"
          />
          <path
            id="Path_32603"
            data-name="Path 32603"
            d="M691.739,604.917c-.181,0-.363,0-.544,0a.56.56,0,1,1,0-1.12q.561-.009,1.122,0a.56.56,0,0,1,0,1.119c-.193.007-.386,0-.579,0Z"
            transform="translate(-293.413 -245.05)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
};

export const GraphIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13.367"
      height="13.367"
      viewBox="0 0 13.367 13.367"
    >
      <path
        id="lightning_usage"
        d="M190,201.253a1.1,1.1,0,0,0,1.114,1.114h11.808a.447.447,0,0,0,.446-.446v-.468a.447.447,0,0,0-.446-.446H191.76a.438.438,0,0,1-.423-.423V189.446a.447.447,0,0,0-.446-.446h-.446a.447.447,0,0,0-.446.446Zm3.431-3.565a.662.662,0,0,1-.468-1.136l3.565-3.542a.646.646,0,0,1,.936,0l1.715,1.715,3.008-3.052a.662.662,0,0,1,.936.936l-3.453,3.5a.641.641,0,0,1-.468.2.607.607,0,0,1-.468-.2L197,194.391l-3.074,3.1A.691.691,0,0,1,193.431,197.689Z"
        transform="translate(-190 -189)"
        fill="#01539a"
      />
    </svg>
  );
};

export const DownloadFilteredIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
    >
      <defs>
        <filter
          id="Path_29676"
          x="0"
          y="0"
          width="44.739"
          height="44.738"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="1" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feFlood flood-opacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g
        id="Group_24548"
        data-name="Group 24548"
        transform="translate(-8866.982 -20317.439)"
      >
        <g
          id="Group_24547"
          data-name="Group 24547"
          transform="translate(-78.682 48)"
        >
          <g id="Download" transform="translate(8954.664 20277.439)">
            <g transform="matrix(1, 0, 0, 1, -9, -8)" filter="url(#Path_29676)">
              <path
                id="Path_29676-2"
                data-name="Path 29676"
                d="M3.342,0H23.4a3.342,3.342,0,0,1,3.342,3.342V23.4A3.342,3.342,0,0,1,23.4,26.739H3.342A3.342,3.342,0,0,1,0,23.4V3.342A3.342,3.342,0,0,1,3.342,0Z"
                transform="translate(9 8)"
                fill="#0070d2"
              />
            </g>
          </g>
        </g>
        <g id="filter" transform="translate(8553.418 20027.936)">
          <g
            id="Group_24543"
            data-name="Group 24543"
            transform="translate(327.409 300.89)"
          >
            <path
              id="Path_32617"
              data-name="Path 32617"
              d="M337.265,300.89a2.3,2.3,0,0,1,.306.28q2.149,2.256,4.3,4.508a.807.807,0,0,1,.242.6q-.008,5.29,0,10.579a2.452,2.452,0,0,1-1.926,2.492,2.479,2.479,0,0,1-.574.059q-4.855,0-9.71,0a2.44,2.44,0,0,1-2.491-2.5q0-6.766,0-13.532a2.437,2.437,0,0,1,1.865-2.446c.023-.007.047-.008.056-.036h7.935Z"
              transform="translate(-327.409 -300.89)"
              fill="#fff"
            />
            <path
              id="Path_32618"
              data-name="Path 32618"
              d="M352.164,332.92q0-3.361,0-6.721a1.55,1.55,0,0,1,1.149-1.584,1.69,1.69,0,0,1,.484-.052q3.261,0,6.522,0c.158,0,.184.048.183.192-.007.851-.005,1.7,0,2.554a1.954,1.954,0,0,0,2.047,2.047c.791,0,1.582,0,2.373,0,.114,0,.152.023.152.146q-.005,5.118-.005,10.235a1.544,1.544,0,0,1-1.633,1.583q-2.917,0-5.833,0h-3.768a1.555,1.555,0,0,1-1.667-1.675v-6.721Z"
              transform="translate(-351.264 -323.7)"
              fill="#0070d2"
            />
            <path
              id="Path_32619"
              data-name="Path 32619"
              d="M609.181,347.624h-.669c-.464,0-.929.008-1.392-.01a1.013,1.013,0,0,1-.981-.953c-.04-.722-.013-1.446-.012-2.169,0-.009.012-.017.03-.042l3.023,3.174Z"
              transform="translate(-595.996 -342.868)"
              fill="#0070d2"
            />
            <path
              id="Path_32620"
              data-name="Path 32620"
              d="M448.88,475.219c.624-.668,1.214-1.3,1.8-1.931a.5.5,0,0,1,.408-.193.4.4,0,0,1,.37.248.442.442,0,0,1-.078.5q-.522.565-1.048,1.127l-1.481,1.59c-.3.319-.53.324-.823.009q-1.254-1.344-2.5-2.69a.458.458,0,0,1-.119-.512.413.413,0,0,1,.371-.276.532.532,0,0,1,.437.213q.831.9,1.664,1.79l.084.088a.361.361,0,0,0,.024-.2q0-2.264,0-4.527a.618.618,0,0,1,.082-.381.438.438,0,0,1,.487-.186.451.451,0,0,1,.324.411c0,.09,0,.181,0,.272v4.64Z"
              transform="translate(-441.085 -463.741)"
              fill="#fff"
            />
            <path
              id="Path_32621"
              data-name="Path 32621"
              d="M420.1,700.872c1.2,0,2.4,0,3.6,0a.521.521,0,0,1,.4.137.409.409,0,0,1,.121.414.437.437,0,0,1-.329.326,1.018,1.018,0,0,1-.233.021H416.53a.683.683,0,0,1-.3-.045.456.456,0,0,1-.255-.509.465.465,0,0,1,.473-.344q1.828,0,3.656,0Z"
              transform="translate(-412.747 -686.343)"
              fill="#fff"
            />
          </g>
          <g
            id="Group_24546"
            data-name="Group 24546"
            transform="translate(339.994 313.857)"
          >
            <g
              id="Group_24544"
              data-name="Group 24544"
              transform="translate(0 0)"
            >
              <path
                id="Path_32622"
                data-name="Path 32622"
                d="M673.91,661.441a3.47,3.47,0,1,1,3.466,3.5,3.485,3.485,0,0,1-3.466-3.5Z"
                transform="translate(-673.91 -657.94)"
                fill="#fff"
              />
              <path
                id="Path_32623"
                data-name="Path 32623"
                d="M692.72,679.832a2.916,2.916,0,1,1,2.893-2.911A2.91,2.91,0,0,1,692.72,679.832Z"
                transform="translate(-689.252 -673.417)"
                fill="#0070d2"
              />
            </g>
            <g
              id="Group_24545"
              data-name="Group 24545"
              transform="translate(1.463 1.903)"
            >
              <path
                id="Path_32624"
                data-name="Path 32624"
                d="M716.268,710.35h1.669a.388.388,0,0,1,.4.347.381.381,0,0,1-.107.318l-.79.869c-.145.159-.289.319-.435.478a.117.117,0,0,0-.034.086c0,.336,0,.672,0,1.009a.4.4,0,0,1-.191.358l-.6.4a.394.394,0,0,1-.621-.337c0-.469,0-.937,0-1.405a.171.171,0,0,0-.049-.125q-.606-.664-1.209-1.329a.391.391,0,0,1,.054-.595.4.4,0,0,1,.239-.072h1.67Z"
                transform="translate(-714.194 -710.35)"
                fill="#fff"
              />
              <path
                id="Path_32625"
                data-name="Path 32625"
                d="M729.92,723.34h3c0,.018-.019.028-.031.041q-.552.609-1.106,1.217a.451.451,0,0,0-.125.323c0,.33,0,.659,0,.989a.074.074,0,0,1-.038.07c-.131.085-.261.172-.391.259l-.042.027v-.059c0-.431,0-.861,0-1.293a.443.443,0,0,0-.123-.314q-.555-.607-1.107-1.217l-.038-.044Z"
                transform="translate(-729.349 -722.868)"
                fill="#0070d2"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
